import { meshCoverageRuntime } from './core/mesh-coverage-runtime';
import { fetchMeshCoverage, renderMeshCoverageCard, attachMeshCoverageDetails } from './modules/mesh-coverage-card';
import { renderLayerPointCard } from './modules/layer-point-card';
import { LAYER_POINT_TYPES, layerPointQuerySources } from './core/layer-point-sources';
import { PZGIK_NOTICE } from './layers/attribution';
import { createBasemapMap } from '../shared/basemap-style';
import OwnershipLayer from './layers/OwnershipLayer';
import { ownershipLayerRuntime } from './core/ownership-layer-runtime';
import LandUseLayer from './layers/LandUseLayer';
import { landUseLayerRuntime } from './core/land-use-layer-runtime';
import TransactionsLayer, { TRANSACTION_COLOR } from './layers/TransactionsLayer';
import SignalsLayer from './layers/SignalsLayer';
import ListingsLayer from './layers/ListingsLayer';
import DzialkiLayer from './layers/DzialkiLayer';
import DzialkiVectorTileLayer from './layers/DzialkiVectorTileLayer';
import BudynkiLayer from './layers/BudynkiLayer';
import GunbLayer from './layers/GunbLayer';
import OtoczenieLayer from './layers/OtoczenieLayer';
import SelectionPinLayer from './layers/SelectionPinLayer';
import PogLayer from './layers/PogLayer';
import MpzpImportedLayer from './layers/MpzpImportedLayer';
import { noiseLayerRuntime } from './core/noise-layer-runtime';
import { contourHtml } from './layers/NoiseContourLayer';
import { measurementHtml } from './layers/NoiseMonitoringLayer';
import EducationFacilitiesLayer, { educationFacilityHtml } from './layers/EducationFacilitiesLayer';
import { educationLayerRuntime } from './core/education-layer-runtime';
import {
    API_REFRESH_STAGGER_MS,
    BASE_URL,
    BBOX_DECIMALS,
    BDOT10K_IMPACT_CLASSIFICATION_PARAM,
    BDOT10K_LAYER_LABELS,
    BDOT10K_NUISANCE_LEVEL_PARAM,
    BDOT10K_USEFULNESS_LEVEL_PARAM,
    DEFAULT_GUNB_ROK_WPLYWU_OD,
    DZIALKI_SEARCH_URL,
    EGIB_BUDYNKI_SEARCH_URL,
    EGIB_DZIALKI_SEARCH_URL,
    DEFAULT_LAT,
    DEFAULT_LNG,
    DEFAULT_SORT,
    DEFAULT_TRANSACTION_ROK_OD,
    DEFAULT_ZOOM,
    GUNB_EMPTY_FILTER_URL_VALUE,
    GUNB_ROK_WPLYWU_OD_PARAM,
    INDIVIDUAL_ZOOM_THRESHOLD,
    LIMITED_MODE,
    LIST_PER_PAGE,
    MAP_MAX_ZOOM,
    MIEJSCOWOSCI_URL,
    MAP_REFRESH_DEBOUNCE_MS,
    OPENFREEMAP_STYLE,
    OVERLAY_LAYERS_MIN_ZOOM,
    PARCEL_RENDER_MODE,
    PERF_DEBUG,
    TRANSACTION_ROK_OD_PARAM,
    VALID_ASSETS,
    VALID_SORTS,
    VALID_TABS,
    YEAR_FILTER_EMPTY_URL_VALUE,
} from './core/constants';
import {
    appEl,
    applyFiltersBtn,
    addressInput,
    addressRadiusKmInput,
    addressSuggestEl,
    assetEls,
    assetSwitchEl,
    backToDetailsBtn,
    bdot10kImpactClassificationInput,
    bdot10kNuisanceLevelInput,
    bdot10kUsefulnessLevelInput,
    buildingFloorsAboveInput,
    buildingFloorsBelowInput,
    buildingIdInput,
    buildingLocationQueryInput,
    buildingLocationSuggestEl,
    buildingMapBoundsStatusEl,
    buildingResultsEl,
    buildingUseMapBoundsBtn,
    detailsContentEl,
    detailsMetaEl,
    dzialkaIdHintEl,
    dzialkaIdInput,
    filterScopeEls,
    filterScopeSectionEls,
    floatingClearBtn,
    floatingPillbarEl,
    geolocateBtn,
    shareBtn,
    gunbRokWplywuOdInput,
    html,
    limitedBannerEl,
    listingActiveFiltersEl,
    transactionActiveFiltersEl,
    listingBrowseLinkEl,
    listingCategoryEls,
    listingCategoryInput,
    listingCategoryMoreSelect,
    listingCategorySwitchEl,
    listContentEl,
    listLoadingBarEl,
    listMetaEl,
    listMoreBtn,
    listMoreErrorEl,
    listTabCountEl,
    listTitleEl,
    mapLoadingEl,
    nearbyContentEl,
    nearbyMetaEl,
    openFavoritesBtn,
    favListEl,
    favListBodyEl,
    favListBackdropEl,
    openNearbyBtn,
    detailCtaEl,
    panelEls,
    panelFooterEls,
    panelScrollEls,
    panelToggleBtn,
    parcelAreaInput,
    parcelAreaToleranceInput,
    parcelIdInput,
    parcelLocationQueryInput,
    parcelLocationSuggestEl,
    parcelNeighbourAreasInput,
    parcelNeighbourAreasEditor,
    parcelNeighbourAreasValuesEl,
    parcelNeighbourNumbersInput,
    parcelNeighbourNumbersEditor,
    parcelNeighbourNumbersValuesEl,
    parcelNeighbourRadiusInput,
    parcelNumberInput,
    parcelMapBoundsStatusEl,
    parcelResultsEl,
    parcelUseMapBoundsBtn,
    personaBtn,
    resetFiltersBtn,
    rodzajInput,
    listingAreaMaxInput,
    listingAreaMinInput,
    listingAdvertiserTypeInput,
    listingConditionInput,
    listingCreatedDaysInput,
    listingEnergyClassInput,
    listingFeaturesInput,
    listingHasPhotosInput,
    listingHeatingTypeInput,
    listingLocationQueryInput,
    listingLocationSuggestEl,
    listingMarketTypeInput,
    listingOfferTypeInput,
    listingOwnershipTypeInput,
    listingParkingInput,
    listingPetPolicyInput,
    listingPlotZoningInput,
    listingPriceMaxInput,
    listingPriceMinInput,
    listingRadiusKmInput,
    listingRentalTermInput,
    listingRoadAccessInput,
    listingMpzpInput,
    listingRoomsInput,
    rokDoInput,
    rokOdInput,
    rynekInput,
    selectionBannerEl,
    selectionBannerTextEl,
    selectionClearBtn,
    selectionShowBtn,
    sheetEl,
    sheetHandleEl,
    sortEls,
    sortRowEl,
    listingSortRowEl,
    listingSortEls,
    listSubTabsEl,
    tabEls,
    terytHintEl,
    terytInput,
    terytSuggestEl,
    topbarEl,
    wojInput,
    setDetailsMeta,
    setDetailsKicker,
    setDetailsDepartment,
    setDepartment,
    setPageHeading,
} from './dom/elements';
import { midpoint, bboxString, centroidOfGeometry } from './utils/coords';
import {
    DEVELOPER_OFFER_MEDIAN_HELP,
    bdot10kImpactBalanceLabel,
    bdot10kImpactClassificationLabel,
    bdot10kImpactSummary,
    renderBdot10kFunctions,
    bdot10kTranslate,
    bdot10kLabel,
    countLabel,
    dateDisp,
    dateLong,
    esc,
    fmt,
    formatAggCount,
    formatDist,
    funkcjaLabel,
    nierLabel,
    parseAddr,
    renderFunkcjaChip,
    renderInfoHelpButton,
    rodzLabel,
    safeHref,
    typLabel,
} from './utils/formatters';
import { MarkerGroup, createHtmlMarker } from './utils/markers';
import { setListContent, renderKeyedStack } from './utils/dom-list';
import { buildListingBrowseUrl } from './utils/listing-browse-url';
import { addOrUpdateGeoJsonSource, removeSourceAndLayers, setVisibility, ensureLayerOrder, registerCursorHandlers } from './utils/maplibre-helpers';
import { perfEnd, perfStart } from './utils/performance';
import {
    buildBuildingDetailUrl,
    buildDetailUrl,
    buildGunbDetailUrl,
    buildParcelDetailUrl,
    geoportalMapviewUrl,
    geoportalParcelUrl,
    googleMapsUrl,
    qstr,
    rcnMapviewUrl,
    rcnParcelUrl,
    renderExternalLinks,
    renderSourceLinks,
} from './utils/url';
import { iconMarkup } from './utils/icons';
import {
    fetchTerytPowiaty,
    parseTerytFilterValue,
    setupTerytAutocomplete,
    syncTerytHintFromInput,
} from './modules/teryt-autocomplete';
import {
    applyFilterInputs as applyFilterInputsState,
    createDefaultFilterState as createDefaultFilterStateState,
    getApiFilters as getApiFiltersState,
    getBdot10kFilterParams as getBdot10kFilterParamsState,
    getBdot10kFilterQueryString as getBdot10kFilterQueryStringState,
    getGunbFilterParams as getGunbFilterParamsState,
    getGunbFilterQueryString as getGunbFilterQueryStringState,
    getSharedFilters as getSharedFiltersState,
    isListingAreaReference,
    normalizeGunbRokWplywuOd as normalizeGunbRokWplywuOdState,
    normalizeTransactionRokOd as normalizeTransactionRokOdState,
    readFilterInputs as readFilterInputsState,
    restoreListingAreaBbox,
    restoreStateFromUrl as restoreStateFromUrlState,
    sortDir as sortDirState,
    sortField as sortFieldState,
    syncUrl as syncUrlState,
} from './modules/filter-url-state';
import { createLayerControllers } from './core/layer-bootstrap';
import { EGIB_SEARCH_LOADING_TEXT, renderEgibSearchResultsHtml } from './modules/egib-search-results';
import KowrLayer from './layers/KowrLayer';
import { createDetailRenderers } from './modules/detail-renderers';
import { createParcelMeasurements } from './modules/parcel-measurements';
import { createLayerPanel } from './modules/layer-panel';
import { createListDataManager, renderListMoreControls } from './modules/list-data-manager';
import { areaFilterChipHtml } from './utils/area-filter-chip';
import { createListPanelRenderers } from './modules/list-panel-renderers';
import { createGunbManager } from './modules/gunb-manager';
import { createNearbyManager } from './modules/nearby';
import { createOtoczenieModule } from './modules/otoczenie';
import { createPanelLayout } from './modules/panel-layout';
import { createPersonaModule } from './modules/persona';
import { createOverlapManager } from './modules/overlap';
import { createSelectionManager } from './modules/selection-manager';
import { createSelectedFeatureManager } from './modules/selected-feature-manager';
import { createSignalsPanel } from './modules/signals-panel';
import { createSignalsSubmitController } from './modules/signals-submit';
import { createSubmissionFooter } from './modules/submission-footer';
import { initSignalsDisclaimer } from './modules/signals-disclaimer';
import { createSignalReportModule } from './modules/signal-report';
import { createFavoritesModule, mountFavoritesList } from './modules/favorites';
import { initMapShare } from './modules/map-share';
import { createTapBrowseManager } from './modules/tap-browse';
import {
    CLICK_MARKER_LAYER_IDS,
    createInteractiveHitDispatcher,
    noiseGeometryHitsAtLngLat,
    normalizeNoiseHit,
} from './modules/interactive-hit-dispatcher';
import { createTransactionDetailManager } from './modules/transaction-detail-manager';
import { createTapResolutionManager } from './modules/tap-resolution';
import { createPointQuerySession } from './modules/point-query-session';
import { POINT_SOURCE_LABELS, objectHits, pointQueryObjectCount, releasePointQueryPanel, renderPointQueryPanel } from './modules/point-query-panel';
import { initSearchModule, pickSearchItem } from './modules/search';
import { initAuthModal } from './modules/auth-modal';
import { initWhatsNew, hasPendingNews } from './modules/whats-new';
import { initStartDialog } from './modules/start-dialog';
import { initGuidedResume } from './modules/guided-resume';

(function() {
    'use strict';
    var initialUiParams = new URLSearchParams(window.location.search || '');
    var signalNotice = initialUiParams.get('signal_notice') || '';
    var legacyListingId = initialUiParams.get('edit_listing_id') || initialUiParams.get('draft_listing_id') || '';
    if (legacyListingId || initialUiParams.get('add_listing')) {
        var listingFormUrl = new URL(BASE_URL + 'dodaj-ogloszenie', window.location.origin);
        if (initialUiParams.get('edit_listing_id')) listingFormUrl.searchParams.set('edit_listing_id', legacyListingId);
        else if (initialUiParams.get('draft_listing_id')) listingFormUrl.searchParams.set('draft_listing_id', legacyListingId);
        window.location.replace(listingFormUrl.toString());
        return;
    }

    // Favorite "open on map" deep-link params. Set by /konto/panel/ulubione/<id>
    // redirects (UserDashboardController::actionOpenFavorite) when the bookmark
    // points to a transakcja / community_signal / gunb_permit / bdot10k_object.
    // Side-panel managers read this object on first render and auto-open the
    // matching record once the parent (dzialka/budynek) is selected via
    // signal_type + signal_entity_id. The flag is consumed on first use.
    window.metroskopDeepLink = {
        openTransakcja: initialUiParams.get('open_transakcja') || null,
        openSignal: initialUiParams.get('open_signal') || null,
        openGunb: initialUiParams.get('open_gunb') || null,
        openBdot: initialUiParams.get('open_bdot') || null,
        consume: function (key) {
            var value = this[key] || null;
            this[key] = null;
            return value;
        },
    };

    // The start dialog needs no map, so it opens before MapLibre loads and
    // still guides the visitor when the map cannot start. It reads the
    // address as it arrived; the first syncUrl() drops `kreator`. Unseen news
    // of a returning visitor go first: „Co nowego” opens instead. A check of a
    // parcel begun in this browser is offered over the map („Dokończ
    // sprawdzanie”), and then the dialog does not open by itself.
    var newsPending = hasPendingNews();
    var guidedResume = initGuidedResume({ params: initialUiParams });
    var startDialog = initStartDialog({ params: initialUiParams, newsPending: newsPending, resumeShown: guidedResume.shown });

    function mapZoom() {
        return map ? Math.round(map.getZoom() * 10) / 10 : DEFAULT_ZOOM;
    }

    function getParcelRenderOrderLayerIds() {
        return PARCEL_RENDER_MODE === 'vector'
            ? DzialkiVectorTileLayer.RENDER_ORDER_LAYER_IDS
            : DzialkiLayer.RENDER_ORDER_LAYER_IDS;
    }

    function getParcelBaseLayerIds() {
        return PARCEL_RENDER_MODE === 'vector'
            ? DzialkiVectorTileLayer.BASE_LAYER_IDS
            : DzialkiLayer.BASE_LAYER_IDS;
    }

    var orthoLayer = null;
    var orthoActive = false;
    var orthoDesired = false;
    var gesutLayer = null;
    var gesutActive = false;
    var gesutDesired = false;
    var portPolskaLayer = null;
    var portPolskaActive = false;
    var portPolskaDesired = false;
    var sidusisLayer = null;
    var sidusisActive = false;
    var sidusisDesired = false;
    var mpzpLayer = null;
    var mpzpActive = false;
    var mpzpDesired = false;
    var mpzpRuLayer = null;
    var mpzpRuActive = false;
    var mpzpRuDesired = false;
    var pogLayer = null;
    var pogActive = false;
    var pogDesired = false;
    var studiumLayer = null;
    var studiumActive = false;
    var studiumDesired = false;
    var powodzLayer = null;
    var powodzActive = false;
    var powodzDesired = false;
    var dzialkiLayer = null;
    var dzialkiActive = true;
    var dzialkiDesired = true;
    var budynkiLayer = null;
    var budynkiActive = false;
    var budynkiDesired = false;
    var gunbLayer = null;
    var gunbBadgeLayer = null;
    var selectedGunbLayer = null;
    var gunbActive = false;
    var gunbDesired = false;
    var sygnalyLayer = null;
    var sygnalyActive = true;
    var sygnalyDesired = true;
    var ogloszeniaLayer = null;
    var ogloszeniaActive = false;
    var ogloszeniaDesired = false;
    var ofertyDeweloperowLayer = null;
    var ofertyDeweloperowActive = false;
    var ofertyDeweloperowDesired = false;
    var transakcjeActive = true;
    var transakcjeDesired = true;
    var otoczenieLayer = null;
    var otoczenieActive = false;
    var otoczenieDesired = false;
    var gunbBrowseFeatures = null;
    var gunbBrowseLatlng = null;
    var selectedGunbId = null;
    var gunbGroupsCache = {};
    var combinedBadgeLayer = null;
    var layerPanel = null;
    var orthoController = null;
    var gesutController = null;
    var portPolskaController = null;
    var sidusisController = null;
    var mpzpController = null;
    var mpzpRuController = null;
    var pogController = null;
    var studiumController = null;
    var powodzController = null;
    var kowrController = null;
    var ownershipController = null;
    var landUseController = null;
    var transactionsController = null;
    var signalsController = null;
    var listingsController = null;
    var developerOffersController = null;
    var listingViewFeatures = [];
    var listingViewAggregated = false;
    // Developer investments in the view, for the "Oferty deweloperów" list.
    var developerOfferViewFeatures = [];
    var developerOfferViewAggregated = false;
    var renderedDeveloperOfferFeatures = [];
    var listingListSort = 'newest';
    var listSubTab = null;
    var signalsViewFeatures = [];
    var signalsViewAggregated = false;
    var dzialkiController = null;
    var budynkiController = null;
    var gunbController = null;
    var otoczenieController = null;
    var selectionPinController = null;
    var map = null;
    var mapAttributionControl = null;
    // Credits of viewport-image WMS layers, keyed by layer, shown only while their image is visible.
    var overlayMapAttributions = {};

    function updateOverlayMapAttribution(layerKey, credit) {
        if ((overlayMapAttributions[layerKey] || '') === credit) return;
        overlayMapAttributions[layerKey] = credit;
        if (!map || !mapAttributionControl) return;
        map.removeControl(mapAttributionControl);
        mapAttributionControl = new maplibregl.AttributionControl({
            compact: true,
            customAttribution: [PZGIK_NOTICE + '.'].concat(Object.values(overlayMapAttributions)).filter(Boolean),
        });
        map.addControl(mapAttributionControl, 'bottom-right');
    }
    var egibSearchMarkerGroup = null;
    var geoLayer = null;
    var nearbyLayer = null;
    var nearbyLinkLayer = null;
    var selectionPinLayer = null;
    var selectedFeatureLayer = null;
    var selectedFeatureLayerKey = null;
    var highlightedLayer = null;
    var latestGeoData = null;
    var selectedTransactionRow = null;
    var listRows = [];
    var rowCoords = {};
    var detailCache = {};
    var otoczenieUrbanPlanningCache = {};
    var pointUrbanPlanningCache = {};
    var nearbyItems = [];
    var activeNearbyItem = null;
    var activeNearbyId = null;
    var currentAssetType = 'dzialki';
    // Property-type statistics bucket for transaction aggregates ('' = all types,
    // legacy behaviour). Sent to api/geojson as &bucket=.
    var currentBucket = (function () {
        try { return new URLSearchParams(location.search).get('bucket') || ''; } catch (e) { return ''; }
    })();
    var currentSort = DEFAULT_SORT;
    var activeTab = 'list';
    var listPage = 1;
    var listTotal = 0;
    var listTotalEstimated = false;
    var listLoading = false;
    var listError = null;
    var listMoreFailed = false;
    var listMoreLabel = listMoreBtn ? listMoreBtn.textContent : '';
    var renderedTransactionRows = [];
    var renderedListingFeatures = [];
    var renderedGunbFeatures = [];
    var renderedSignalFeatures = [];
    var listHasMore = false;
    var selectedTid = null;
    var selectedDid = null;
    var selectedBid = null;
    var selectedListingId = null;
    // The investment shown in the details panel, and whether a URL asked for
    // one that is still waiting for the developer-offer markers to load.
    var selectedDeveloperInvestmentId = null;
    var pendingDeveloperInvestmentRestore = false;
    var selectedSignalContext = null;
    var selectedSearchItem = null;
    var selectedOtoczenieFeature = null;
    var selectedOtoczenieId = null;
    var selectedNoiseContext = null;
    var selectedEducationId = null;
    var selectedLatLng = null;
    var nearbyPointReference = null;
    var nearbyLoaded = false;
    var pendingNearbyRestore = false;
    var mapRefreshTimer = null;
    var userMapNavigationPending = false;
    var personaModule = null;
    var signalsPanel = null;
    var signalSubmitController = null;
    var favoritesController = null;

    function createDefaultFilterState() {
        return createDefaultFilterStateState();
    }

    function normalizeTransactionRokOd(value) {
        return normalizeTransactionRokOdState(value);
    }

    function parseTransactionRokOdFromUrl(value) {
        return value === null ? DEFAULT_TRANSACTION_ROK_OD : normalizeTransactionRokOd(value);
    }

    function normalizeGunbRokWplywuOd(value) {
        return normalizeGunbRokWplywuOdState(value);
    }

    function parseGunbRokWplywuOdFromUrl(value) {
        return value === null ? DEFAULT_GUNB_ROK_WPLYWU_OD : normalizeGunbRokWplywuOd(value);
    }

    function getGunbFilterParams() {
        return getGunbFilterParamsState(filterState);
    }

    function getGunbFilterQueryString(baseParams) {
        return getGunbFilterQueryStringState(baseParams, filterState);
    }

    function getBdot10kFilterParams() {
        return getBdot10kFilterParamsState(filterState);
    }

    function getBdot10kFilterQueryString(baseParams) {
        var params = new URLSearchParams(getBdot10kFilterQueryStringState(baseParams, filterState));
        if (typeof window.RCN_BDOT10K_IMPACT_CACHE_VERSION === 'string') {
            params.set('impact_cache_version', window.RCN_BDOT10K_IMPACT_CACHE_VERSION);
        }
        return params.toString();
    }

    var filterState = createDefaultFilterState();

    var panelLayout = createPanelLayout({
        appEl: appEl,
        getMap: function() { return map; },
        html: html,
        panelToggleBtn: panelToggleBtn,
        sheetEl: sheetEl,
        sheetHandleEl: sheetHandleEl,
        topbarEl: topbarEl,
    });

    var otoczenieModule = createOtoczenieModule({
        addOrUpdateGeoJsonSource: addOrUpdateGeoJsonSource,
        bdot10kImpactBalanceLabel: bdot10kImpactBalanceLabel,
        bdot10kImpactSummary: bdot10kImpactSummary,
        bdot10kLabel: bdot10kLabel,
        getFeatureCentroid: getFeatureCentroid,
        bdot10kTranslate: bdot10kTranslate,
        renderBdot10kFunctions: renderBdot10kFunctions,
        bringDataLayersToFront: bringDataLayersToFront,
        consumeHandledMapClick: consumeHandledMapClick,
        usePointQueryPanel: true,
        esc: esc,
        getController: function() { return otoczenieController; },
        getLayer: function() { return otoczenieLayer; },
        getMap: function() { return map; },
        registerCursorHandlers: registerCursorHandlers,
        removeSourceAndLayers: removeSourceAndLayers,
        setLayer: function(layer) { otoczenieLayer = layer; },
    });

    var selectedFeatureManager = createSelectedFeatureManager({
        getRenderedLayerKey: function() { return selectedFeatureLayerKey; },
        getRequestUrl: getSelectedFeatureRequestUrl,
        getSelectedFeatureId: getSelectedFeatureIdByType,
        perfEnd: perfEnd,
        perfStart: perfStart,
        renderDetails: renderSelectedFeatureDetailsFromData,
        renderError: renderDetailsError,
        renderLayer: renderSelectedFeatureLayerData,
    });

    var parcelMeasurementManager = createParcelMeasurements({
        detailsContentEl: detailsContentEl,
        getMap: function() { return map; },
        onStateChange: function() { syncUrl(); },
    });

    var tapBrowseManager = createTapBrowseManager({
        bdot10kImpactBalanceLabel: bdot10kImpactBalanceLabel,
        bdot10kImpactClassificationLabel: bdot10kImpactClassificationLabel,
        bdot10kImpactSummary: bdot10kImpactSummary,
        bdot10kLabel: bdot10kLabel,
        esc: esc,
        fmt: fmt,
        getFeatureCentroid: getFeatureCentroid,
        getSelectedIds: function() {
            return {
                selectedBid: selectedBid,
                selectedDid: selectedDid,
                selectedGunbId: selectedGunbId,
                selectedSignalId: selectedSignalContext ? selectedSignalContext.selectedSignalId : null,
            };
        },
        listContentEl: listContentEl,
        listMetaEl: listMetaEl,
        listMoreBtn: listMoreBtn,
        listTitleEl: listTitleEl,
        renderListPanel: renderListPanel,
        selectBuilding: selectBuilding,
        selectGunbPermit: selectGunbPermit,
        selectOtoczenieFeature: selectOtoczenieFeature,
        selectNoiseHit: selectNoiseHit,
        selectEducationHit: selectEducationHit,
        selectParcel: selectParcel,
        selectSignalHit: selectSignalHit,
        setTab: setTab,
        sortRowEl: sortRowEl,
        state: {
            getTapBrowseHits: function() { return tapBrowseHits; },
            setTapBrowseHits: function(value) { tapBrowseHits = value; },
            getTapBrowseLatlng: function() { return tapBrowseLatlng; },
            setTapBrowseLatlng: function(value) { tapBrowseLatlng = value; },
            setGunbBrowseFeatures: function(value) { gunbBrowseFeatures = value; },
            setGunbBrowseLatlng: function(value) { gunbBrowseLatlng = value; },
            setCombinedBrowseTransactions: function(value) { combinedBrowseTransactions = value; },
            setCombinedBrowseGunb: function(value) { combinedBrowseGunb = value; },
            getCombinedBrowseOtherHits: function() { return combinedBrowseOtherHits; },
            setCombinedBrowseOtherHits: function(value) { combinedBrowseOtherHits = value; },
            setCombinedBrowseLatlng: function(value) { combinedBrowseLatlng = value; },
            setOverlapBrowseFeatures: function(value) { overlapBrowseFeatures = value; },
            setOverlapBrowseLatlng: function(value) { overlapBrowseLatlng = value; },
        },
    });

    var tapResolutionManager = createTapResolutionManager({
        dispatchPointQuery: function(latlng, point, hits) { return startPointQuery(latlng, point, hits); },
        BASE_URL: BASE_URL,
        BudynkiLayer: BudynkiLayer,
        DzialkiLayer: DzialkiLayer,
        GunbLayer: GunbLayer,
        OtoczenieLayer: OtoczenieLayer,
        browseCombinedInPanel: browseCombinedInPanel,
        browseTapHitsInPanel: browseTapHitsInPanel,
        clearTapBrowseState: clearTapBrowseState,
        getGunbFilterQueryString: getGunbFilterQueryString,
        getMap: function() { return map; },
        getNoiseFeatures: function(key) { return noiseLayerRuntime.getRenderedFeatures(key); },
        getOtoczenieLayerIds: function() { return ['lyr-otoczenie-power-line-buffer-fill', 'lyr-otoczenie-power-line-buffer-line', 'lyr-otoczenie-fill', 'lyr-otoczenie-line', 'lyr-otoczenie-linestring', 'lyr-otoczenie-circle']; },
        getParcelLayerIds: getParcelBaseLayerIds,
        isDesktopLayout: isDesktopLayout,
        isBudynkiActive: function() { return budynkiActive; },
        isDzialkiActive: function() { return dzialkiActive; },
        isGunbActive: function() { return gunbActive; },
        isOtoczenieActive: function() { return otoczenieActive; },
        mapZoom: mapZoom,
        qstr: qstr,
        renderListPanel: renderListPanel,
        resolveTapHitSelection: resolveTapHitSelection,
        selectTransactionByFeature: selectTransactionByFeature,
        state: {
            bumpTapResolverRequestVersion: function() {
                tapResolverRequestVersion += 1;
                return tapResolverRequestVersion;
            },
            getAbortTapResolver: function() { return abortTapResolver; },
            setAbortTapResolver: function(value) { abortTapResolver = value; },
            getTapBrowseHits: function() { return tapBrowseHits; },
            setTapBrowseHits: function(value) { tapBrowseHits = value; },
            setTapBrowseLatlng: function(value) { tapBrowseLatlng = value; },
            getTapResolverRequestVersion: function() { return tapResolverRequestVersion; },
        },
    });

    var overlapManager = createOverlapManager({
        dispatchPointQuery: startPointQuery,
        applySelectedStylesInList: applySelectedStylesInList,
        browseCombinedInPanel: browseCombinedInPanel,
        browseGunbInPanel: browseGunbInPanel,
        clearGunbBadgeLayer: clearGunbBadgeLayer,
        clearTapBrowseState: clearTapBrowseState,
        getCurrentSort: function() { return currentSort; },
        getFeatureCentroid: getFeatureCentroid,
        getMap: function() { return map; },
        listContentEl: listContentEl,
        listMetaEl: listMetaEl,
        listMoreBtn: listMoreBtn,
        listTitleEl: listTitleEl,
        renderListCardHtml: renderListCardHtml,
        renderListPanel: renderListPanel,
        setTab: setTab,
        sortDir: sortDir,
        sortField: sortField,
        sortRowEl: sortRowEl,
        state: {
            getCombinedBadgeLayer: function() { return combinedBadgeLayer; },
            setCombinedBadgeLayer: function(value) { combinedBadgeLayer = value; },
            getGunbGroupsCache: function() { return gunbGroupsCache; },
            setCombinedBrowseGunb: function(value) { combinedBrowseGunb = value; },
            setCombinedBrowseOtherHits: function(value) { combinedBrowseOtherHits = value; },
            setCombinedBrowseLatlng: function(value) { combinedBrowseLatlng = value; },
            setCombinedBrowseTransactions: function(value) { combinedBrowseTransactions = value; },
            setGunbBrowseFeatures: function(value) { gunbBrowseFeatures = value; },
            setGunbBrowseLatlng: function(value) { gunbBrowseLatlng = value; },
            getOverlapBrowseFeatures: function() { return overlapBrowseFeatures; },
            setOverlapBrowseFeatures: function(value) { overlapBrowseFeatures = value; },
            setOverlapBrowseLatlng: function(value) { overlapBrowseLatlng = value; },
            getOverlapGroupsCache: function() { return overlapGroupsCache; },
            setOverlapGroupsCache: function(value) { overlapGroupsCache = value; },
            getOverlapLayer: function() { return overlapLayer; },
            setOverlapLayer: function(value) { overlapLayer = value; },
        },
    });

    var listPanelRenderers = createListPanelRenderers({
        INDIVIDUAL_ZOOM_THRESHOLD: INDIVIDUAL_ZOOM_THRESHOLD,
        LIMITED_MODE: LIMITED_MODE,
        buildDetailUrl: buildDetailUrl,
        dateDisp: dateDisp,
        esc: esc,
        fmt: fmt,
        formatDist: formatDist,
        funkcjaLabel: funkcjaLabel,
        listContentEl: listContentEl,
        listMetaEl: listMetaEl,
        listMoreBtn: listMoreBtn,
        listTitleEl: listTitleEl,
        mapZoom: mapZoom,
        nierLabel: nierLabel,
        parseAddr: parseAddr,
        renderFunkcjaChip: renderFunkcjaChip,
        renderTapHitCardHtml: function(hit) {
            return tapBrowseManager.renderTapHitCardHtml(hit);
        },
        rodzLabel: rodzLabel,
        sortOverlapFeatures: function(features, sort) {
            return overlapManager.sortOverlapFeatures(features, sort);
        },
        sortRowEl: sortRowEl,
        state: {
            getCombinedBrowseTransactions: function() { return combinedBrowseTransactions; },
            getCombinedBrowseGunb: function() { return combinedBrowseGunb; },
            getCombinedBrowseOtherHits: function() { return combinedBrowseOtherHits; },
            getCurrentSort: function() { return currentSort; },
            getGunbBrowseFeatures: function() { return gunbBrowseFeatures; },
            getLatestGeoData: function() { return latestGeoData; },
            getSelectedGunbId: function() { return selectedGunbId; },
            getSelectedTid: function() { return selectedTid; },
        },
        typLabel: typLabel,
    });

    signalsPanel = createSignalsPanel({
        baseUrl: BASE_URL,
        detailsContentEl: detailsContentEl,
        esc: esc,
        onOpenSubmitForm: openSignalSubmitForm,
        onSignalFocus: handleSignalFocus,
        onSignalSelectionChange: function() {
            syncUrl();
        },
    });

    const submitFooterEl = document.getElementById('nm-submit-footer');
    if (submitFooterEl) {
        createSubmissionFooter({ footer: submitFooterEl });
    }

    initSignalsDisclaimer({
        title: 'Sygnały społeczności — informacja',
        body: 'Sygnały dodają użytkownicy. Administrator nie ponosi odpowiedzialności za prawdziwość publikowanych treści. Jeśli widzisz nieodpowiedni wpis, zgłoś go do moderacji.',
        policyUrl: '/sygnaly-spolecznosci/regulamin',
        policyLabel: 'Zobacz pełen regulamin',
    });

    const REPORT_REASONS = [
        { code: 'offensive', label: 'Obraźliwy / wulgarny' },
        { code: 'false', label: 'Nieprawdziwy / wprowadzający w błąd' },
        { code: 'spam', label: 'Spam / reklama' },
        { code: 'hate', label: 'Mowa nienawiści / dyskryminacja' },
        { code: 'privacy', label: 'Narusza prywatność / dane osobowe' },
        { code: 'wrong_category', label: 'Niewłaściwa kategoria' },
        { code: 'duplicate', label: 'Duplikat istniejącego sygnału' },
        { code: 'illegal', label: 'Treści niezgodne z prawem' },
        { code: 'other', label: 'Inny powód' },
    ];
    const LISTING_REPORT_REASONS = [
        { code: 'spam', label: 'Spam lub masowa reklama' },
        { code: 'fraud', label: 'Podejrzenie oszustwa' },
        { code: 'offensive', label: 'Treść obraźliwa' },
        { code: 'illegal', label: 'Treść niezgodna z prawem' },
        { code: 'privacy', label: 'Naruszenie prywatności' },
        { code: 'duplicate', label: 'Duplikat ogłoszenia' },
        { code: 'wrong_category', label: 'Niewłaściwa kategoria' },
        { code: 'unavailable', label: 'Ogłoszenie nieaktualne' },
        { code: 'wrong_data', label: 'Błędne dane (cena, powierzchnia, lokalizacja)' },
        { code: 'other', label: 'Inny powód' },
    ];
    createSignalReportModule({
        apiUrl: BASE_URL + 'rcn/api/community-signals',
        loginUrl: '/konto/logowanie',
        dashboardUrl: '/konto/panel/moje-zgloszenia',
        reasons: REPORT_REASONS,
        title: 'Zgłoś sygnał do moderacji',
        onSuccess: function () {
            if (typeof window.alert === 'function') {
                window.alert('Zgłoszenie zostało zapisane. Administrator je rozpatrzy.');
            }
        },
    });
    createSignalReportModule({
        requestUrl: function () {
            return BASE_URL + 'api/listings/report';
        },
        buildPayload: function (listingId, payload) {
            return Object.assign({}, payload, { listing_id: listingId });
        },
        selector: '[data-listing-report]',
        idAttribute: 'data-listing-id',
        loginUrl: '/konto/logowanie',
        reasons: LISTING_REPORT_REASONS,
        title: 'Zgłoś ogłoszenie',
        onSuccess: function () {
            if (typeof window.alert === 'function') {
                window.alert('Zgłoszenie ogłoszenia zostało zapisane. Administrator je rozpatrzy.');
            }
        },
    });
    document.addEventListener('click', handleMapListingLightboxClick);

    favoritesController = createFavoritesModule({
        apiUrl: BASE_URL + 'rcn/api/favorites',
        loginUrl: '/konto/logowanie',
        getMap: function () { return map; },
        // Side-panel renderers (transactions, signals, GUNB permits, BDOT objects)
        // call window.metroskopFavorites.toggleForContext({ entityType, entityRef }).
        onReady: function (api) { window.metroskopFavorites = api; },
        captureState: function () {
            syncUrl();
            var center = map ? map.getCenter() : null;
            return {
                urlState: location.pathname + location.search + location.hash,
                lat: center ? center.lat : null,
                lng: center ? center.lng : null,
                zoom: map ? map.getZoom() : null,
                previewMeta: {
                    asset: currentAssetType,
                    selectedTid: selectedTid,
                    selectedDid: selectedDid,
                    selectedBid: selectedBid,
                    selectedGunbId: selectedGunbId,
                    activeTab: activeTab,
                },
                defaultTitle: (document.title || '').split('|')[0].trim(),
            };
        },
    });

    signalSubmitController = createSignalsSubmitController({
        baseUrl: BASE_URL,
        setDetailsMeta: setDetailsMeta,
        clearPointMarker: function() {
            if (interactiveHitDispatcher && typeof interactiveHitDispatcher.clearClickMarker === 'function') {
                interactiveHitDispatcher.clearClickMarker();
            }
        },
        clearSignalPreview: function() {
            if (!map) return;
            removeSourceAndLayers(map, 'src-signal-submit-preview', [
                'lyr-signal-submit-preview-fill',
                'lyr-signal-submit-preview-line',
                'lyr-signal-submit-preview-pin-ring',
                'lyr-signal-submit-preview-pin-dot',
            ]);
        },
        clearTileGeometry: function() {
            if (!map) return;
            removeSourceAndLayers(map, 'src-signal-tile-preview', [
                'lyr-signal-tile-fill', 'lyr-signal-tile-line', 'lyr-signal-tile-circle',
            ]);
        },
        detailsContentEl: detailsContentEl,
        detailsMetaEl: detailsMetaEl,
        esc: esc,
        getMapCenter: function() {
            if (map) {
                var center = map.getCenter();
                return {
                    lat: center.lat,
                    lng: center.lng,
                };
            }

            return {
                lat: DEFAULT_LAT,
                lng: DEFAULT_LNG,
            };
        },
        onClose: restoreCurrentDetailsAfterSignalSubmit,
        openNearbyBtn: openNearbyBtn,
        showPointMarker: function(latlng) {
            if (interactiveHitDispatcher && typeof interactiveHitDispatcher.showClickMarker === 'function') {
                interactiveHitDispatcher.showClickMarker(latlng);
            }
        },
        turnstile: window.RCN_COMMUNITY_SIGNALS_TURNSTILE && typeof window.RCN_COMMUNITY_SIGNALS_TURNSTILE === 'object'
            ? window.RCN_COMMUNITY_SIGNALS_TURNSTILE
            : null,
        showSignalPreview: function(preview) {
            if (!map || !preview || !preview.point) return;

            function makeCirclePolygon(lat, lng, radiusMeters, steps) {
                var points = [];
                var safeSteps = steps || 48;
                var latRad = lat * Math.PI / 180;
                var metersPerDegLat = 111320;
                var metersPerDegLng = Math.max(1, 111320 * Math.cos(latRad));
                for (var i = 0; i <= safeSteps; i += 1) {
                    var angle = (i / safeSteps) * Math.PI * 2;
                    var dx = Math.cos(angle) * radiusMeters;
                    var dy = Math.sin(angle) * radiusMeters;
                    points.push([
                        lng + (dx / metersPerDegLng),
                        lat + (dy / metersPerDegLat),
                    ]);
                }
                return points;
            }

            var features = [{
                type: 'Feature',
                properties: {
                    kind: 'point',
                },
                geometry: {
                    type: 'Point',
                    coordinates: [preview.point.lng, preview.point.lat],
                },
            }];

            if (preview.radius && preview.radius > 0) {
                features.unshift({
                    type: 'Feature',
                    properties: {
                        kind: 'radius',
                    },
                    geometry: {
                        type: 'Polygon',
                        coordinates: [makeCirclePolygon(preview.point.lat, preview.point.lng, preview.radius, 56)],
                    },
                });
            }

            addOrUpdateGeoJsonSource(map, 'src-signal-submit-preview', {
                type: 'FeatureCollection',
                features: features,
            });

            if (!map.getLayer('lyr-signal-submit-preview-fill') && preview.radius && preview.radius > 0) {
                map.addLayer({
                    id: 'lyr-signal-submit-preview-fill',
                    type: 'fill',
                    source: 'src-signal-submit-preview',
                    filter: ['==', ['get', 'kind'], 'radius'],
                    paint: {
                        'fill-color': '#ea6a2a',
                        'fill-opacity': 0.14,
                    },
                });
            }

            if (!map.getLayer('lyr-signal-submit-preview-line') && preview.radius && preview.radius > 0) {
                map.addLayer({
                    id: 'lyr-signal-submit-preview-line',
                    type: 'line',
                    source: 'src-signal-submit-preview',
                    filter: ['==', ['get', 'kind'], 'radius'],
                    paint: {
                        'line-color': '#d76621',
                        'line-width': 2.25,
                        'line-opacity': 0.85,
                    },
                });
            }

            if (!map.getLayer('lyr-signal-submit-preview-pin-ring')) {
                map.addLayer({
                    id: 'lyr-signal-submit-preview-pin-ring',
                    type: 'circle',
                    source: 'src-signal-submit-preview',
                    filter: ['==', ['get', 'kind'], 'point'],
                    paint: {
                        'circle-radius': 13,
                        'circle-color': 'rgba(255,255,255,0.22)',
                        'circle-stroke-color': '#d76621',
                        'circle-stroke-width': 3,
                    },
                });
            }

            if (!map.getLayer('lyr-signal-submit-preview-pin-dot')) {
                map.addLayer({
                    id: 'lyr-signal-submit-preview-pin-dot',
                    type: 'circle',
                    source: 'src-signal-submit-preview',
                    filter: ['==', ['get', 'kind'], 'point'],
                    paint: {
                        'circle-radius': 4.5,
                        'circle-color': '#d76621',
                        'circle-stroke-color': '#fff6ef',
                        'circle-stroke-width': 2,
                    },
                });
            }
        },
        showTileGeometry: function(feature) {
            if (!map || !feature || !feature.geometry) return;
            removeSourceAndLayers(map, 'src-signal-tile-preview', [
                'lyr-signal-tile-fill', 'lyr-signal-tile-line', 'lyr-signal-tile-circle',
            ]);
            var fc = { type: 'FeatureCollection', features: [feature] };
            addOrUpdateGeoJsonSource(map, 'src-signal-tile-preview', fc);
            var geomType = feature.geometry.type || '';
            if (geomType === 'Polygon' || geomType === 'MultiPolygon') {
                map.addLayer({
                    id: 'lyr-signal-tile-fill', type: 'fill', source: 'src-signal-tile-preview',
                    paint: { 'fill-color': '#3b82f6', 'fill-opacity': 0.15 },
                });
                map.addLayer({
                    id: 'lyr-signal-tile-line', type: 'line', source: 'src-signal-tile-preview',
                    paint: { 'line-color': '#3b82f6', 'line-width': 2.5, 'line-opacity': 0.8 },
                });
            } else if (geomType === 'LineString' || geomType === 'MultiLineString') {
                map.addLayer({
                    id: 'lyr-signal-tile-line', type: 'line', source: 'src-signal-tile-preview',
                    paint: { 'line-color': '#3b82f6', 'line-width': 3, 'line-opacity': 0.85 },
                });
            } else if (geomType === 'Point' || geomType === 'MultiPoint') {
                map.addLayer({
                    id: 'lyr-signal-tile-circle', type: 'circle', source: 'src-signal-tile-preview',
                    paint: { 'circle-color': '#3b82f6', 'circle-radius': 8, 'circle-opacity': 0.7, 'circle-stroke-color': '#fff', 'circle-stroke-width': 2 },
                });
            }
        },
    });

    var detailRenderers = createDetailRenderers({
        baseUrl: BASE_URL,
        bdot10kImpactBalanceLabel: bdot10kImpactBalanceLabel,
        bdot10kImpactClassificationLabel: bdot10kImpactClassificationLabel,
        bdot10kImpactSummary: bdot10kImpactSummary,
        bdot10kLabel: bdot10kLabel,
        bdot10kTranslate: bdot10kTranslate,
        renderBdot10kFunctions: renderBdot10kFunctions,
        buildBuildingDetailUrl: buildBuildingDetailUrl,
        buildDetailUrl: buildDetailUrl,
        buildGunbDetailUrl: buildGunbDetailUrl,
        buildParcelDetailUrl: buildParcelDetailUrl,
        detailsContentEl: detailsContentEl,
        detailsMetaEl: detailsMetaEl,
        esc: esc,
        fmt: fmt,
        geoportalMapviewUrl: geoportalMapviewUrl,
        geoportalParcelUrl: geoportalParcelUrl,
        googleMapsUrl: googleMapsUrl,
        openNearbyBtn: openNearbyBtn,
        detailCtaEl: detailCtaEl,
        onOpenSubmitForm: openSignalSubmitForm,
        listingFormUrl: BASE_URL + 'dodaj-ogloszenie',
        setDetailsMeta: setDetailsMeta,
        setDetailsKicker: setDetailsKicker,
        setDetailsDepartment: setDetailsDepartment,
        onDetailRendered: function() {
            if (favoritesController && typeof favoritesController.reapplyDetailState === 'function') {
                favoritesController.reapplyDetailState();
            }
        },
        parseAddr: parseAddr,
        rcnMapviewUrl: rcnMapviewUrl,
        rcnParcelUrl: rcnParcelUrl,
        renderExternalLinks: renderExternalLinks,
        renderParcelMeasurementControls: function(helpButton) {
            return parcelMeasurementManager.controlsHtml(helpButton);
        },
        signalsPanel: signalsPanel,
        state: {
            getSelectedLatLng: function() { return selectedLatLng; },
            getSelectedTransactionRow: function() { return selectedTransactionRow; },
        },
        typLabel: typLabel,
    });

    var selectionManager = createSelectionManager({
        INDIVIDUAL_ZOOM_THRESHOLD: INDIVIDUAL_ZOOM_THRESHOLD,
        applySelectedStylesInGunbList: applySelectedStylesInGunbList,
        applySelectedStylesInList: applySelectedStylesInList,
        bringDataLayersToFront: bringDataLayersToFront,
        clearSignalFocus: clearSignalFocus,
        clearNearbyState: clearNearbyState,
        clearSelectedFeatureVisual: clearSelectedFeatureVisual,
        clearSelectedGunbVisual: clearSelectedGunbVisual,
        clearTapBrowseState: clearTapBrowseState,
        easeMapToKeepPointVisible: easeMapToKeepPointVisible,
        ensureSelectedFeatureData: ensureSelectedFeatureData,
        fetchTransactionDetail: fetchTransactionDetail,
        floatingPillbarEl: floatingPillbarEl,
        getFeatureCentroid: getFeatureCentroid,
        getLatestGeoData: function() { return latestGeoData; },
        getMap: function() { return map; },
        getMapPaddingForPanel: getMapPaddingForPanel,
        getSelectedFeatureKey: getSelectedFeatureKey,
        getTransactionsController: function() { return transactionsController; },
        hasBuildingDetails: hasBuildingDetails,
        hasParcelDetails: hasParcelDetails,
        loadNearbyForSelection: loadNearbyForSelection,
        loadSignalsForContext: loadSignalsForContext,
        rebuildNearbyLinkIfNeeded: rebuildNearbyLinkIfNeeded,
        renderBuildingDetails: renderBuildingDetails,
        renderDetailsLoading: renderDetailsLoading,
        renderDetailsPlaceholder: renderDetailsPlaceholder,
        renderParcelDetails: renderParcelDetails,
        renderSignalTargetDetails: renderSignalTargetDetails,
        renderOtoczenieDetails: renderOtoczenieDetails,
        personaBtn: personaBtn,
        selectionBannerEl: selectionBannerEl,
        selectionBannerTextEl: selectionBannerTextEl,
        selectionClearBtn: selectionClearBtn,
        onSelectionChanged: function (ctx) {
            if (ctx) selectedNoiseContext = null;
            if (favoritesController && typeof favoritesController.setContext === 'function') {
                favoritesController.setContext(ctx);
            }
        },
        setTab: setTab,
        syncListingMarkerSelection: syncListingMarkerSelection,
        syncUrl: syncUrl,
        updateParcelLabels: updateParcelLabels,
        state: {
            getActiveTab: function() { return activeTab; },
            getGeoLayer: function() { return geoLayer; },
            getNearbyLoaded: function() { return nearbyLoaded; },
            getPendingNearbyRestore: function() { return pendingNearbyRestore; },
            setPendingNearbyRestore: function(value) { pendingNearbyRestore = !!value; },
            getRowCoords: function() { return rowCoords; },
            getListRows: function() { return listRows; },
            getSelectedBid: function() { return selectedBid; },
            setSelectedBid: function(value) { selectedBid = value; },
            getSelectedDid: function() { return selectedDid; },
            setSelectedDid: function(value) { selectedDid = value; },
            getSelectedFeatureLayer: function() { return selectedFeatureLayer; },
            getSelectedFeatureLayerKey: function() { return selectedFeatureLayerKey; },
            getSelectedGunbId: function() { return selectedGunbId; },
            setSelectedGunbId: function(value) { selectedGunbId = value; },
            getSelectedListingId: function() { return selectedListingId; },
            setSelectedListingId: function(value) { selectedListingId = value; },
            getSelectedGunbLayer: function() { return selectedGunbLayer; },
            getSelectedLatLng: function() { return selectedLatLng; },
            setSelectedLatLng: function(value) { selectedLatLng = value; },
            getSelectedOtoczenieFeature: function() { return selectedOtoczenieFeature; },
            setSelectedOtoczenieFeature: function(value) {
                selectedOtoczenieFeature = value;
                selectedOtoczenieId = value ? getOtoczenieFeatureId(value) : null;
            },
            getSelectedSignalContext: function() { return selectedSignalContext; },
            setSelectedSignalContext: function(value) { selectedSignalContext = value; },
            getSelectedTid: function() { return selectedTid; },
            setSelectedTid: function(value) { selectedTid = value; },
            getSelectedTransactionRow: function() { return selectedTransactionRow; },
            setSelectedTransactionRow: function(value) { selectedTransactionRow = value; },
            setHighlightedLayer: function(value) { highlightedLayer = value; },
        },
    });

    var gunbManager = createGunbManager({
        BASE_URL: BASE_URL,
        applySelectionFocusState: applySelectionFocusState,
        applySelectedStylesInGunbList: applySelectedStylesInGunbList,
        bringDataLayersToFront: bringDataLayersToFront,
        clearSignalFocus: clearSignalFocus,
        clearNearbyState: clearNearbyState,
        clearSelectedFeatureVisual: clearSelectedFeatureVisual,
        clearTapBrowseState: clearTapBrowseState,
        clearTransactionHighlight: clearTransactionHighlight,
        easeMapToKeepPointVisible: easeMapToKeepPointVisible,
        getFeatureCentroid: getFeatureCentroid,
        getGunbController: function() { return gunbController; },
        getMap: function() { return map; },
        hasGunbLayer: function() { return !!gunbLayer; },
        isGunbActive: function() { return gunbActive; },
        loadNearbyForSelection: loadNearbyForSelection,
        rebuildNearbyLinkIfNeeded: rebuildNearbyLinkIfNeeded,
        renderDetailsError: renderDetailsError,
        renderDetailsLoading: renderDetailsLoading,
        renderGunbDetails: renderGunbDetails,
        renderListPanel: renderListPanel,
        setTab: setTab,
        syncUrl: syncUrl,
        state: {
            getCombinedBrowseGunb: function() { return combinedBrowseGunb; },
            setCombinedBrowseGunb: function(value) { combinedBrowseGunb = value; },
            setCombinedBrowseOtherHits: function(value) { combinedBrowseOtherHits = value; },
            setCombinedBrowseLatlng: function(value) { combinedBrowseLatlng = value; },
            setCombinedBrowseTransactions: function(value) { combinedBrowseTransactions = value; },
            getGunbBrowseFeatures: function() { return gunbBrowseFeatures; },
            setGunbBrowseFeatures: function(value) { gunbBrowseFeatures = value; },
            setGunbBrowseLatlng: function(value) { gunbBrowseLatlng = value; },
            getNearbyLoaded: function() { return nearbyLoaded; },
            getPendingNearbyRestore: function() { return pendingNearbyRestore; },
            setPendingNearbyRestore: function(value) { pendingNearbyRestore = !!value; },
            getSelectedBid: function() { return selectedBid; },
            setSelectedBid: function(value) { selectedBid = value; },
            getSelectedDid: function() { return selectedDid; },
            setSelectedDid: function(value) { selectedDid = value; },
            getSelectedGunbId: function() { return selectedGunbId; },
            setSelectedGunbId: function(value) { selectedGunbId = value; },
            setSelectedListingId: function(value) { selectedListingId = value; },
            getSelectedGunbLayer: function() { return selectedGunbLayer; },
            setSelectedGunbLayer: function(value) { selectedGunbLayer = value; },
            getSelectedLatLng: function() { return selectedLatLng; },
            setSelectedLatLng: function(value) { selectedLatLng = value; },
            getSelectedOtoczenieFeature: function() { return selectedOtoczenieFeature; },
            setSelectedOtoczenieFeature: function(value) {
                selectedOtoczenieFeature = value;
                selectedOtoczenieId = value ? getOtoczenieFeatureId(value) : null;
            },
            getSelectedSignalContext: function() { return selectedSignalContext; },
            setSelectedSignalContext: function(value) { selectedSignalContext = value; },
            getSelectedTid: function() { return selectedTid; },
            setSelectedTid: function(value) { selectedTid = value; },
            setSelectedTransactionRow: function(value) { selectedTransactionRow = value; },
            setOverlapBrowseFeatures: function(value) { overlapBrowseFeatures = value; },
            setOverlapBrowseLatlng: function(value) { overlapBrowseLatlng = value; },
        },
    });

    var interactiveHitDispatcher = createInteractiveHitDispatcher({
        dispatchPointQuery: startPointQuery,
        BASE_URL: BASE_URL,
        BudynkiLayer: BudynkiLayer,
        DzialkiLayer: DzialkiLayer,
        GunbLayer: GunbLayer,
        INDIVIDUAL_ZOOM_THRESHOLD: INDIVIDUAL_ZOOM_THRESHOLD,
        OtoczenieLayer: OtoczenieLayer,
        SignalsLayer: SignalsLayer,
        TransactionsLayer: TransactionsLayer,
        browseCombinedInPanel: browseCombinedInPanel,
        browseGunbInPanel: browseGunbInPanel,
        clearTapBrowseState: clearTapBrowseState,
        collectCombinedSupportingHits: function(features, point) {
            return tapResolutionManager.collectCombinedSupportingHits(features, point);
        },
        getFeatureCentroid: getFeatureCentroid,
        getGunbGroupsCache: function() { return gunbGroupsCache; },
        getMap: function() { return map; },
        getNoiseFeatures: function(key) { return noiseLayerRuntime.getRenderedFeatures(key); },
        getActiveTab: function() { return activeTab; },
        getNearbyItems: function() { return nearbyItems; },
        getOtoczenieLayerIds: function() { return ['lyr-otoczenie-power-line-buffer-fill', 'lyr-otoczenie-power-line-buffer-line', 'lyr-otoczenie-fill', 'lyr-otoczenie-line', 'lyr-otoczenie-linestring', 'lyr-otoczenie-circle']; },
        getParcelLayerIds: getParcelBaseLayerIds,
        hasTapBrowseHits: function() { return tapBrowseManager.hasTapBrowseHits(); },
        focusNearbyItem: focusNearbyItem,
        isBudynkiActive: function() { return budynkiActive; },
        isDzialkiActive: function() { return dzialkiActive; },
        isGunbActive: function() { return gunbActive; },
        isOtoczenieActive: function() { return otoczenieActive; },
        isSignalsActive: function() { return sygnalyActive; },
        isTransakcjeActive: function() { return transakcjeActive; },
        mapZoom: mapZoom,
        renderListPanel: renderListPanel,
        selectBuilding: selectBuilding,
        selectGunbPermit: selectGunbPermit,
        selectOtoczenieFeature: selectOtoczenieFeature,
        selectNoiseHit: selectNoiseHit,
        selectEducationHit: selectEducationHit,
        selectParcel: selectParcel,
        selectSignalHit: selectSignalHit,
        selectTransactionByFeature: selectTransactionByFeature,
    });

    var pointQueryMarker = null;
    var pointQueryRefreshScheduled = false;
    var pointQuerySession = createPointQuerySession({
        collectHits: collectPointQueryHits,
        getSources: getPointQuerySources,
        onCancel: function() {
            if (pointQueryMarker) pointQueryMarker.remove();
            pointQueryMarker = null;
            // Session and DOM must change together, including selection and
            // filter changes while the desktop list is frozen under the cursor.
            renderListPanel({ immediate: true });
        },
        onStart: function(session) {
            session.filterKey = JSON.stringify(filterState);
            session.zoom = mapZoom();
            clearSelection({ keepDetails: false, sync: false });
            clearTapBrowseState();
            overlapBrowseFeatures = null;
            gunbBrowseFeatures = null;
            combinedBrowseTransactions = null;
            combinedBrowseGunb = null;
            combinedBrowseOtherHits = null;
            interactiveHitDispatcher.clearClickMarker();
            var element = document.createElement('div');
            element.className = 'ms-point-query-marker is-loading';
            element.setAttribute('role', 'status');
            element.setAttribute('aria-label', 'Sprawdzanie obiektów w wybranym punkcie');
            pointQueryMarker = new maplibregl.Marker({ element: element }).setLngLat([session.latlng.lng, session.latlng.lat]).addTo(map);
            listHoverLock = false;
            renderListPanel();
            for (var scrollNode = listContentEl; scrollNode && scrollNode !== document.body; scrollNode = scrollNode.parentElement) scrollNode.scrollTop = 0;
            setTab('list', { snap: 'full' });
        },
        onUpdate: function(session) {
            if (pointQueryMarker) {
                pointQueryMarker.getElement().classList.toggle('is-loading', session.loading);
                pointQueryMarker.getElement().setAttribute('aria-label', session.loading ? 'Sprawdzanie obiektów w wybranym punkcie' : 'Wybrany punkt');
            }
            renderListPanel();
            if (activeTab === 'nearby' && !selectedLatLng) renderPointNearbyChoice();
        },
    });

    function startPointQuery(latlng, point, hits) {
        if (!map || !latlng) return;
        return pointQuerySession.start(latlng, point || map.project([latlng.lng, latlng.lat]), hits);
    }

    function collectPointQueryHits(point, latlng) {
        point = map.project([latlng.lng, latlng.lat]);
        var hits = interactiveHitDispatcher.collectRenderedHits(point, latlng);
        // Listing markers are HTML; their parcel outlines and point proximity are
        // resolved separately from MapLibre's vector feature query.
        if (ogloszeniaActive && !listingViewAggregated) {
            var ids = new Set();
            var parcelLayers = ListingsLayer.PARCEL_LAYER_IDS.filter(function(id) { return !!map.getLayer(id); });
            if (parcelLayers.length) map.queryRenderedFeatures(point, { layers: parcelLayers }).forEach(function(feature) {
                ids.add(String(feature.properties.listing_id));
            });
            listingViewFeatures.forEach(function(feature) {
                if (!feature.geometry || feature.geometry.type !== 'Point') return;
                var pixel = map.project(feature.geometry.coordinates);
                if (ids.has(String(feature.properties.id)) || Math.hypot(pixel.x - point.x, pixel.y - point.y) <= 14) {
                    hits.push({ type: 'listing', id: String(feature.properties.id), properties: feature.properties, feature: feature });
                }
            });
        }
        return hits;
    }

    function getPointQuerySources(latlng) {
        var sources = [];
        if (meshCoverageRuntime.getDesired()) sources.push({
            key: 'widoki3d', types: ['meshCoverage'], label: 'Widoki 3D',
            request: signal => fetchMeshCoverage(BASE_URL, latlng, signal).then(data => [
                { type: 'meshCoverage', id: latlng.lat + ',' + latlng.lng, data: data }
            ]),
        });
        var query = qstr({ lat: latlng.lat, lng: latlng.lng });
        [
            ['parcel', dzialkiActive && mapZoom() >= DzialkiLayer.MIN_ZOOM, 'dzialki-hit', 'id_dzialki'],
            ['building', budynkiActive && mapZoom() >= BudynkiLayer.MIN_ZOOM, 'budynki-hit', 'id_budynku'],
            ['gunb', gunbActive && mapZoom() >= GunbLayer.INDIVIDUAL_ZOOM_THRESHOLD, 'gunb-rwdz-hit', 'id'],
        ].forEach(function(def) {
            if (!def[1]) return;
            sources.push({ key: def[0], types: [def[0]], request: function(signal) {
                var params = def[0] === 'gunb' ? getGunbFilterQueryString({ lat: latlng.lat, lng: latlng.lng }) : query;
                return fetch(BASE_URL + 'api/' + def[2] + '?' + params, { signal: signal }).then(function(response) {
                    if (!response.ok) throw new Error('HTTP ' + response.status);
                    return response.json();
                }).then(function(data) {
                    if (!data || !data.found) return [];
                    var features = def[0] === 'gunb' ? (data.features || []) : [{ properties: data.properties }];
                    return features.filter(function(feature) { return feature.properties && feature.properties[def[3]] != null; }).map(function(feature) {
                        return { type: def[0], id: String(feature.properties[def[3]]), properties: feature.properties, feature: feature };
                    });
                });
            } });
        });
        [
            ['transaction', transactionsController], ['listing', listingsController], ['otoczenie', otoczenieController],
            ['noise', noiseLayerRuntime.getController('noiseLdwn')], ['noise', noiseLayerRuntime.getController('noiseLn')],
            ['noise', noiseLayerRuntime.getController('noiseMonitoring')],
            ['education', educationLayerRuntime.getController()],
        ].forEach(function(def) {
            var layer = def[1];
            if (!layer || !layer.isActive() || !layer.canActivate()) return;
            if (['transaction', 'listing'].indexOf(def[0]) !== -1 && mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) return;
            sources.push({ key: layer.id, types: [def[0]], label: layer.constructor.DESCRIPTION,
                getState: function() {
                    if (!layer.isActive()) return 'empty';
                    var sourceId = layer.getSourceId();
                    if (layer.loadState === 'success' && map.getSource(sourceId) && !map.isSourceLoaded(sourceId)) return 'loading';
                    return layer.loadState || 'loading';
                },
                reload: function() { layer.load(); },
            });
        });
        if (kowrController && kowrController.canQueryFeatureInfo()) sources.push({
            key: 'kowr', types: ['kowr'], request: function(signal) {
                return kowrController.getFeatureInfo(latlng, { signal: signal }).then(function(data) {
                    return data && data.found ? [{ type: 'kowr', id: data.parcel.identifier, data: data }] : [];
                });
            },
        });
        // Overlay layers answer for the exact point at any zoom, so none of them waits behind a zoom gate.
        return sources.concat(layerPointQuerySources({
            latlng: latlng, zoom: mapZoom(), baseUrl: BASE_URL, getController: getOverlayController,
        }));
    }

    function getOverlayController(key) {
        return {
            mpzp: mpzpController, mpzpRu: mpzpRuController, pog: pogController, studium: studiumController,
            portPolska: portPolskaController, powodz: powodzController, gesut: gesutController, sidusis: sidusisController,
        }[key] || null;
    }

    // Switched-on layers that getPointQuerySources skipped at this zoom; mirrors
    // its thresholds so the empty point result can say what zooming in unlocks.
    function getPointQueryZoomGates(zoom) {
        var gates = {};
        function addGate(type, desired, minZoom) {
            if (!desired || zoom >= minZoom) return;
            if (!gates[type] || gates[type].minZoom > minZoom) gates[type] = { type: type, label: POINT_SOURCE_LABELS[type], minZoom: minZoom };
        }
        addGate('parcel', dzialkiDesired, DzialkiLayer.MIN_ZOOM);
        addGate('building', budynkiDesired, BudynkiLayer.MIN_ZOOM);
        addGate('gunb', gunbDesired, GunbLayer.INDIVIDUAL_ZOOM_THRESHOLD);
        [
            ['transaction', transactionsController], ['listing', listingsController], ['otoczenie', otoczenieController],
            ['noise', noiseLayerRuntime.getController('noiseLdwn')], ['noise', noiseLayerRuntime.getController('noiseLn')],
            ['noise', noiseLayerRuntime.getController('noiseMonitoring')],
            ['education', educationLayerRuntime.getController()],
        ].forEach(function(def) {
            var layer = def[1];
            if (!layer) return;
            var minZoom = layer.minZoom || 0;
            if (['transaction', 'listing'].indexOf(def[0]) !== -1) minZoom = Math.max(minZoom, INDIVIDUAL_ZOOM_THRESHOLD);
            addGate(def[0], layer.isDesired(), minZoom);
        });
        return Object.keys(gates).map(function(key) { return gates[key]; }).sort(function(a, b) {
            return a.minZoom - b.minZoom || Object.keys(POINT_SOURCE_LABELS).indexOf(a.type) - Object.keys(POINT_SOURCE_LABELS).indexOf(b.type);
        });
    }

    function schedulePointQueryRefresh() {
        if (!pointQuerySession || !pointQuerySession.get() || pointQueryRefreshScheduled || !map) return;
        pointQueryRefreshScheduled = true;
        map.once('render', function() {
            pointQueryRefreshScheduled = false;
            pointQuerySession.refresh();
        });
        map.triggerRepaint();
    }

    var listDataManager = createListDataManager({
        LIST_PER_PAGE: LIST_PER_PAGE,
        INDIVIDUAL_ZOOM_THRESHOLD: INDIVIDUAL_ZOOM_THRESHOLD,
        currentBbox: currentBbox,
        esc: esc,
        getApiFilters: getApiFilters,
        highlightTransactionById: highlightTransactionById,
        listContentEl: listContentEl,
        listMoreBtn: listMoreBtn,
        loadNearbyForSelection: loadNearbyForSelection,
        mapZoom: mapZoom,
        qstr: qstr,
        renderListPanel: renderListPanel,
        sortDir: sortDir,
        sortField: sortField,
        state: {
            getAbortList: function() { return abortList; },
            setAbortList: function(value) { abortList = value; },
            bumpListRequestVersion: function() {
                listRequestVersion += 1;
                return listRequestVersion;
            },
            getCurrentSort: function() { return currentSort; },
            getListRequestVersion: function() { return listRequestVersion; },
            getListRows: function() { return listRows; },
            setListRows: function(value) { listRows = value; },
            setListPage: function(value) { listPage = value; },
            setListTotal: function(value) { listTotal = value; },
            setListTotalEstimated: function(value) { listTotalEstimated = value; },
            setListHasMore: function(value) { listHasMore = value; },
            setListLoading: function(value) { listLoading = value; },
            setListError: function(value) { listError = value; },
            setListMoreFailed: function(value) { listMoreFailed = value; },
            getNearbyLoaded: function() { return nearbyLoaded; },
            getPendingNearbyRestore: function() { return pendingNearbyRestore; },
            getRowCoords: function() { return rowCoords; },
            setRowCoords: function(value) { rowCoords = value; },
            getSelectedLatLng: function() { return selectedLatLng; },
            setSelectedLatLng: function(value) { selectedLatLng = value; },
            getSelectedTid: function() { return selectedTid; },
            setSelectedTransactionRow: function(value) { selectedTransactionRow = value; },
        },
    });

    var transactionDetailManager = createTransactionDetailManager({
        BASE_URL: BASE_URL,
        getLatestGeoData: function() { return latestGeoData; },
        bringDataLayersToFront: bringDataLayersToFront,
        getMap: function() { return map; },
        getTransactionsController: function() { return transactionsController; },
        highlightTransactionById: highlightTransactionById,
        rebuildNearbyLinkIfNeeded: rebuildNearbyLinkIfNeeded,
        renderDetailsError: renderDetailsError,
        renderTransactionDetails: renderTransactionDetails,
        state: {
            getAbortDetail: function() { return abortDetail; },
            setAbortDetail: function(value) { abortDetail = value; },
            getDetailCache: function() { return detailCache; },
            getSelectedTid: function() { return selectedTid; },
            setSelectedLatLng: function(value) { selectedLatLng = value; },
        },
    });

    var nearbyManager = createNearbyManager({
        bringDataLayersToFront: bringDataLayersToFront,
        clearSelectionPin: function() {
            if (selectionPinController) {
                selectionPinController.clear();
            } else if (selectionPinLayer && map) {
                removeSourceAndLayers(map, SelectionPinLayer.SOURCE_ID, SelectionPinLayer.LAYER_IDS);
            }
            selectionPinLayer = null;
        },
        consumeHandledMapClick: consumeHandledMapClick,
        getHasActiveBdot10kFilters: hasActiveBdot10kFilters,
        getCurrentSheetSnap: getCurrentSheetSnap,
        getMap: function() { return map; },
        getMapPaddingForPanel: getMapPaddingForPanel,
        isDesktopLayout: isDesktopLayout,
        loadSelectionPin: loadSelectionPin,
        mapZoom: mapZoom,
        messages: window.RCN_NEARBY_GROUP_I18N || {},
        nearbyContentEl: nearbyContentEl,
        getBdot10kFilterQueryString: getBdot10kFilterQueryString,
        nearbyMetaEl: nearbyMetaEl,
        getReferenceLabel: function() { return nearbyPointReference === selectedLatLng && nearbyPointReference ? 'Otoczenie wskazanego punktu' : ''; },
        setSheetSnap: setSheetSnap,
        setTab: setTab,
        syncNearbyHalfSnap: syncNearbyHalfSnap,
        state: {
            getAbortNearby: function() { return abortNearby; },
            setAbortNearby: function(value) { abortNearby = value; },
            getActiveNearbyId: function() { return activeNearbyId; },
            setActiveNearbyId: function(value) { activeNearbyId = value; },
            getActiveNearbyItem: function() { return activeNearbyItem; },
            setActiveNearbyItem: function(value) { activeNearbyItem = value; },
            getActiveTab: function() { return activeTab; },
            getNearbyItems: function() { return nearbyItems; },
            setNearbyItems: function(value) { nearbyItems = value; },
            getNearbyLayer: function() { return nearbyLayer; },
            setNearbyLayer: function(value) { nearbyLayer = value; },
            getNearbyLinkLayer: function() { return nearbyLinkLayer; },
            setNearbyLinkLayer: function(value) { nearbyLinkLayer = value; },
            getNearbyLoaded: function() { return nearbyLoaded; },
            setNearbyLoaded: function(value) { nearbyLoaded = !!value; },
            getSelectedLatLng: function() { return selectedLatLng; },
        },
        syncUrl: syncUrl,
    });

    personaModule = createPersonaModule({
        bringDataLayersToFront: bringDataLayersToFront,
        consumeHandledMapClick: consumeHandledMapClick,
        detailsEndpointUrl: window.RCN_NEIGHBORHOOD_PERSONA_SIGNAL_DETAILS_URL || 'api/neighborhood-persona-signal-details',
        endpointUrl: window.RCN_NEIGHBORHOOD_PERSONAS_URL || 'api/neighborhood-personas',
        getMap: function() { return map; },
        getMapPaddingForPanel: getMapPaddingForPanel,
        getSelectedLatLng: function() { return selectedLatLng; },
        messages: window.RCN_PERSONA_I18N || {},
        nearbyContentEl: nearbyContentEl,
        nearbyMetaEl: nearbyMetaEl,
        prepareNearbyForHighlight: nearbyManager.prepareForExternalHighlight,
        refreshNearbyMeta: refreshNearbyMeta,
        renderNearbyList: renderNearbyList,
        setNearbyContextDimmed: nearbyManager.setExternalContextDimmed,
        setTab: setTab,
        triggerBtn: personaBtn,
    });

    var consumedMapClickOriginalEvent = null;
    var consumedMapClickPoint = null;
    var consumedMapClickAt = 0;

    var overlapLayer = null;
    var overlapGroupsCache = [];
    var overlapBrowseFeatures = null;
    var overlapBrowseLatlng = null;
    var combinedBrowseTransactions = null;
    var combinedBrowseGunb = null;
    var combinedBrowseOtherHits = null;
    var combinedBrowseLatlng = null;
    var tapBrowseHits = null;
    var tapBrowseLatlng = null;
    var pendingTapBrowseRestore = false;
    var tapBrowseRestoreScheduled = false;

    var abortGeo = null;
    var abortSignals = null;
    var abortListings = null;
    var abortDeveloperOffers = null;
    var abortListingDetail = null;
    var abortList = null;
    var abortDetail = null;
    var abortNearby = null;
    var abortDzialki = null;
    var abortBudynki = null;
    var abortGunb = null;
    var abortMpzpRu = null;
    var abortOtoczenie = null;
    var abortSelectionPin = null;
    var abortParcelHit = null;
    var abortTapResolver = null;
    var geoRequestVersion = 0;
    var listRequestVersion = 0;
    var parcelHitRequestVersion = 0;

    function consumeHandledMapClick(event) {
        if (pointQuerySession) pointQuerySession.cancel();
        consumedMapClickOriginalEvent = event && event.originalEvent ? event.originalEvent : null;
        consumedMapClickPoint = event && event.point
            ? { x: event.point.x, y: event.point.y }
            : null;
        consumedMapClickAt = Date.now();
        var handledAt = consumedMapClickAt;
        setTimeout(function() {
            if (consumedMapClickAt !== handledAt) return;
            consumedMapClickOriginalEvent = null;
            consumedMapClickPoint = null;
            consumedMapClickAt = 0;
        }, 0);
        if (interactiveHitDispatcher) {
            interactiveHitDispatcher.clearClickMarker();
        }
        if (tapResolutionManager) {
            tapResolutionManager.abortCurrentRequest();
        }
    }

    function shouldIgnoreMapClick(event) {
        var sameOriginalEvent = !!(
            consumedMapClickOriginalEvent
            && event
            && event.originalEvent
            && consumedMapClickOriginalEvent === event.originalEvent
        );
        var sameRecentPoint = !!(
            consumedMapClickPoint
            && event
            && event.point
            && Date.now() - consumedMapClickAt < 500
            && Math.abs(consumedMapClickPoint.x - event.point.x) <= 1
            && Math.abs(consumedMapClickPoint.y - event.point.y) <= 1
        );

        consumedMapClickOriginalEvent = null;
        consumedMapClickPoint = null;
        consumedMapClickAt = 0;
        return sameOriginalEvent || sameRecentPoint;
    }

    function isNearbyFeatureMapClick(event) {
        if (activeTab !== 'nearby' || !map || !event || !event.point) return false;
        var nearbyClickLayers = [
            'lyr-nearby-power-line-buffer-fill',
            'lyr-nearby-power-line-buffer-line',
            'lyr-nearby-fill',
            'lyr-nearby-line',
            'lyr-nearby-linestring',
            'lyr-nearby-circle'
        ].filter(function(layerId) { return !!map.getLayer(layerId); });
        if (!nearbyClickLayers.length) return false;
        return map.queryRenderedFeatures(event.point, { layers: nearbyClickLayers }).length > 0;
    }

    function getInteractiveMapClickLayerIds() {
        var layerIds = [
            TransactionsLayer.BASE_LAYER_IDS[0],
            TransactionsLayer.BASE_LAYER_IDS[1],
            TransactionsLayer.HIT_LAYER_ID,
            'lyr-otoczenie-fill',
            'lyr-otoczenie-power-line-buffer-fill',
            'lyr-otoczenie-power-line-buffer-line',
            'lyr-otoczenie-linestring',
            'lyr-otoczenie-circle',
            'lyr-nearby-fill',
            'lyr-nearby-power-line-buffer-fill',
            'lyr-nearby-power-line-buffer-line',
            'lyr-nearby-linestring',
            'lyr-nearby-circle',
            'lyr-search-circle'
        ];

        if (isDesktopLayout()) {
            layerIds = layerIds.concat([
                BudynkiLayer.BASE_LAYER_IDS[0],
                GunbLayer.BASE_LAYER_IDS[0]
            ]);
        }

        if (!map) {
            return [];
        }

        return layerIds.filter(function(layerId) {
            return !!map.getLayer(layerId);
        });
    }

    function hasHandledFeatureAtClickPoint(point) {
        if (!map || !point) {
            return false;
        }

        var layerIds = getInteractiveMapClickLayerIds();
        if (!layerIds.length) {
            return false;
        }

        try {
            return map.queryRenderedFeatures(point, { layers: layerIds }).length > 0;
        } catch (_error) {
            return false;
        }
    }
    var tapResolverRequestVersion = 0;

    function midpointLatLng(a, b) {
        if (!a || !b) return null;
        return midpoint(a, b);
    }

    function currentBbox(padding) {
        return bboxString(map.getBounds(), padding != null ? padding : 0.08, BBOX_DECIMALS);
    }

    function showMapLoading(show) {
        if (!mapLoadingEl) return;
        mapLoadingEl.classList.toggle('is-visible', !!show);
    }

    // Result-list loading indicator — a thin bar on the list panel. Needed
    // because the smooth (non-flickering) list update otherwise gives no hint
    // that a refresh is in progress.
    var listLoadingHideTimer = null;
    var listLoadingMaxTimer = null;

    function hideListLoadingIndicator() {
        if (!listLoadingBarEl) return;
        listLoadingBarEl.classList.remove('is-loading');
        if (listLoadingHideTimer) { clearTimeout(listLoadingHideTimer); listLoadingHideTimer = null; }
        if (listLoadingMaxTimer) { clearTimeout(listLoadingMaxTimer); listLoadingMaxTimer = null; }
    }

    function showListLoadingIndicator() {
        if (!listLoadingBarEl) return;
        // While the pointer rests on the list the list itself is frozen, so a
        // loading bar would be misleading — the indicator is held back and
        // shown only once the pointer leaves and the list actually refreshes.
        if (listHoverLock) return;
        if (listLoadingHideTimer) { clearTimeout(listLoadingHideTimer); listLoadingHideTimer = null; }
        listLoadingBarEl.classList.add('is-loading');
        if (!listLoadingMaxTimer) {
            // Safety net so the bar can never get stuck on.
            listLoadingMaxTimer = setTimeout(hideListLoadingIndicator, 9000);
        }
    }

    function scheduleListLoadingHide() {
        if (!listLoadingBarEl || !listLoadingBarEl.classList.contains('is-loading')) return;
        if (listLoadingHideTimer) clearTimeout(listLoadingHideTimer);
        listLoadingHideTimer = setTimeout(function() {
            listLoadingHideTimer = null;
            hideListLoadingIndicator();
        }, 240);
    }

    function updateLimitedBanner() {
        if (!limitedBannerEl) return;
        limitedBannerEl.hidden = !(LIMITED_MODE && mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD);
    }

    function getLayerToggleEl(layerKey) {
        return layerPanel ? layerPanel.getToggleEl(layerKey) : null;
    }

    function getLayerPanelState() {
        return {
            orthoActive: orthoActive,
            orthoDesired: orthoDesired,
            mpzpActive: mpzpActive,
            mpzpDesired: mpzpDesired,
            mpzpRuActive: mpzpRuActive,
            mpzpRuDesired: mpzpRuDesired,
            pogActive: pogActive,
            pogDesired: pogDesired,
            studiumActive: studiumActive,
            studiumDesired: studiumDesired,
            powodzActive: powodzActive,
            powodzDesired: powodzDesired,
            gesutActive: gesutActive,
            gesutDesired: gesutDesired,
            portPolskaActive: portPolskaActive,
            portPolskaDesired: portPolskaDesired,
            sidusisActive: sidusisActive,
            sidusisDesired: sidusisDesired,
            dzialkiActive: dzialkiActive,
            dzialkiDesired: dzialkiDesired,
            budynkiActive: budynkiActive,
            budynkiDesired: budynkiDesired,
            gunbActive: gunbActive,
            gunbDesired: gunbDesired,
            sygnalyActive: sygnalyActive,
            sygnalyDesired: sygnalyDesired,
            ogloszeniaActive: ogloszeniaActive,
            ogloszeniaDesired: ogloszeniaDesired,
            ofertyDeweloperowActive: ofertyDeweloperowActive,
            ofertyDeweloperowDesired: ofertyDeweloperowDesired,
            transakcjeActive: transakcjeActive,
            transakcjeDesired: transakcjeDesired,
            otoczenieActive: otoczenieActive,
            otoczenieDesired: otoczenieDesired
        };
    }

    function applyTheme() {
        html.setAttribute('data-theme', 'light');
    }



    function syncOrthoToggleVisibility() {
        if (orthoController) {
            orthoController.syncVisibility();
        }
    }

    function toggleOrthoLayer() {
        if (orthoController) {
            orthoController.toggle();
        }
    }


    function syncGesutToggleVisibility() {
        if (gesutController) {
            gesutController.syncVisibility();
        }
    }

    function syncPortPolskaToggleVisibility() {
        if (portPolskaController) {
            portPolskaController.syncVisibility();
        }
    }

    function syncSidusisToggleVisibility() {
        if (sidusisController) {
            sidusisController.syncVisibility();
        }
    }

    function bringDataLayersToFront() {
        if (!map) return;
        ensureLayerOrder(map, []
            .concat(MpzpImportedLayer.RENDER_ORDER_LAYER_IDS)
            .concat(OwnershipLayer.LAYER_IDS)
            .concat(LandUseLayer.LAYER_IDS)
            .concat(getParcelBaseLayerIds())
            .concat(['lyr-nearby-power-line-buffer-fill', 'lyr-nearby-power-line-buffer-line', 'lyr-nearby-fill', 'lyr-nearby-line', 'lyr-nearby-linestring'])
            .concat(GunbLayer.BASE_LAYER_IDS)
            .concat(EducationFacilitiesLayer.LAYER_IDS)
            .concat(TransactionsLayer.BASE_LAYER_IDS)
            .concat(SignalsLayer.RADIUS_LAYER_IDS)
            .concat(ListingsLayer.BASE_LAYER_IDS)
            .concat(TransactionsLayer.HIGHLIGHT_RENDER_ORDER)
            .concat(BudynkiLayer.BASE_LAYER_IDS)
            .concat(['lyr-otoczenie-power-line-buffer-fill', 'lyr-otoczenie-power-line-buffer-line', 'lyr-otoczenie-fill', 'lyr-otoczenie-line', 'lyr-otoczenie-linestring', 'lyr-otoczenie-circle'])
            .concat(['lyr-persona-highlight-fill', 'lyr-persona-highlight-polygon-casing', 'lyr-persona-highlight-line', 'lyr-persona-highlight-linestring-casing', 'lyr-persona-highlight-linestring', 'lyr-persona-highlight-circle'])
            .concat(DzialkiLayer.SELECTED_LAYER_IDS)
            .concat([
                'lyr-parcel-measure-house-fill',
                'lyr-parcel-measure-house-line',
                'lyr-parcel-measure-road-selection',
                'lyr-parcel-measure-inset',
                'lyr-parcel-measure-leader',
                'lyr-parcel-measure-endpoint',
                'lyr-parcel-measure-label',
                'lyr-parcel-measure-house-label',
                'lyr-parcel-measure-house-violation',
            ])
            .concat(BudynkiLayer.SELECTED_LAYER_IDS)
            .concat(GunbLayer.SELECTED_LAYER_IDS)
            .concat(SelectionPinLayer.LAYER_IDS)
            .concat(['lyr-nearby-circle'])
            .concat(['lyr-nearby-link-casing', 'lyr-nearby-link-line'])
            .concat(CLICK_MARKER_LAYER_IDS));
    }

    function toggleGesutLayer() {
        if (gesutController) {
            gesutController.toggle();
        }
    }

    function togglePortPolskaLayer() {
        if (portPolskaController) {
            portPolskaController.toggle();
        }
    }

    function toggleSidusisLayer() {
        if (sidusisController) {
            sidusisController.toggle();
        }
    }




    function syncMpzpToggleVisibility() {
        if (mpzpController) {
            mpzpController.syncVisibility();
        }
    }

    function toggleMpzpLayer() {
        if (mpzpController) {
            mpzpController.toggle();
        }
    }

    function renderMpzpRuData(_data, layer) {
        bringDataLayersToFront();
        return layer;
    }

    function loadMpzpRu() {
        if (mpzpRuController) {
            mpzpRuController.load();
        }
    }

    function syncMpzpRuToggleVisibility() {
        if (mpzpRuController) {
            mpzpRuController.syncVisibility();
        }
    }

    function toggleMpzpRuLayer() {
        if (mpzpRuController) {
            mpzpRuController.toggle();
        }
    }

    function syncPogToggleVisibility() {
        if (pogController) {
            pogController.syncVisibility();
        }
    }

    function togglePogLayer() {
        if (pogController) {
            pogController.toggle();
        }
    }


    function syncStudiumToggleVisibility() {
        if (studiumController) {
            studiumController.syncVisibility();
        }
    }

    function toggleStudiumLayer() {
        if (studiumController) {
            studiumController.toggle();
        }
    }


    function syncPowodzToggleVisibility() {
        if (powodzController) {
            powodzController.syncVisibility();
        }
    }

    function togglePowodzLayer() {
        if (powodzController) {
            powodzController.toggle();
        }
    }

    function syncTransakcjeToggleVisibility() {
        if (transactionsController) {
            transactionsController.syncVisibility();
        }
    }

    function renderSignalsData(data) {
        if (data && data.aggregated === true) {
            signalsViewAggregated = true;
            signalsViewFeatures = [];
        } else {
            signalsViewAggregated = false;
            signalsViewFeatures = (data && Array.isArray(data.features)) ? data.features.slice() : [];
        }

        if (selectedSignalContext && selectedSignalContext.selectedSignalId != null) {
            loadSignalsForContext(selectedSignalContext);
        }

        bringDataLayersToFront();

        if (sygnalyActive && listSubTab === 'sygnaly') {
            renderListPanel();
        }
        reapplyHoverMarkerHighlight();

        return sygnalyLayer;
    }

    function loadSignals() {
        if (!signalsController) {
            return;
        }

        signalsController.load();
    }

    function syncSignalsToggleVisibility() {
        if (signalsController) {
            signalsController.syncVisibility();
        }
    }

    function toggleSignalsLayer() {
        if (signalsController) {
            signalsController.toggle();
        }
        if (!sygnalyActive) {
            signalsViewFeatures = [];
            signalsViewAggregated = false;
        }
        renderListPanel();
    }

    function listingFilterFieldVisible(field, state) {
        if (!field) return true;
        if (field === 'base' || field === 'created_days' || field === 'description_query' || field === 'has_photos' || field === 'advertiser_type') {
            return true;
        }

        state = state || filterState;
        var visibilityRules = window.RCN_PROPERTY_LISTING_FILTER_VISIBILITY || {};
        var category = state.listing_category || '';
        var offerType = state.listing_offer_type || '';
        var categoryHidden = visibilityRules.categories && visibilityRules.categories[category] || [];
        var offerHidden = visibilityRules.offers && visibilityRules.offers[offerType] || [];
        return categoryHidden.indexOf(field) === -1 && offerHidden.indexOf(field) === -1;
    }

    function syncListingFilterVisibility() {
        document.querySelectorAll('[data-listing-filter-field]').forEach(function(el) {
            var visible = listingFilterFieldVisible(el.getAttribute('data-listing-filter-field') || '');
            el.hidden = !visible;
        });
    }

    function syncListingFilterTags() {
        document.querySelectorAll('[data-listing-select-target]').forEach(function(el) {
            var input = document.getElementById(el.getAttribute('data-listing-select-target') || '');
            var value = el.getAttribute('data-listing-select-value') || '';
            var active = input && String(input.value || '') === value;
            el.classList.toggle('is-active', !!active);
            el.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
    }

    function addVisibleListingParam(params, field, key, value, state) {
        if (listingFilterFieldVisible(field, state) && value) {
            params[key] = value;
        }
    }

    function setAddressReference(item) {
        if (!item || !item.type || item.lat == null || item.lng == null) {
            filterState.address_ref_type = '';
            filterState.address_ref_id = '';
            filterState.address_ref_lat = '';
            filterState.address_ref_lng = '';
            filterState.address_ref_bbox = '';
            return;
        }
        filterState.address_query = item.nazwa || '';
        filterState.address_ref_type = item.type;
        filterState.address_ref_id = item.id != null ? String(item.id) : '';
        filterState.address_ref_lat = String(item.lat);
        filterState.address_ref_lng = String(item.lng);
        filterState.address_ref_bbox = Array.isArray(item.bbox) ? item.bbox.join(',') : '';
        if (item.type === 'bdot_area') {
            filterState.address_radius_km = '';
            if (addressRadiusKmInput) addressRadiusKmInput.value = '';
        } else if (!filterState.address_radius_km) {
            filterState.address_radius_km = '1';
            if (addressRadiusKmInput) addressRadiusKmInput.value = '1';
        }
        updateSearchRadiusCircles();
    }

    function setListingLocationReference(item) {
        if (listingRadiusKmInput) listingRadiusKmInput.disabled = !!item && isListingAreaReference(item.type);
        if (!item || !item.type || item.lat == null || item.lng == null) {
            filterState.listing_location_ref_type = '';
            filterState.listing_location_ref_id = '';
            filterState.listing_location_ref_lat = '';
            filterState.listing_location_ref_lng = '';
            filterState.listing_location_ref_bbox = '';
            return;
        }
        filterState.listing_location_query = item.nazwa || '';
        filterState.listing_location_ref_type = item.type;
        filterState.listing_location_ref_id = item.id != null ? String(item.id) : '';
        filterState.listing_location_ref_lat = String(item.lat);
        filterState.listing_location_ref_lng = String(item.lng);
        filterState.listing_location_ref_bbox = Array.isArray(item.bbox) ? item.bbox.join(',') : '';
        if (isListingAreaReference(item.type)) {
            filterState.listing_radius_km = '';
            if (listingRadiusKmInput) listingRadiusKmInput.value = '';
        } else if (!filterState.listing_radius_km) {
            filterState.listing_radius_km = '1';
            if (listingRadiusKmInput) listingRadiusKmInput.value = '1';
        }
        updateSearchRadiusCircles();
    }

    function locationSuggestionMeta(item) {
        var context = [item.miejscowosc, item.gmina, item.powiat, item.wojewodztwo].filter(Boolean);
        return context.filter(function(value, index) {
            return context.indexOf(value) === index;
        }).join(', ');
    }

    var LOCATION_SECTION_ORDER = ['area', 'address', 'street', 'locality', 'bdot_area', 'place'];

    function locationTypeLabel(type) {
        if (type === 'locality') return 'Miejscowość';
        if (type === 'street') return 'Ulica';
        if (type === 'place') return 'Plac';
        if (type === 'address') return 'Adres';
        if (type === 'bdot_area') return 'Nazwany obszar';
        if (type === 'gmina') return 'Granice miasta lub gminy';
        return '';
    }

    function locationSectionTitle(type) {
        if (type === 'area') return 'Obszary';
        if (type === 'address') return 'Adresy';
        if (type === 'street') return 'Ulice';
        if (type === 'locality') return 'Miejscowości';
        if (type === 'bdot_area') return 'Nazwane obszary';
        if (type === 'place') return 'Place';
        return '';
    }

    function locationSectionIcon(type) {
        if (type === 'area') return 'town';
        if (type === 'address') return 'pin';
        if (type === 'street') return 'road';
        if (type === 'locality') return 'town';
        if (type === 'bdot_area') return 'town';
        if (type === 'place') return 'place';
        return 'loc';
    }

    function geometryKindLabel(kind) {
        if (kind === 'point') return 'Punkt';
        if (kind === 'line') return 'Linia';
        if (kind === 'area') return 'Obszar';
        return '';
    }

    function formatLocationHitCount(total, query) {
        var word = 'trafień';
        if (total === 1) {
            word = 'trafienie';
        } else if (total % 10 >= 2 && total % 10 <= 4 && (total % 100 < 10 || total % 100 >= 20)) {
            word = 'trafienia';
        }
        return total + ' ' + word + ' dla „' + query + '”';
    }

    function renderLocationSuggestHtml(items, query, pickAttr) {
        if (!items.length) {
            return '<div class="nm-search-empty">Brak wyników dla „' + esc(query) + '”</div>';
        }
        var groups = {};
        items.forEach(function(item, index) {
            var type = pickAttr === 'data-listing-location-pick' && isListingAreaReference(item.type)
                ? 'area' : item.type || 'other';
            if (!groups[type]) groups[type] = [];
            groups[type].push(index);
        });
        var orderedTypes = LOCATION_SECTION_ORDER.filter(function(type) { return groups[type]; });
        Object.keys(groups).forEach(function(type) {
            if (orderedTypes.indexOf(type) === -1) orderedTypes.push(type);
        });
        var htmlString = '<div class="nm-search-summary">' + esc(formatLocationHitCount(items.length, query)) + '</div>';
        orderedTypes.forEach(function(type) {
            var title = locationSectionTitle(type);
            var iconName = locationSectionIcon(type);
            htmlString += '<div class="nm-search-section" data-type="' + esc(type) + '">';
            if (title) {
                htmlString += '<div class="nm-search-section-title">' + esc(title) + '</div>';
            }
            groups[type].forEach(function(index) {
                var item = items[index];
                var typeLabel = locationTypeLabel(item.type);
                var kindLabel = geometryKindLabel(item.geometry_kind);
                var locationMeta = locationSuggestionMeta(item);
                var metaParts = [typeLabel, kindLabel];
                if (isListingAreaReference(item.type) && item.rodzaj) {
                    metaParts.push(item.rodzaj);
                }
                if (locationMeta) {
                    metaParts.push(locationMeta);
                }
                var meta = metaParts.filter(Boolean).join(' · ');
                htmlString += '<button class="nm-search-item" type="button" ' + pickAttr + '="' + index + '">'
                    + '<span class="nm-search-item-icon nm-search-item-icon--' + esc(type) + '">'
                    + iconMarkup(iconName, { size: 18 })
                    + '</span>'
                    + '<span class="nm-search-item-body">'
                    + '<span class="nm-search-item-name">' + esc(item.nazwa || '') + '</span>'
                    + (meta ? '<span class="nm-search-item-meta">' + esc(meta) + '</span>' : '')
                    + '</span>'
                    + '</button>';
            });
            htmlString += '</div>';
        });
        return htmlString;
    }

    function setupTransactionAddressAutocomplete() {
        if (!addressInput || !addressSuggestEl) {
            return;
        }
        var timer = null;
        var requestSeq = 0;
        var close = function() {
            addressSuggestEl.hidden = true;
            addressSuggestEl.innerHTML = '';
        };
        var render = function(items, query) {
            addressSuggestEl.innerHTML = renderLocationSuggestHtml(items, query, 'data-address-filter-pick');
            addressSuggestEl.hidden = false;
            addressSuggestEl._items = items;
        };

        addressInput.addEventListener('input', function() {
            var query = addressInput.value.trim();
            if (query !== (filterState.address_query || '')) {
                setAddressReference(null);
            }
            if (timer) clearTimeout(timer);
            if (query.length < 2) {
                close();
                return;
            }
            timer = setTimeout(function() {
                var seq = ++requestSeq;
                fetch(MIEJSCOWOSCI_URL + '?q=' + encodeURIComponent(query) + '&limit=12&types=' + encodeURIComponent('locality,street,place,address,bdot_area'))
                    .then(function(response) { return response.json(); })
                    .then(function(data) {
                        if (seq !== requestSeq || addressInput.value.trim() !== query) {
                            return;
                        }
                        render((data.items || []).filter(function(item) {
                            return item.lat != null && item.lng != null;
                        }), query);
                    })
                    .catch(close);
            }, 220);
        });

        addressSuggestEl.addEventListener('click', function(event) {
            var button = event.target.closest('[data-address-filter-pick]');
            if (!button || button.disabled) {
                return;
            }
            var items = addressSuggestEl._items || [];
            var item = items[parseInt(button.getAttribute('data-address-filter-pick') || '-1', 10)];
            if (!item) {
                return;
            }
            addressInput.value = item.nazwa || '';
            setAddressReference(item);
            close();
            addressInput.focus();
        });

        document.addEventListener('click', function(event) {
            if (!event.target.closest('#nm-f-address, #nm-f-address-suggest')) {
                close();
            }
        });
    }

    function setupListingLocationAutocomplete() {
        if (!listingLocationQueryInput || !listingLocationSuggestEl) {
            return;
        }
        var timer = null;
        var requestSeq = 0;
        var close = function() {
            listingLocationSuggestEl.hidden = true;
            listingLocationSuggestEl.innerHTML = '';
        };
        var render = function(items, query) {
            listingLocationSuggestEl.innerHTML = renderLocationSuggestHtml(items, query, 'data-listing-location-pick');
            listingLocationSuggestEl.hidden = false;
            listingLocationSuggestEl._items = items;
        };

        listingLocationQueryInput.addEventListener('input', function() {
            var query = listingLocationQueryInput.value.trim();
            if (query !== (filterState.listing_location_query || '')) {
                setListingLocationReference(null);
            }
            if (timer) clearTimeout(timer);
            if (query.length < 2) {
                close();
                return;
            }
            timer = setTimeout(function() {
                var seq = ++requestSeq;
                fetch(MIEJSCOWOSCI_URL + '?q=' + encodeURIComponent(query) + '&limit=12&types=' + encodeURIComponent('locality,street,place,address,bdot_area,gmina'))
                    .then(function(response) { return response.json(); })
                    .then(function(data) {
                        if (seq !== requestSeq || listingLocationQueryInput.value.trim() !== query) {
                            return;
                        }
                        render((data.items || []).filter(function(item) {
                            return item.lat != null && item.lng != null;
                        }), query);
                    })
                    .catch(close);
            }, 220);
        });

        listingLocationSuggestEl.addEventListener('click', function(event) {
            var button = event.target.closest('[data-listing-location-pick]');
            if (!button || button.disabled) {
                return;
            }
            var items = listingLocationSuggestEl._items || [];
            var item = items[parseInt(button.getAttribute('data-listing-location-pick') || '-1', 10)];
            if (!item) {
                return;
            }
            listingLocationQueryInput.value = item.nazwa || '';
            setListingLocationReference(item);
            close();
            listingLocationQueryInput.focus();
        });

        document.addEventListener('click', function(event) {
            if (!event.target.closest('#nm-f-listing-location-query, #nm-f-listing-location-suggest')) {
                close();
            }
        });
    }

    var egibLocationReferences = {
        parcels: null,
        buildings: null,
    };
    var egibMapBounds = {
        parcels: null,
        buildings: null,
    };

    function egibMapScopeElements(scope) {
        return scope === 'parcels'
            ? {
                input: parcelLocationQueryInput,
                button: parcelUseMapBoundsBtn,
                status: parcelMapBoundsStatusEl,
            }
            : {
                input: buildingLocationQueryInput,
                button: buildingUseMapBoundsBtn,
                status: buildingMapBoundsStatusEl,
            };
    }

    function clearEgibMapBounds(scope) {
        egibMapBounds[scope] = null;
        var elements = egibMapScopeElements(scope);
        if (elements.button) {
            elements.button.classList.remove('is-active');
            elements.button.removeAttribute('aria-pressed');
        }
        if (elements.status) {
            elements.status.textContent = 'Przycisk zapamięta aktualne granice mapy i użyje ich razem z pozostałymi kryteriami.';
        }
    }

    function captureEgibMapBounds(scope) {
        if (!map) {
            return;
        }
        var bounds = map.getBounds();
        egibMapBounds[scope] = {
            west: bounds.getWest(),
            south: bounds.getSouth(),
            east: bounds.getEast(),
            north: bounds.getNorth(),
        };
        egibLocationReferences[scope] = null;
        var elements = egibMapScopeElements(scope);
        if (elements.input) {
            elements.input.value = '';
        }
        if (elements.button) {
            elements.button.classList.add('is-active');
            elements.button.setAttribute('aria-pressed', 'true');
        }
        if (elements.status) {
            elements.status.textContent = 'Ustawiono widoczny obszar mapy przy powiększeniu '
                + fmt(map.getZoom(), 1) + '. Kliknij ponownie, aby zaktualizować granice.';
        }
        setFilterInputsPending(true);
    }

    function setupEgibMapBoundsButtons() {
        [
            { scope: 'parcels', button: parcelUseMapBoundsBtn },
            { scope: 'buildings', button: buildingUseMapBoundsBtn },
        ].forEach(function(config) {
            if (!config.button) return;
            config.button.addEventListener('click', function() {
                captureEgibMapBounds(config.scope);
            });
        });
    }

    function setupTokenField(hiddenInput, editor, valuesEl, normalizer, unitLabel) {
        if (!hiddenInput || !editor || !valuesEl) {
            return;
        }
        var values = [];
        var render = function() {
            hiddenInput.value = values.join(';');
            valuesEl.innerHTML = values.map(function(value, index) {
                var removeLabel = 'Usuń wartość ' + value + (unitLabel ? ' ' + unitLabel : '');
                return '<span class="nm-token-field__token">'
                    + '<span>' + esc(value) + (unitLabel ? ' <small>' + esc(unitLabel) + '</small>' : '') + '</span>'
                    + '<button type="button" data-token-remove="' + index + '" aria-label="' + esc(removeLabel) + '">×</button>'
                    + '</span>';
            }).join('');
            valuesEl.hidden = values.length === 0;
        };
        var addValues = function(rawValues) {
            var changed = false;
            rawValues.forEach(function(rawValue) {
                if (values.length >= 8) return;
                var value = normalizer(rawValue);
                if (!value || values.indexOf(value) !== -1) return;
                values.push(value);
                changed = true;
            });
            if (changed) {
                render();
                setFilterInputsPending(true);
            }
        };
        var commit = function() {
            var raw = editor.value.trim();
            if (!raw) return;
            addValues(raw.split(/[\s,;]+/u));
            editor.value = '';
        };

        editor.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ';' || event.key === ',') {
                event.preventDefault();
                commit();
            } else if (event.key === 'Backspace' && editor.value === '' && values.length) {
                values.pop();
                render();
                setFilterInputsPending(true);
            }
        });
        editor.addEventListener('blur', commit);
        editor.addEventListener('paste', function() {
            setTimeout(function() {
                if (/[\s,;\n]/u.test(editor.value)) {
                    commit();
                }
            }, 0);
        });
        valuesEl.addEventListener('click', function(event) {
            var button = event.target.closest('[data-token-remove]');
            if (!button) return;
            var index = parseInt(button.getAttribute('data-token-remove') || '-1', 10);
            if (index < 0 || index >= values.length) return;
            values.splice(index, 1);
            render();
            setFilterInputsPending(true);
            editor.focus();
        });

        hiddenInput._tokenField = {
            clear: function() {
                values = [];
                editor.value = '';
                render();
            },
        };
        render();
    }

    function setupEgibLocationAutocomplete(input, suggestEl, scope, pickAttr) {
        if (!input || !suggestEl) {
            return;
        }
        var timer = null;
        var requestSeq = 0;
        var close = function() {
            suggestEl.hidden = true;
            suggestEl.innerHTML = '';
        };

        input.addEventListener('input', function() {
            egibLocationReferences[scope] = null;
            if (timer) clearTimeout(timer);
            var query = input.value.trim();
            if (query.length < 2) {
                close();
                return;
            }
            timer = setTimeout(function() {
                var seq = ++requestSeq;
                fetch(MIEJSCOWOSCI_URL + '?q=' + encodeURIComponent(query) + '&limit=12&types=' + encodeURIComponent('locality,street,place,address,bdot_area'))
                    .then(function(response) { return response.json(); })
                    .then(function(data) {
                        if (seq !== requestSeq || input.value.trim() !== query) {
                            return;
                        }
                        var items = (data.items || []).filter(function(item) {
                            return item.id != null && item.type && item.lat != null && item.lng != null;
                        });
                        suggestEl._items = items;
                        suggestEl.innerHTML = renderLocationSuggestHtml(items, query, pickAttr);
                        suggestEl.hidden = false;
                    })
                    .catch(close);
            }, 220);
        });

        suggestEl.addEventListener('click', function(event) {
            var button = event.target.closest('[' + pickAttr + ']');
            if (!button || button.disabled) {
                return;
            }
            var item = (suggestEl._items || [])[parseInt(button.getAttribute(pickAttr) || '-1', 10)];
            if (!item) {
                return;
            }
            input.value = item.nazwa || '';
            egibLocationReferences[scope] = item;
            clearEgibMapBounds(scope);
            close();
            setFilterInputsPending(true);
            input.focus();
        });

        document.addEventListener('click', function(event) {
            if (!event.target.closest('#' + input.id + ', #' + suggestEl.id)) {
                close();
            }
        });
    }

    function addEgibLocationParams(params, scope) {
        var location = egibLocationReferences[scope];
        if (!location) {
            return;
        }
        params.set('location_type', location.type);
        params.set('location_id', String(location.id));
    }

    function addEgibMapBoundsParams(params, scope) {
        var bounds = egibMapBounds[scope];
        if (!bounds) {
            return;
        }
        params.set('bbox_west', String(bounds.west));
        params.set('bbox_south', String(bounds.south));
        params.set('bbox_east', String(bounds.east));
        params.set('bbox_north', String(bounds.north));
    }

    function renderEgibSearchResults(scope, data) {
        var resultsEl = scope === 'parcels' ? parcelResultsEl : buildingResultsEl;
        if (!resultsEl) {
            return;
        }
        resultsEl._items = data.items || [];
        resultsEl.hidden = false;
        resultsEl.innerHTML = renderEgibSearchResultsHtml(scope, data);
    }

    function clearEgibSearchMarkers() {
        if (egibSearchMarkerGroup) {
            egibSearchMarkerGroup.remove();
            egibSearchMarkerGroup = null;
        }
    }

    function setEgibPreviewActive(scope, index) {
        var resultsEl = scope === 'parcels' ? parcelResultsEl : buildingResultsEl;
        if (resultsEl) {
            resultsEl.querySelectorAll('[data-egib-result-card]').forEach(function(card) {
                card.classList.toggle(
                    'is-previewed',
                    parseInt(card.getAttribute('data-egib-result-card') || '-1', 10) === index
                );
            });
        }
        if (egibSearchMarkerGroup) {
            egibSearchMarkerGroup.getMarkers().forEach(function(marker) {
                var element = marker.getElement && marker.getElement();
                if (element) {
                    element.classList.toggle(
                        'is-previewed',
                        parseInt(element.getAttribute('data-egib-result-index') || '-1', 10) === index
                    );
                }
            });
        }
    }

    function previewEgibSearchItem(scope, item, index) {
        if (!map || !item || !isFinite(item.lat) || !isFinite(item.lng)) {
            return;
        }
        var latlng = { lat: Number(item.lat), lng: Number(item.lng) };
        map.flyTo({
            center: [latlng.lng, latlng.lat],
            zoom: Math.max(map.getZoom(), 18),
            duration: 800,
        });
        setEgibPreviewActive(scope, index);
        if (!isDesktopLayout()) {
            setSheetSnap('half');
        }
        syncUrl();
    }

    function renderEgibSearchMarkers(scope, items) {
        clearEgibSearchMarkers();
        if (!map || !items || !items.length) {
            return;
        }
        var group = new MarkerGroup();
        items.forEach(function(item, index) {
            if (!isFinite(item.lat) || !isFinite(item.lng)) {
                return;
            }
            var marker = createHtmlMarker(
                [Number(item.lng), Number(item.lat)],
                '<span class="nm-egib-search-marker__badge"><span>' + (index + 1) + '</span></span>',
                'nm-egib-search-marker nm-egib-search-marker--' + (scope === 'parcels' ? 'parcel' : 'building'),
                {
                    anchor: 'bottom',
                    onClick: function() {
                        previewEgibSearchItem(scope, item, index);
                    },
                }
            );
            marker.getElement().setAttribute(
                'aria-label',
                scope === 'parcels'
                    ? 'Wynik wyszukiwania: działka ' + (item.numer || item.id_dzialki || '')
                    : 'Wynik wyszukiwania: budynek ' + (item.id_budynku || '')
            );
            marker.getElement().setAttribute('data-egib-result-index', String(index));
            marker.getElement().setAttribute('role', 'button');
            marker.getElement().tabIndex = 0;
            marker.getElement().addEventListener('keydown', function(event) {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                event.preventDefault();
                previewEgibSearchItem(scope, item, index);
            });
            group.add(marker);
        });
        group.addTo(map);
        egibSearchMarkerGroup = group;
    }

    function focusEgibSearchItem(scope, item) {
        if (!map || !item || !isFinite(item.lat) || !isFinite(item.lng)) {
            return;
        }
        var latlng = { lat: Number(item.lat), lng: Number(item.lng) };
        map.flyTo({
            center: [latlng.lng, latlng.lat],
            zoom: Math.max(map.getZoom(), 18),
            duration: 800,
        });
        if (scope === 'parcels') {
            dzialkiDesired = true;
            dzialkiActive = true;
            if (dzialkiController) {
                dzialkiController.setDesired(true);
                dzialkiController.setActive(true);
            }
            selectParcel(item, latlng);
        } else {
            budynkiDesired = true;
            budynkiActive = true;
            if (budynkiController) {
                budynkiController.setDesired(true);
                budynkiController.setActive(true);
            }
            selectBuilding(Object.assign({}, item, {
                kondygnacje: item.kondygnacje_nadziemne,
            }), latlng);
        }
        syncLayerTogglesVisibility();
        syncLayerBadge();
        syncUrl();
    }

    function fitEgibSearchItems(scope, items) {
        if (!map || !items || !items.length) {
            return;
        }
        if (items.length === 1) {
            previewEgibSearchItem(scope, items[0], 0);
            return;
        }
        var lngs = items.map(function(item) { return Number(item.lng); }).filter(isFinite);
        var lats = items.map(function(item) { return Number(item.lat); }).filter(isFinite);
        if (!lngs.length || !lats.length) {
            return;
        }
        map.fitBounds([
            [Math.min.apply(null, lngs), Math.min.apply(null, lats)],
            [Math.max.apply(null, lngs), Math.max.apply(null, lats)],
        ], {
            padding: { top: 120, right: 72, bottom: 150, left: 72 },
            duration: 800,
            maxZoom: 18,
        });
    }

    function runEgibSearch(scope) {
        var params = new URLSearchParams();
        var url;
        var resultsEl;
        if (scope === 'parcels') {
            url = EGIB_DZIALKI_SEARCH_URL;
            resultsEl = parcelResultsEl;
            if (parcelIdInput && parcelIdInput.value.trim()) params.set('id_dzialki', parcelIdInput.value.trim());
            if (parcelNumberInput && parcelNumberInput.value.trim()) params.set('numer', parcelNumberInput.value.trim());
            if (parcelAreaInput && parcelAreaInput.value) params.set('powierzchnia_m2', parcelAreaInput.value);
            if (parcelNeighbourNumbersInput && parcelNeighbourNumbersInput.value.trim()) {
                params.set('numery_sasiednie', parcelNeighbourNumbersInput.value.trim());
            }
            if (parcelNeighbourAreasInput && parcelNeighbourAreasInput.value.trim()) {
                params.set('powierzchnie_sasiednie_m2', parcelNeighbourAreasInput.value.trim());
            }
            if (parcelNeighbourRadiusInput && parcelNeighbourRadiusInput.value) {
                params.set('promien_sasiedztwa_m', parcelNeighbourRadiusInput.value);
            }
            if (parcelAreaToleranceInput && parcelAreaToleranceInput.value) {
                params.set('tolerancja_m2', parcelAreaToleranceInput.value);
            }
            addEgibLocationParams(params, 'parcels');
            addEgibMapBoundsParams(params, 'parcels');
        } else {
            url = EGIB_BUDYNKI_SEARCH_URL;
            resultsEl = buildingResultsEl;
            if (buildingIdInput && buildingIdInput.value.trim()) params.set('id_budynku', buildingIdInput.value.trim());
            if (buildingFloorsAboveInput && buildingFloorsAboveInput.value !== '') {
                params.set('kondygnacje_nadziemne', buildingFloorsAboveInput.value);
            }
            if (buildingFloorsBelowInput && buildingFloorsBelowInput.value !== '') {
                params.set('kondygnacje_podziemne', buildingFloorsBelowInput.value);
            }
            addEgibLocationParams(params, 'buildings');
            addEgibMapBoundsParams(params, 'buildings');
        }
        if (resultsEl) {
            resultsEl.hidden = false;
            resultsEl.innerHTML = '<div class="nm-egib-search-results__message">' + esc(EGIB_SEARCH_LOADING_TEXT) + '</div>';
        }
        clearEgibSearchMarkers();
        return fetch(url + '?' + params.toString())
            .then(function(response) {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.json();
            })
            .then(function(data) {
                renderEgibSearchResults(scope, data || {});
                var items = (data && data.items) || [];
                renderEgibSearchMarkers(scope, items);
                fitEgibSearchItems(scope, items);
            })
            .catch(function() {
                clearEgibSearchMarkers();
                if (resultsEl) {
                    resultsEl.innerHTML = '<div class="nm-egib-search-results__message nm-egib-search-results__message--error">Nie udało się wykonać wyszukiwania. Spróbuj ponownie.</div>';
                }
            });
    }

    [
        { element: parcelResultsEl, scope: 'parcels' },
        { element: buildingResultsEl, scope: 'buildings' },
    ].forEach(function(config) {
        if (!config.element) {
            return;
        }
        config.element.addEventListener('click', function(event) {
            var previewButton = event.target.closest('[data-egib-preview-index]');
            var selectButton = event.target.closest('[data-egib-select-index]');
            var button = previewButton || selectButton;
            if (!button) return;
            var attribute = previewButton ? 'data-egib-preview-index' : 'data-egib-select-index';
            var index = parseInt(button.getAttribute(attribute) || '-1', 10);
            var item = (config.element._items || [])[index];
            if (!item) return;
            if (previewButton) {
                previewEgibSearchItem(config.scope, item, index);
            } else {
                focusEgibSearchItem(config.scope, item);
            }
        });
    });

    function getListingFilterParams(state) {
        state = state || filterState;
        var params = {};
        if (state.woj) params.woj = state.woj;
        if (state.teryt) params.teryt = state.teryt;
        if (state.rodzaj_rynku === 'pierwotny') params.market_type = 'primary';
        if (state.rodzaj_rynku === 'wtorny') params.market_type = 'secondary';
        if (state.address_query) params.description_query = state.address_query;
        if (state.listing_category) params.category = state.listing_category;
        if (state.listing_offer_type) params.offer_type = state.listing_offer_type;
        if (state.listing_location_query) params.location_query = state.listing_location_query;
        if (state.listing_location_ref_type) params.location_ref_type = state.listing_location_ref_type;
        if (state.listing_location_ref_id) params.location_ref_id = state.listing_location_ref_id;
        if (state.listing_location_ref_lat) params.location_ref_lat = state.listing_location_ref_lat;
        if (state.listing_location_ref_lng) params.location_ref_lng = state.listing_location_ref_lng;
        if (!isListingAreaReference(state.listing_location_ref_type) && state.listing_radius_km && state.listing_location_ref_lat && state.listing_location_ref_lng) {
            params.radius_km = state.listing_radius_km;
        }
        if (state.listing_price_min) params.price_min = state.listing_price_min;
        if (state.listing_price_max) params.price_max = state.listing_price_max;
        addVisibleListingParam(params, 'area', 'area_min', state.listing_area_min, state);
        addVisibleListingParam(params, 'area', 'area_max', state.listing_area_max, state);
        addVisibleListingParam(params, 'price_per_m2', 'price_per_m2_min', state.listing_price_per_m2_min, state);
        addVisibleListingParam(params, 'price_per_m2', 'price_per_m2_max', state.listing_price_per_m2_max, state);
        addVisibleListingParam(params, 'rooms', 'rooms', state.listing_rooms && state.listing_rooms.length ? state.listing_rooms.join(',') : '', state);
        addVisibleListingParam(params, 'floor', 'floor', state.listing_floor && state.listing_floor.length ? state.listing_floor.join(',') : '', state);
        addVisibleListingParam(params, 'building_year', 'build_year_min', state.listing_build_year_min, state);
        addVisibleListingParam(params, 'building_year', 'build_year_max', state.listing_build_year_max, state);
        addVisibleListingParam(params, 'building_floors', 'building_floors_min', state.listing_building_floors_min, state);
        addVisibleListingParam(params, 'building_floors', 'building_floors_max', state.listing_building_floors_max, state);
        addVisibleListingParam(params, 'building_type', 'building_type', state.listing_building_type && state.listing_building_type.length ? state.listing_building_type.join(',') : '', state);
        addVisibleListingParam(params, 'building_material', 'building_material', state.listing_building_material && state.listing_building_material.length ? state.listing_building_material.join(',') : '', state);
        addVisibleListingParam(params, 'features', 'features', state.listing_features && state.listing_features.length ? state.listing_features.join(',') : '', state);
        addVisibleListingParam(params, 'has_photos', 'has_photos', state.listing_has_photos ? '1' : '', state);
        addVisibleListingParam(params, 'ownership_type', 'ownership_type', state.listing_ownership_type, state);
        addVisibleListingParam(params, 'condition', 'condition', state.listing_condition, state);
        addVisibleListingParam(params, 'heating_type', 'heating_type', state.listing_heating_type, state);
        addVisibleListingParam(params, 'energy_class', 'energy_class', state.listing_energy_class, state);
        addVisibleListingParam(params, 'parking', 'parking', state.listing_parking, state);
        addVisibleListingParam(params, 'rental', 'rental_term', state.listing_rental_term, state);
        addVisibleListingParam(params, 'furnished', 'furnished', state.listing_furnished ? '1' : '', state);
        addVisibleListingParam(params, 'deposit', 'deposit_max', state.listing_deposit_max, state);
        addVisibleListingParam(params, 'rental', 'pet_policy', state.listing_pet_policy, state);
        addVisibleListingParam(params, 'plot', 'plot_zoning', state.listing_plot_zoning, state);
        addVisibleListingParam(params, 'plot', 'road_access', state.listing_road_access, state);
        addVisibleListingParam(params, 'plot', 'mpzp', state.listing_mpzp, state);
        addVisibleListingParam(params, 'market_type', 'market_type', state.listing_market_type, state);
        addVisibleListingParam(params, 'advertiser_type', 'advertiser_type', state.listing_advertiser_type, state);
        addVisibleListingParam(params, 'created_days', 'created_days', state.listing_created_days, state);
        addVisibleListingParam(params, 'description_query', 'description_query', state.listing_description_query, state);
        return params;
    }

    function getListingRadiusFilterState() {
        if (isListingAreaReference(filterState.listing_location_ref_type) || !filterState.listing_location_ref_lat || !filterState.listing_location_ref_lng) {
            return null;
        }
        return {
            lat: filterState.listing_location_ref_lat,
            lng: filterState.listing_location_ref_lng,
            radiusKm: filterState.listing_radius_km || '1',
        };
    }

    function syncListingBrowseLink(state) {
        if (!listingBrowseLinkEl) {
            return;
        }
        listingBrowseLinkEl.href = buildListingBrowseUrl(
            BASE_URL,
            getListingFilterParams(state),
            window.RCN_PROPERTY_LISTING_URLS || {}
        );
    }

    function checkedGroupLabels(group, values) {
        return (values || []).map(function(value) {
            var input = document.querySelector('[data-listing-checkbox-group="' + group + '"][value="' + esc(String(value)) + '"]');
            var label = input ? input.closest('label') : null;
            var text = label ? label.textContent.trim() : String(value);
            return text;
        }).filter(Boolean).join(', ');
    }

    function selectOptionLabel(inputEl, value) {
        if (!inputEl || !inputEl.options || !value) {
            return value || '';
        }
        for (var i = 0; i < inputEl.options.length; i++) {
            if (String(inputEl.options[i].value) === String(value)) {
                return inputEl.options[i].textContent.trim();
            }
        }
        return value;
    }

    function addListingActiveFilter(chips, key, label, value, field) {
        if (!value || (field && !listingFilterFieldVisible(field))) {
            return;
        }
        chips.push({ key: key, label: label, value: value });
    }

    function renderListingActiveFilters() {
        if (!listingActiveFiltersEl) {
            return;
        }
        var previousScroller = listingActiveFiltersEl.querySelector('.nm-active-filters__scroller');
        var previousScrollLeft = previousScroller ? previousScroller.scrollLeft : 0;
        var chips = [];
        addListingActiveFilter(chips, 'listing_price_min', 'Cena od', filterState.listing_price_min, 'base');
        addListingActiveFilter(
            chips,
            'listing_location_query',
            'Lokalizacja',
            filterState.listing_location_query
                ? filterState.listing_location_query + (isListingAreaReference(filterState.listing_location_ref_type)
                    ? ' · w granicach obszaru'
                    : ' · do ' + (filterState.listing_radius_km || '1') + ' km')
                : '',
            'base'
        );
        addListingActiveFilter(chips, 'listing_price_max', 'Cena do', filterState.listing_price_max, 'base');
        addListingActiveFilter(chips, 'listing_area_min', 'Powierzchnia od', filterState.listing_area_min, 'area');
        addListingActiveFilter(chips, 'listing_area_max', 'Powierzchnia do', filterState.listing_area_max, 'area');
        addListingActiveFilter(chips, 'listing_price_per_m2_min', 'Cena za metr kwadratowy od', filterState.listing_price_per_m2_min, 'price_per_m2');
        addListingActiveFilter(chips, 'listing_price_per_m2_max', 'Cena za metr kwadratowy do', filterState.listing_price_per_m2_max, 'price_per_m2');
        addListingActiveFilter(chips, 'listing_rooms', 'Pokoje', checkedGroupLabels('rooms', filterState.listing_rooms), 'rooms');
        addListingActiveFilter(chips, 'listing_floor', 'Piętro', checkedGroupLabels('floor', filterState.listing_floor), 'floor');
        addListingActiveFilter(chips, 'listing_build_year_min', 'Rok od', filterState.listing_build_year_min, 'building_year');
        addListingActiveFilter(chips, 'listing_build_year_max', 'Rok do', filterState.listing_build_year_max, 'building_year');
        addListingActiveFilter(chips, 'listing_building_type', 'Budynek', checkedGroupLabels('building_type', filterState.listing_building_type), 'building_type');
        addListingActiveFilter(chips, 'listing_building_material', 'Materiał', checkedGroupLabels('building_material', filterState.listing_building_material), 'building_material');
        addListingActiveFilter(chips, 'listing_features', 'Udogodnienia', checkedGroupLabels('features', filterState.listing_features), 'features');
        addListingActiveFilter(chips, 'listing_has_photos', 'Zdjęcia', filterState.listing_has_photos ? 'tylko ze zdjęciami' : '', 'has_photos');
        addListingActiveFilter(chips, 'listing_ownership_type', 'Własność', selectOptionLabel(listingOwnershipTypeInput, filterState.listing_ownership_type), 'ownership_type');
        addListingActiveFilter(chips, 'listing_condition', 'Stan', selectOptionLabel(listingConditionInput, filterState.listing_condition), 'condition');
        addListingActiveFilter(chips, 'listing_heating_type', 'Ogrzewanie', selectOptionLabel(listingHeatingTypeInput, filterState.listing_heating_type), 'heating_type');
        addListingActiveFilter(chips, 'listing_energy_class', 'Energia', selectOptionLabel(listingEnergyClassInput, filterState.listing_energy_class), 'energy_class');
        addListingActiveFilter(chips, 'listing_parking', 'Parking', selectOptionLabel(listingParkingInput, filterState.listing_parking), 'parking');
        addListingActiveFilter(chips, 'listing_rental_term', 'Najem', selectOptionLabel(listingRentalTermInput, filterState.listing_rental_term), 'rental');
        addListingActiveFilter(chips, 'listing_furnished', 'Umeblowanie', filterState.listing_furnished ? 'umeblowane' : '', 'furnished');
        addListingActiveFilter(chips, 'listing_deposit_max', 'Kaucja do', filterState.listing_deposit_max, 'deposit');
        addListingActiveFilter(chips, 'listing_pet_policy', 'Zwierzęta', selectOptionLabel(listingPetPolicyInput, filterState.listing_pet_policy), 'rental');
        addListingActiveFilter(chips, 'listing_plot_zoning', 'Działka', selectOptionLabel(listingPlotZoningInput, filterState.listing_plot_zoning), 'plot');
        addListingActiveFilter(chips, 'listing_road_access', 'Dojazd', selectOptionLabel(listingRoadAccessInput, filterState.listing_road_access), 'plot');
        addListingActiveFilter(chips, 'listing_mpzp', 'Miejscowy plan zagospodarowania przestrzennego', selectOptionLabel(listingMpzpInput, filterState.listing_mpzp), 'plot');
        addListingActiveFilter(chips, 'listing_advertiser_type', 'Ogłoszeniodawca', selectOptionLabel(listingAdvertiserTypeInput, filterState.listing_advertiser_type), 'advertiser_type');
        addListingActiveFilter(chips, 'listing_market_type', 'Rynek', selectOptionLabel(listingMarketTypeInput, filterState.listing_market_type), 'market_type');
        addListingActiveFilter(chips, 'listing_created_days', 'Dodano', selectOptionLabel(listingCreatedDaysInput, filterState.listing_created_days), 'created_days');
        addListingActiveFilter(chips, 'listing_description_query', 'Opis', filterState.listing_description_query, 'description_query');

        listingActiveFiltersEl.hidden = chips.length === 0;
        listingActiveFiltersEl.innerHTML = chips.length
            ? '<span class="nm-active-filters__label">Wybrane filtry</span><div class="nm-active-filters__scroller">' + chips.map(function(chip) {
                var label = chip.label + ': ' + chip.value;
                return '<span class="nm-active-filter">'
                    + '<span>' + esc(label) + '</span>'
                    + '<button type="button" data-listing-active-clear="' + esc(chip.key) + '" aria-label="' + esc('Usuń filtr ' + label) + '">×</button>'
                + '</span>';
            }).join('') + '</div>'
            : '';
        var nextScroller = listingActiveFiltersEl.querySelector('.nm-active-filters__scroller');
        if (nextScroller) {
            nextScroller.scrollLeft = previousScrollLeft;
        }
    }

    function renderTransactionActiveFilters() {
        if (!transactionActiveFiltersEl) {
            return;
        }
        var chipsHtml = areaFilterChipHtml(filterState.obszar || '', transactionActiveFiltersEl.getAttribute('data-area-label') || '');
        transactionActiveFiltersEl.hidden = chipsHtml === '';
        transactionActiveFiltersEl.innerHTML = chipsHtml;
    }

    // Removing the area filter widens the transactions to the whole map view again.
    function clearTransactionAreaFilter() {
        filterState.obszar = '';
        renderTransactionActiveFilters();
        syncUrl();
        if (map) {
            clearSelection({ keepDetails: false, sync: false });
            refreshAll({ resetList: true });
        }
    }

    function clearListingActiveFilter(key) {
        if (!Object.prototype.hasOwnProperty.call(filterState, key)) {
            return;
        }
        filterState[key] = Array.isArray(filterState[key]) ? [] : '';
        if (key === 'listing_location_query') {
            setListingLocationReference(null);
            filterState.listing_radius_km = '';
            if (listingRadiusKmInput) listingRadiusKmInput.value = '1';
        }
        applyFilterInputs();
        syncListingBrowseLink();
        syncUrl();
        if (map) {
            clearSelection({ keepDetails: false, sync: false });
            refreshAll({ resetList: true });
        }
    }

    function syncAssetSwitchVisibility() {
        if (assetSwitchEl) {
            assetSwitchEl.hidden = !transakcjeActive;
        }
    }

    var activeFilterScope = ogloszeniaActive ? 'listings' : 'transactions';

    function setFilterScope(scope) {
        activeFilterScope = scope || 'transactions';
        filterScopeEls.forEach(function(el) {
            var active = el.getAttribute('data-filter-scope') === activeFilterScope;
            el.classList.toggle('is-active', active);
            el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        filterScopeSectionEls.forEach(function(el) {
            el.hidden = el.getAttribute('data-filter-scope-section') !== activeFilterScope;
        });
    }

    function enableLayerForActiveFilterScope() {
        var controller = null;
        if (activeFilterScope === 'transactions') {
            transakcjeDesired = true;
            transakcjeActive = true;
            controller = transactionsController;
        } else if (activeFilterScope === 'listings') {
            ogloszeniaDesired = true;
            ogloszeniaActive = true;
            controller = listingsController;
        } else if (activeFilterScope === 'parcels') {
            dzialkiDesired = true;
            dzialkiActive = true;
            controller = dzialkiController;
        } else if (activeFilterScope === 'buildings') {
            budynkiDesired = true;
            budynkiActive = true;
            controller = budynkiController;
        } else if (activeFilterScope === 'signals') {
            sygnalyDesired = true;
            sygnalyActive = true;
            controller = signalsController;
        } else if (activeFilterScope === 'surroundings') {
            otoczenieDesired = true;
            otoczenieActive = true;
            controller = otoczenieController;
        } else if (activeFilterScope === 'permits') {
            gunbDesired = true;
            gunbActive = true;
            controller = gunbController;
        }
        if (controller) {
            controller.setDesired(true);
            controller.setActive(true);
        }
        syncAssetSwitchVisibility();
        syncListingCategorySwitch();
    }

    function syncListingCategorySwitch() {
        if (listingCategorySwitchEl) {
            listingCategorySwitchEl.hidden = !ogloszeniaActive;
        }
        var value = filterState.listing_category || '';
        var topValues = ['apartment', 'house', 'plot'];
        var isOther = value !== '' && topValues.indexOf(value) === -1;
        if (listingCategoryEls) {
            listingCategoryEls.forEach(function(el) {
                el.classList.toggle('is-active', el.getAttribute('data-listing-category-filter') === value);
            });
        }
        if (listingCategoryMoreSelect) {
            listingCategoryMoreSelect.value = isOther ? value : '';
            listingCategoryMoreSelect.classList.toggle('is-active', isOther);
        }
        syncListingBrowseLink();
    }

    function setListingCategoryFilter(value) {
        // The listing category switch always keeps one category selected.
        filterState.listing_category = value || 'plot';
        if (listingCategoryInput) {
            listingCategoryInput.value = filterState.listing_category;
        }
        applyListingQuickFilterChange();
    }

    function activateListingsLayerForFilters() {
        ogloszeniaDesired = true;
        ogloszeniaActive = true;
        if (listingsController) {
            listingsController.setDesired(true);
            listingsController.setActive(true);
        }
        syncAssetSwitchVisibility();
        syncListingCategorySwitch();
    }

    function applyListingQuickFilterChange(options) {
        options = options || {};
        if (options.clearPending) {
            setFilterInputsPending(false);
        }
        syncListingCategorySwitch();
        syncListingFilterTags();
        syncListingFilterVisibility();
        syncListingBrowseLink();
        activateListingsLayerForFilters();
        clearSelection({ keepDetails: false, sync: false });
        if (ogloszeniaActive) {
            loadListings();
        }
        syncUrl();
    }

    var LISTING_CATEGORY_LABELS = {
        apartment: 'Mieszkanie', studio: 'Kawalerka', room: 'Pokój', house: 'Dom',
        development: 'Inwestycja', plot: 'Działka', commercial_unit: 'Lokal użytkowy',
        warehouse: 'Hala lub magazyn', garage: 'Garaż'
    };

    function listingCategoryLabelText(slug) {
        if (!slug) return 'Ogłoszenie';
        return LISTING_CATEGORY_LABELS[slug] || slug;
    }

    function renderListingsData(data) {
        bringDataLayersToFront();
        if (data && data.aggregated === true) {
            listingViewAggregated = true;
            listingViewFeatures = [];
        } else {
            listingViewAggregated = false;
            listingViewFeatures = (data && Array.isArray(data.features)) ? data.features.slice() : [];
        }
        if (ogloszeniaActive) {
            renderListPanel();
        }
        reapplyListingMarkerHighlight();
        return ogloszeniaLayer;
    }

    function onListingClusterClick() {
        setTab('list', { snap: 'half', sync: false });
        renderListPanel();
    }

    var listHoverHighlightKey = null;
    var listHoverHighlightId = null;
    // While the pointer rests on the result list (desktop hover-to-pan), list
    // re-renders are frozen so a map move can never reshuffle the card under
    // the cursor. Deferred renders are flushed once the pointer leaves.
    var listHoverLock = false;
    var listRenderDeferredWhileLocked = false;

    function clearMarkerStateClass(className, stateClass) {
        var marked = document.querySelectorAll('.' + className + '.' + stateClass);
        for (var i = 0; i < marked.length; i += 1) {
            marked[i].classList.remove(stateClass);
        }
    }

    function clearMarkerHighlightClass(className) {
        clearMarkerStateClass(className, 'is-hovered');
    }

    function applyMarkerStateClass(className, attr, id, stateClass) {
        clearMarkerStateClass(className, stateClass);
        if (id == null || id === '') {
            return;
        }
        var selectorId = String(id).replace(/["\\]/g, '\\$&');
        var el = document.querySelector('.' + className + '[' + attr + '="' + selectorId + '"]');
        if (el) {
            el.classList.add(stateClass);
        }
    }

    function applyListingMarkerHighlight(id) {
        applyMarkerStateClass('nm-listing-marker', 'data-listing-marker-id', id, 'is-hovered');
    }

    function syncListingMarkerSelection(id) {
        applyMarkerStateClass('nm-listing-marker', 'data-listing-marker-id', id, 'is-selected');
    }

    function applySignalMarkerHighlight(id) {
        applyMarkerStateClass('nm-signal-marker', 'data-signal-marker-id', id, 'is-hovered');
    }

    function findGunbViewFeatureById(gunbId) {
        return flattenGunbViewFeatures().filter(function(feature) {
            return feature.properties && String(feature.properties.id) === String(gunbId);
        })[0] || null;
    }

    function reapplyHoverMarkerHighlight() {
        var kind = listHoverHighlightKey ? listHoverHighlightKey.charAt(0) : null;
        if (kind === 'l' && listHoverHighlightId != null) {
            applyListingMarkerHighlight(listHoverHighlightId);
        } else if (kind === 's' && listHoverHighlightId != null) {
            applySignalMarkerHighlight(listHoverHighlightId);
        } else if (kind === 'g' && listHoverHighlightId != null && gunbController) {
            var gunbFeature = findGunbViewFeatureById(listHoverHighlightId);
            if (gunbFeature) {
                gunbController.renderSelectedFeature(gunbFeature);
            }
        }
    }

    // Kept for callers that re-render the listings layer.
    function reapplyListingMarkerHighlight() {
        syncListingMarkerSelection(selectedListingId);
        reapplyHoverMarkerHighlight();
    }

    function resetListHoverHighlight() {
        cancelListHoverPan();
        var kind = listHoverHighlightKey ? listHoverHighlightKey.charAt(0) : null;
        if (kind === 't') {
            if (transactionsController) {
                transactionsController.clearHighlight();
                if (selectedTid) {
                    transactionsController.highlightFeatureById(selectedTid, latestGeoData);
                }
            }
        } else if (kind === 'g') {
            if (gunbController) {
                gunbController.clearSelectedFeature();
                if (selectedGunbId) {
                    gunbController.syncSelectedFeature(selectedGunbId);
                }
            }
        } else if (kind === 's') {
            clearMarkerHighlightClass('nm-signal-marker');
        } else if (kind === 'l') {
            clearMarkerHighlightClass('nm-listing-marker');
        }
        listHoverHighlightKey = null;
        listHoverHighlightId = null;
    }

    var listHoverPanTimer = null;

    function cancelListHoverPan() {
        if (listHoverPanTimer) {
            clearTimeout(listHoverPanTimer);
            listHoverPanTimer = null;
        }
    }

    function sortListingFeatures(features, sort) {
        function priceOf(feature) {
            var props = feature.properties || {};
            var value = props.price != null ? props.price : props.price_amount;
            return value == null || value === '' ? null : Number(value);
        }
        function areaOf(feature) {
            var value = (feature.properties || {}).area_m2;
            return value == null || value === '' ? null : Number(value);
        }
        function idOf(feature) {
            return Number((feature.properties || {}).id || 0);
        }
        return features.slice().sort(function(a, b) {
            if (sort === 'price_asc' || sort === 'price_desc') {
                var pa = priceOf(a);
                var pb = priceOf(b);
                if (pa == null && pb == null) return idOf(b) - idOf(a);
                if (pa == null) return 1;
                if (pb == null) return -1;
                return sort === 'price_asc' ? pa - pb : pb - pa;
            }
            if (sort === 'area_desc') {
                var aa = areaOf(a);
                var ab = areaOf(b);
                if (aa == null && ab == null) return idOf(b) - idOf(a);
                if (aa == null) return 1;
                if (ab == null) return -1;
                return ab - aa;
            }
            return idOf(b) - idOf(a);
        });
    }

    // List states shared by every result type of the list tab.
    function renderZoomInState(title, body) {
        return '<div class="ms-empty-state nm-empty-state nm-zoom-in-state">'
            + '<strong>' + esc(title) + '</strong>'
            + '<span>' + esc(body) + '</span>'
        + '</div>';
    }

    function renderListSkeleton(label) {
        var card = '<div class="ms-card ms-card--grid nm-skeleton-card" aria-hidden="true">'
            + '<span class="ms-skeleton ms-skeleton--text nm-skeleton-card__badge"></span>'
            + '<span class="ms-skeleton ms-skeleton--title"></span>'
            + '<span class="ms-skeleton ms-skeleton--text"></span>'
            + '<span class="ms-skeleton ms-skeleton--text nm-skeleton-card__short"></span>'
        + '</div>';
        return '<div class="nm-list-stack" role="status" aria-busy="true">'
            + '<span class="sr-only">' + esc(label) + '</span>'
            + card + card + card
        + '</div>';
    }

    // detail: the server's own message, kept as a separate line.
    function renderListError(message, retryAttribute, detail) {
        return '<div class="ms-alert ms-alert--danger nm-list-error" role="alert">'
            + '<p><strong>' + esc(message) + '</strong></p>'
            + (detail ? '<p>' + esc(detail) + '</p>' : '')
            + (retryAttribute ? '<button class="ms-button ms-button--secondary ms-button--sm" type="button" ' + retryAttribute + '>Spróbuj ponownie</button>' : '')
        + '</div>';
    }

    function listingDetailUrl(props) {
        if (props.detail_url) return safeHref(props.detail_url);
        if (props.slug && props.id != null) return '/ogloszenie/' + props.slug + '-' + props.id;
        return '';
    }

    function renderListingListCardHtml(feature) {
        var props = (feature && feature.properties) || {};
        var coords = feature && feature.geometry ? feature.geometry.coordinates : null;
        var price = props.price != null ? props.price : props.price_amount;
        var priceStr = price != null && price !== ''
            ? fmt(price) + (props.offer_type === 'rent' ? ' zł miesięcznie' : ' zł')
            : 'Cena do uzgodnienia';
        var offerLabel = props.offer_type === 'rent' ? 'Wynajem' : 'Sprzedaż';
        var detailUrl = listingDetailUrl(props);
        var facts = [];
        facts.push('<li>' + esc(offerLabel) + '</li>');
        if (props.area_m2 != null) facts.push('<li>Powierzchnia ' + fmt(props.area_m2) + ' m²</li>');
        if (props.has_photos) facts.push('<li>Ze zdjęciami</li>');
        return '<article class="ms-card ms-card--grid nm-list-card nm-listing-card nm-transaction-card ms-dept--offers"'
            + ' data-listing-card="' + esc(String(props.id || '')) + '"'
            + ' data-lat="' + (coords ? coords[1] : '') + '"'
            + ' data-lng="' + (coords ? coords[0] : '') + '">'
            + '<div class="nm-transaction-card__top">'
                + '<span class="ms-badge ms-badge--accent">' + esc(listingCategoryLabelText(props.category)) + '</span>'
                + '<span class="nm-transaction-card__date">cena ofertowa</span>'
            + '</div>'
            + '<h3 class="nm-transaction-card__title"><button class="nm-list-card-select" type="button">'
                + esc(props.title || listingCategoryLabelText(props.category))
            + '</button></h3>'
            + '<p class="nm-transaction-card__price"><strong>' + esc(priceStr) + '</strong></p>'
            + '<ul class="nm-transaction-card__facts">' + facts.join('') + '</ul>'
            + (props.address ? '<p class="nm-transaction-card__source">' + esc(props.address) + '</p>' : '')
            + (detailUrl ? '<a class="ms-link nm-card-link" href="' + esc(detailUrl) + '">Szczegóły ogłoszenia</a>' : '')
        + '</article>';
    }

    function renderListingsListPanel() {
        sortRowEl.style.display = 'none';
        listMoreBtn.style.display = 'none';
        listTitleEl.textContent = 'Ogłoszenia w aktualnym widoku';

        if (listingViewAggregated || mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) {
            if (listingSortRowEl) listingSortRowEl.style.display = 'none';
            listMetaEl.textContent = 'Przybliż mapę, aby wczytać listę';
            setListContent(listContentEl, renderZoomInState(
                'Przybliż mapę, aby zobaczyć pojedyncze ogłoszenia',
                'Na tym poziomie ogłoszenia są grupowane w skupiska. Lista pojawi się po przybliżeniu.'
            ));
            return;
        }

        if (listingSortRowEl) listingSortRowEl.style.display = '';

        var listingState = listingsController && listingsController.loadState;
        if (!listingState || listingState === 'loading') {
            listMetaEl.textContent = 'Ładowanie ogłoszeń…';
            setListContent(listContentEl, renderListSkeleton('Ładowanie ogłoszeń w aktualnym widoku…'));
            return;
        }
        if (listingState === 'error') {
            listMetaEl.textContent = 'Nie udało się wczytać ogłoszeń';
            setListContent(listContentEl, renderListError('Nie udało się wczytać ogłoszeń dla aktualnego widoku.', 'data-listings-retry'));
            return;
        }

        if (!listingViewFeatures.length) {
            listMetaEl.textContent = '0 ogłoszeń';
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Brak ogłoszeń w tym widoku</strong><span>Zmień filtry ogłoszeń albo oddal mapę.</span></div>');
            return;
        }

        var sorted = sortListingFeatures(listingViewFeatures, listingListSort);
        renderedListingFeatures = sorted.slice();
        listMetaEl.textContent = countLabel(sorted.length, 'ogłoszenie', 'ogłoszenia', 'ogłoszeń');
        renderKeyedStack(listContentEl, sorted.map(function(feature) {
            var props = (feature && feature.properties) || {};
            return { key: 'l:' + (props.id != null ? props.id : ''), html: renderListingListCardHtml(feature) };
        }));
    }

    function renderDeveloperOffersData(data) {
        developerOfferViewAggregated = !!(data && data.aggregated === true);
        developerOfferViewFeatures = data && Array.isArray(data.features) ? data.features.slice() : [];
        restorePendingDeveloperInvestment();
        if (ofertyDeweloperowActive && listSubTab === 'ofertyDeweloperow') {
            renderListPanel();
        }
        return ofertyDeweloperowLayer;
    }

    // A URL with developer_offer_investment_id opens that investment once its
    // marker has loaded (the investment pages link to the map this way).
    function restorePendingDeveloperInvestment() {
        if (!pendingDeveloperInvestmentRestore || developerOfferViewAggregated) return;
        var match = developerOfferViewFeatures.find(function(feature) {
            var props = feature && feature.properties;
            return props && String(props.investment_id) === String(selectedDeveloperInvestmentId);
        });
        if (!match) return;
        var coords = match.geometry && Array.isArray(match.geometry.coordinates) ? match.geometry.coordinates : null;
        selectDeveloperInvestmentHit(match.properties || {}, coords ? { lat: coords[1], lng: coords[0] } : null);
    }

    // Another selection (a transaction, parcel, building, permit, signal…)
    // replaces the investment in the details panel, so it leaves the URL.
    function urlDeveloperInvestmentId() {
        if (selectedTid || selectedDid || selectedBid || selectedGunbId || selectedListingId || selectedOtoczenieId || selectedSignalContext || selectedNoiseContext) {
            return null;
        }
        return selectedDeveloperInvestmentId;
    }

    function clearDeveloperOffersData() {
        developerOfferViewFeatures = [];
        developerOfferViewAggregated = false;
        renderedDeveloperOfferFeatures = [];
    }

    function developerOfferMoney(value) {
        var num = Number(value);
        return value == null || value === '' || !isFinite(num) ? 'brak danych' : fmt(Math.round(num)) + ' zł';
    }

    function renderDeveloperInvestmentCardHtml(props, index) {
        var count = Number(props.count || 0);
        var perM2 = props.price_per_m2_median != null && props.price_per_m2_median !== ''
            ? fmt(Math.round(Number(props.price_per_m2_median))) + ' zł/m²'
            : 'brak danych';
        var hasRange = props.price_min != null || props.price_max != null;
        var listDate = props.last_seen_at ? dateLong(String(props.last_seen_at).substring(0, 10)) : '';
        return '<article class="ms-card ms-card--grid nm-list-card nm-transaction-card nm-investment-card"'
            + ' data-developer-investment-index="' + index + '">'
            + '<div class="nm-transaction-card__top">'
                + '<span class="ms-badge ms-badge--accent">Inwestycja deweloperska</span>'
                + '<span class="nm-transaction-card__date">cena ofertowa</span>'
            + '</div>'
            + '<h3 class="nm-transaction-card__title"><button class="nm-list-card-select" type="button">'
                + esc(props.investment_name || 'Inwestycja deweloperska')
            + '</button></h3>'
            + (props.developer_name ? '<p class="nm-transaction-card__sub">' + esc(props.developer_name) + '</p>' : '')
            + '<p class="nm-transaction-card__price"><strong>' + esc(countLabel(count, 'oferta', 'oferty', 'ofert')) + '</strong>'
                + '<span>mediana ' + esc(perM2) + renderInfoHelpButton(DEVELOPER_OFFER_MEDIAN_HELP, 'Jak liczymy medianę ceny ofertowej') + '</span></p>'
            + '<ul class="nm-transaction-card__facts">'
                + (hasRange ? '<li>Ceny ofert ' + esc(developerOfferMoney(props.price_min)) + ' – ' + esc(developerOfferMoney(props.price_max)) + '</li>' : '')
                + (listDate ? '<li>Cennik z ' + esc(listDate) + '</li>' : '')
            + '</ul>'
            + (props.detail_url ? '<a class="ms-link nm-card-link" href="' + esc(safeHref(props.detail_url)) + '">Cennik inwestycji</a>' : '')
        + '</article>';
    }

    function renderDeveloperOffersListPanel() {
        sortRowEl.style.display = 'none';
        listMoreBtn.style.display = 'none';
        listTitleEl.textContent = 'Oferty deweloperów w aktualnym widoku';

        var loadState = developerOffersController && developerOffersController.loadState;
        if (loadState === 'error') {
            listMetaEl.textContent = 'Nie udało się wczytać ofert';
            setListContent(listContentEl, renderListError('Nie udało się wczytać ofert deweloperów dla aktualnego widoku.', 'data-developer-offers-retry'));
            return;
        }
        if ((!loadState || loadState === 'loading') && !developerOfferViewFeatures.length) {
            listMetaEl.textContent = 'Ładowanie ofert…';
            setListContent(listContentEl, renderListSkeleton('Ładowanie ofert deweloperów w aktualnym widoku…'));
            return;
        }
        if (developerOfferViewAggregated) {
            var offers = 0;
            var investments = 0;
            developerOfferViewFeatures.forEach(function(feature) {
                var props = (feature && feature.properties) || {};
                offers += Number(props.count) || 0;
                investments += Number(props.investments_count) || 0;
            });
            listMetaEl.textContent = offers
                ? countLabel(offers, 'oferta', 'oferty', 'ofert') + ' w ' + countLabel(investments, 'inwestycji', 'inwestycjach', 'inwestycjach')
                : 'Przybliż mapę, aby wczytać listę';
            setListContent(listContentEl, renderZoomInState(
                'Przybliż mapę, aby zobaczyć pojedyncze inwestycje',
                'Na tym poziomie inwestycje są grupowane w skupiska. Lista z cenami pojawi się po przybliżeniu.'
            ));
            return;
        }
        if (!developerOfferViewFeatures.length) {
            listMetaEl.textContent = '0 inwestycji';
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Brak ofert deweloperów w tym widoku</strong><span>Oddal mapę albo przesuń ją do innej okolicy.</span></div>');
            return;
        }

        renderedDeveloperOfferFeatures = developerOfferViewFeatures.slice().sort(function(a, b) {
            return (Number((b.properties || {}).count) || 0) - (Number((a.properties || {}).count) || 0);
        });
        listMetaEl.textContent = countLabel(renderedDeveloperOfferFeatures.length, 'inwestycja', 'inwestycje', 'inwestycji');
        renderKeyedStack(listContentEl, renderedDeveloperOfferFeatures.map(function(feature, index) {
            var props = (feature && feature.properties) || {};
            return { key: 'd:' + (props.investment_id != null ? props.investment_id : index), html: renderDeveloperInvestmentCardHtml(props, index) };
        }));
    }

    function loadListings() {
        syncListingBrowseLink();
        if (listingsController) {
            listingsController.load();
        }
    }

    function syncListingsToggleVisibility() {
        if (listingsController) {
            listingsController.syncVisibility();
        }
    }

    function toggleListingsLayer() {
        if (listingsController) {
            listingsController.toggle();
        }
        if (!ogloszeniaActive) {
            listingViewFeatures = [];
            listingViewAggregated = false;
        }
        renderListPanel();
    }

    /**
     * Map filters for the developer-offer layer.
     *
     * Deliberately narrow: the importer supplies no photos, no fit-out standard
     * and no amenities, so the layer must not advertise filters it cannot honour.
     * Availability is left unset, which makes the endpoint fall back to its own
     * "currently published" statuses instead of claiming anything is available.
     */
    function getDeveloperOfferFilterParams() {
        var params = {};
        if (filterState.developer_offer_property_type) {
            params.property_type = filterState.developer_offer_property_type;
        }
        if (filterState.developer_offer_availability) {
            params.availability = filterState.developer_offer_availability;
        }
        ['price_min', 'price_max', 'price_per_m2_min', 'price_per_m2_max', 'area_min', 'area_max'].forEach(function(key) {
            var value = filterState['developer_offer_' + key];
            if (value != null && value !== '') {
                params[key] = value;
            }
        });
        if (filterState.developer_offer_q) {
            params.q = filterState.developer_offer_q;
        }
        return params;
    }

    function loadDeveloperOffers() {
        if (developerOffersController) {
            developerOffersController.load();
        }
    }

    function syncDeveloperOffersToggleVisibility() {
        if (developerOffersController) {
            developerOffersController.syncVisibility();
        }
    }

    function toggleDeveloperOffersLayer() {
        if (developerOffersController) {
            developerOffersController.toggle();
        }
    }

    function selectDeveloperInvestmentHit(props, latlng) {
        selectedNoiseContext = null;
        pendingNearbyRestore = false;
        selectedListingId = null;
        // The marker and the list card both land here, so both put the
        // investment in the URL.
        selectedDeveloperInvestmentId = props && props.investment_id != null ? parseInt(props.investment_id, 10) || null : null;
        pendingDeveloperInvestmentRestore = false;
        selectedTid = null;
        selectedDid = null;
        selectedBid = null;
        selectedGunbId = null;
        selectedOtoczenieFeature = null;
        selectedOtoczenieId = null;
        selectedSignalContext = null;
        selectedLatLng = latlng || null;
        selectedTransactionRow = null;
        clearTapBrowseState();
        clearTransactionHighlight();
        clearSignalFocus();
        clearSelectedFeatureVisual();
        clearSelectedGunbVisual();
        clearNearbyState();
        detailRenderers.renderDeveloperInvestmentDetails(props || {});
        updateSelectionControl();
        setTab('details', { snap: 'half', sync: false });
        easeMapToKeepPointVisible(selectedLatLng);
        syncUrl();
    }

    function selectListingHit(props, latlng) {
        selectedNoiseContext = null;
        pendingNearbyRestore = false;
        selectedListingId = props && props.id != null ? parseInt(props.id, 10) : null;
        selectedDeveloperInvestmentId = null;
        pendingDeveloperInvestmentRestore = false;
        selectedTid = null;
        selectedDid = null;
        selectedBid = null;
        selectedGunbId = null;
        selectedOtoczenieFeature = null;
        selectedOtoczenieId = null;
        selectedSignalContext = null;
        selectedLatLng = latlng || null;
        selectedTransactionRow = null;
        clearTapBrowseState();
        clearTransactionHighlight();
        clearSignalFocus();
        clearSelectedFeatureVisual();
        clearSelectedGunbVisual();
        clearNearbyState();
        detailRenderers.renderListingDetails(props || {});
        if (selectedListingId) {
            fetchListingDetail(selectedListingId, { keepCurrent: true });
        }
        updateSelectionControl();
        setTab('details', { snap: 'half', sync: false });
        easeMapToKeepPointVisible(selectedLatLng);
        syncUrl();
    }

    function fetchListingDetail(listingId, options) {
        options = options || {};
        if (!listingId) {
            return;
        }
        if (abortListingDetail) {
            abortListingDetail.abort();
        }
        abortListingDetail = new AbortController();
        if (!options.keepCurrent) {
            renderDetailsLoading('Ogłoszenie #' + listingId);
        }
        fetch(BASE_URL + 'api/listings/detail/' + encodeURIComponent(listingId), {
            signal: abortListingDetail.signal,
        })
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Nie znaleziono ogłoszenia');
                }
                return response.json();
            })
            .then(function(data) {
                if (selectedListingId && String(selectedListingId) === String(listingId)) {
                    detailRenderers.renderListingDetails(data);
                }
            })
            .catch(function(error) {
                if (error && error.name === 'AbortError') {
                    return;
                }
                renderDetailsError(error && error.message ? error.message : 'Błąd ładowania ogłoszenia');
            })
            .finally(function() {
                abortListingDetail = null;
            });
    }

    function openMapListingLightbox(trigger) {
        var gallery = trigger ? trigger.closest('.nm-listing-map-gallery') : null;
        var dataEl = gallery ? gallery.querySelector('[data-map-listing-lightbox-data]') : null;
        var photos = [];
        try {
            photos = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];
        } catch (_error) {
            photos = [];
        }
        if (!photos.length) {
            return;
        }

        var index = parseInt(trigger.getAttribute('data-map-listing-lightbox-open') || '0', 10);
        if (!isFinite(index) || index < 0 || index >= photos.length) {
            index = 0;
        }

        var overlay = document.createElement('div');
        overlay.className = 'nm-listing-map-lightbox';
        overlay.innerHTML = ''
            + '<button type="button" class="ms-button ms-button--icon-lg ms-button--overlay-icon nm-listing-map-lightbox__close" data-map-listing-lightbox-close aria-label="Zamknij">×</button>'
            + '<button type="button" class="ms-button ms-button--icon-lg ms-button--overlay-icon nm-listing-map-lightbox__prev" data-map-listing-lightbox-prev aria-label="Poprzednie zdjęcie">‹</button>'
            + '<img class="nm-listing-map-lightbox__image" alt="">'
            + '<button type="button" class="ms-button ms-button--icon-lg ms-button--overlay-icon nm-listing-map-lightbox__next" data-map-listing-lightbox-next aria-label="Następne zdjęcie">›</button>';
        document.body.appendChild(overlay);

        var img = overlay.querySelector('.nm-listing-map-lightbox__image');
        function show(nextIndex) {
            index = (nextIndex + photos.length) % photos.length;
            img.src = photos[index].detail || photos[index].thumb || '';
        }
        function close() {
            document.removeEventListener('keydown', onKey);
            if (overlay.parentNode) {
                overlay.parentNode.removeChild(overlay);
            }
        }
        function onKey(ev) {
            if (ev.key === 'Escape') close();
            if (ev.key === 'ArrowLeft') show(index - 1);
            if (ev.key === 'ArrowRight') show(index + 1);
        }
        overlay.addEventListener('click', function(ev) {
            if (ev.target === overlay || ev.target.matches('[data-map-listing-lightbox-close]')) {
                close();
                return;
            }
            if (ev.target.matches('[data-map-listing-lightbox-prev]')) {
                show(index - 1);
                return;
            }
            if (ev.target.matches('[data-map-listing-lightbox-next]')) {
                show(index + 1);
            }
        });
        document.addEventListener('keydown', onKey);
        show(index);
    }

    function handleMapListingLightboxClick(ev) {
        var trigger = ev.target.closest('[data-map-listing-lightbox-open]');
        if (!trigger) {
            return;
        }
        ev.preventDefault();
        openMapListingLightbox(trigger);
    }

    function toggleTransakcjeLayer() {
        if (!map) return;
        transakcjeActive = !transakcjeActive;
        transakcjeDesired = transakcjeActive;
        if (transactionsController) {
            transactionsController.setActive(transakcjeActive);
            transactionsController.setDesired(transakcjeDesired);
        }
        if (transakcjeActive) {
            loadGeoJson();
            loadListPage(1, false);
        } else {
            if (selectedTid) {
                clearSelection({ keepDetails: false, sync: false });
            }
            if (geoLayer) {
                clearGeoLayer();
            }
            if (transactionsController) {
                transactionsController.clear();
            }
            clearOverlapLayer();
            latestGeoData = { features: [], aggregated: false, stats: { count: 0, avg_cena: null } };
            listRows = [];
            listTotal = 0;
            listTotalEstimated = false;
            listHasMore = false;
            listPage = 1;
            overlapBrowseFeatures = null;
            overlapBrowseLatlng = null;
            combinedBrowseTransactions = null;
            combinedBrowseGunb = null;
            combinedBrowseOtherHits = null;
            combinedBrowseLatlng = null;
            buildCombinedBadges();
            renderListPanel();
        }
        var transakcjeToggleEl = getLayerToggleEl('transakcje');
        if (transakcjeToggleEl) transakcjeToggleEl.classList.toggle('is-active', transakcjeActive);
        syncAssetSwitchVisibility();
        syncLayerBadge();
        renderListPanel();
        syncUrl();
    }

    function toggleDzialkiLayer() {
        if (dzialkiController) {
            dzialkiController.toggle();
        }
    }

    function syncDzialkiToggleVisibility() {
        if (dzialkiController) {
            dzialkiController.syncVisibility();
        }
    }

    function toggleBudynkiLayer() {
        if (budynkiController) {
            budynkiController.toggle();
        }
    }

    function syncBudynkiToggleVisibility() {
        if (budynkiController) {
            budynkiController.syncVisibility();
        }
    }

    function toggleGunbLayer() {
        if (gunbController) {
            gunbController.toggle();
        }
        renderListPanel();
    }

    function clearGunbBadgeLayer() {
        if (gunbBadgeLayer) {
            gunbBadgeLayer.remove();
            gunbBadgeLayer = null;
        }
    }

    function clearCombinedBadgeLayer() {
        overlapManager.clearCombinedBadgeLayer();
    }

    function buildCombinedBadges() {
        overlapManager.buildCombinedBadges();
    }

    function renderGunbData(data) {
        clearGunbBadgeLayer();

        bringDataLayersToFront();
        buildCombinedBadges();
        syncSelectedGunbVisual();

        if (gunbActive && listSubTab === 'gunb') {
            renderListPanel();
        }
        reapplyHoverMarkerHighlight();

        return gunbLayer;
    }

    function loadGunb() {
        if (!gunbController) {
            return;
        }

        gunbController.load();
    }

    function syncGunbToggleVisibility() {
        if (gunbController) {
            gunbController.syncVisibility();
        }
    }

    function toggleOtoczenieLayer() {
        otoczenieModule.toggleLayer();
    }







    function getPogLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Źródło danych</div>'
            + '<div class="nm-layer-info-row"><span>Warstwa</span><span>Plan ogólny gminy, usługa przeglądania map</span></div>'
            + '<div class="nm-layer-info-row"><span>Źródło szczegółów</span><span>Lokalny import PostGIS</span></div>'
            + '<p class="nm-layer-info-copy">Rastrowa usługa przeglądania map służy tylko do podglądu. Dane w panelu szczegółów pochodzą z tabel zaimportowanych z Rejestru urbanistycznego.</p>'
            + renderSourceLinks([
                { href: PogLayer.WMS_URL + '?SERVICE=WMS&REQUEST=GetCapabilities', label: 'Usługa przeglądania map' },
                { href: 'https://rejestr-urbanistyczny.gov.pl/published/pog', label: 'Plan ogólny gminy w Rejestrze urbanistycznym' }
            ]);
    }

    function getMpzpLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Źródło danych</div>'
            + '<div class="nm-layer-info-row"><span>Warstwa</span><span>Krajowa Integracja Miejscowych Planów Zagospodarowania Przestrzennego, usługa przeglądania map</span></div>'
            + '<div class="nm-layer-info-row"><span>Źródło</span><span>Geoportal Głównego Urzędu Geodezji i Kartografii</span></div>'
            + '<p class="nm-layer-info-copy">To dotychczasowa rastrowa warstwa miejscowych planów zagospodarowania przestrzennego. Umożliwia wizualne porównanie z danymi lokalnymi, ale nie udostępnia w aplikacji wektorowych pól przeznaczeń.</p>'
            + renderSourceLinks([
                { href: 'https://mapy.geoportal.gov.pl/wss/ext/KrajowaIntegracjaMiejscowychPlanowZagospodarowaniaPrzestrzennego?SERVICE=WMS&REQUEST=GetCapabilities', label: 'Usługa przeglądania map' }
            ]);
    }

    function getMpzpRuLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Źródło danych</div>'
            + '<div class="nm-layer-info-row"><span>Warstwa</span><span>Przeznaczenia z miejscowych planów zagospodarowania przestrzennego z lokalnego importu</span></div>'
            + '<div class="nm-layer-info-row"><span>Źródło</span><span>Rejestr urbanistyczny, pliki danych przestrzennych</span></div>'
            + '<p class="nm-layer-info-copy">Warstwa pokazuje wektorowe wydzielenia i przeznaczenia z miejscowych planów zagospodarowania przestrzennego, jeżeli są obecne w zaimportowanych plikach danych przestrzennych. Jeżeli gmina udostępnia tylko zasięg aktu i rysunek, ta warstwa może być pusta.</p>'
            + '<p class="nm-layer-info-copy">Po przybliżeniu mapy warstwa pokazuje też linie zabudowy, jeżeli gmina publikuje je w swoim serwisie planów: nieprzekraczalna linia wyznacza granicę, do której może sięgać budynek, a obowiązująca miejsce, w którym ma stanąć jego ściana. Wektorowy rysunek w serwisie gminy może być przesunięty względem granic działek; rozstrzyga rysunek planu dołączony do uchwały.</p>'
            + renderSourceLinks([
                { href: 'https://rejestr-urbanistyczny.gov.pl/published/mpzp', label: 'Miejscowe plany zagospodarowania przestrzennego w Rejestrze urbanistycznym' }
            ]);
    }

    function getStudiumLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Źródło danych</div>'
            + '<div class="nm-layer-info-row"><span>Warstwa</span><span>Studium uwarunkowań i kierunków zagospodarowania przestrzennego, usługa przeglądania map</span></div>'
            + '<div class="nm-layer-info-row"><span>Źródło</span><span>Geoportal Głównego Urzędu Geodezji i Kartografii</span></div>'
            + '<p class="nm-layer-info-copy">Studium jest starszym dokumentem planistycznym. Warstwa pochodzi z rastrowej usługi przeglądania map, więc traktuj ją jako podgląd i porównuj z aktualnymi aktami w Rejestrze urbanistycznym.</p>'
            + renderSourceLinks([
                { href: 'https://mapy.geoportal.gov.pl/wss/ext/KrajowaIntegracjaStudiumKierunkowZagospodarowaniaPrzestrzennego?SERVICE=WMS&REQUEST=GetCapabilities', label: 'Usługa przeglądania map' }
            ]);
    }

    function getPowodzLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Prawdopodobieństwo powodzi w dowolnym roku</div>'
            + '<p class="nm-layer-info-copy">Warstwy przedstawiają modelowane zasięgi i głębokość wody z Map zagrożenia powodziowego Wód Polskich. Scenariusze nakładają się i są coraz mocniej widoczne wraz ze wzrostem prawdopodobieństwa. Odcień wewnątrz każdej strefy może się dodatkowo różnić zależnie od modelowanej głębokości wody.</p>'
            + '<p class="nm-layer-info-copy">Wartość 1% nie oznacza regularnej powodzi raz na 100 lat. Oznacza prawdopodobieństwo wystąpienia takiego przepływu w każdym roku. Mapa pomaga wstępnie ocenić położenie domu lub działki, ale nie zastępuje dokumentów planistycznych ani indywidualnej analizy.</p>'
            + renderSourceLinks([
                { href: 'https://powodz.gov.pl/pl/o_mapach', label: 'Opis Map zagrożenia powodziowego' }
            ]);
    }

    function getKowrLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Działki w Zasobie Własności Rolnej Skarbu Państwa</div>'
            + '<div class="nm-layer-info-row"><span>Źródło danych</span><span>Krajowy Ośrodek Wsparcia Rolnictwa</span></div>'
            + '<div class="nm-layer-info-row"><span>Sposób prezentacji</span><span>Liczby dla województw i powiatów, lokalizacje przy średnim przybliżeniu oraz granice konkretnych działek</span></div>'
            + '<p class="nm-layer-info-copy">Po przybliżeniu do granic działek stuknij zielony obszar, aby zobaczyć pełny identyfikator ewidencyjny, aktualność danych i ewentualne ogłoszenie eRolnik jednoznacznie powiązane z działką.</p>'
            + '<p class="nm-layer-info-copy">Obecność działki w zasobie nie oznacza automatycznie, że jest ona aktualnie oferowana na sprzedaż lub do dzierżawy.</p>'
            + renderSourceLinks([
                { href: KowrLayer.WMS_URL + '?SERVICE=WMS&REQUEST=GetCapabilities', label: 'Oficjalna usługa przeglądania map' },
                { href: 'https://www.gov.pl/web/kowr', label: 'Krajowy Ośrodek Wsparcia Rolnictwa' }
            ]);
    }

    function getOwnershipLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Mapa własności działek</div>'
            + '<div class="nm-layer-info-row"><span>Źródło danych</span><span>Lokalny import Ewidencji Gruntów i Budynków</span></div>'
            + '<div class="nm-layer-info-row"><span>Prezentacja</span><span>Kafle wektorowe generowane przez Metroskop z geometrii działek</span></div>'
            + '<p class="nm-layer-info-copy">Kolory oznaczają kategorię właściciela lub władającego według grup rejestrowych Ewidencji Gruntów i Budynków. Nie identyfikują konkretnej osoby ani firmy i nie są dokumentem potwierdzającym tytuł prawny.</p>'
            + '<p class="nm-layer-info-copy">Brak kategorii nie oznacza własności prywatnej ani publicznej. Pokrycie mapy zależy od tego, czy dla danego powiatu zakończył się import grup rejestrowych z Ewidencji Gruntów i Budynków.</p>';
    }

    function getLandUseLayerInfoHtml() {
        return '<div class="nm-layer-info-title">Użytki gruntowe działek</div>'
            + '<div class="nm-layer-info-row"><span>Źródło danych</span><span>Lokalny import Ewidencji Gruntów i Budynków</span></div>'
            + '<div class="nm-layer-info-row"><span>Prezentacja</span><span>Kody użytków zapisane przy geometrii działki, bez dodatkowego zapytania o granice</span></div>'
            + '<p class="nm-layer-info-copy">Kolor pomaga rozróżnić grunty rolne, leśne, zabudowane, komunikacyjne, pod wodami i pozostałe. Pełne kody z Ewidencji Gruntów i Budynków są dostępne w karcie i szczegółach działki.</p>'
            + '<p class="nm-layer-info-copy">Jeżeli działka ma kilka kodów, mapa pokazuje kategorię „Użytki mieszane”. Bez powierzchni poszczególnych części nie wskazujemy użytku dominującego.</p>';
    }

    function renderOtoczenieData(data) {
        var layer = otoczenieModule.renderData(data);

        if (!pendingTapBrowseRestore && selectedOtoczenieId && !selectedOtoczenieFeature && data && Array.isArray(data.features)) {
            var restoredFeature = data.features.find(function(feature) {
                return String(getOtoczenieFeatureId(feature)) === String(selectedOtoczenieId);
            });
            if (restoredFeature) {
                selectedOtoczenieFeature = restoredFeature;
                selectedLatLng = selectedLatLng || getFeatureCentroid(restoredFeature);
                renderOtoczenieDetails(restoredFeature);
                fetchOtoczenieUrbanPlanning(restoredFeature);
                updateSelectionControl();
                selectionManager.applySelectionFocusState();
                var restoredTab = activeTab === 'list' ? 'details' : activeTab;
                setTab(restoredTab, {
                    sync: false,
                    snap: restoredTab === 'filters' ? 'full' : 'half'
                });
            }
        }

        tryRestoreTapBrowse();

        return layer;
    }

    function loadOtoczenie() {
        otoczenieModule.load();
    }

    function syncOtoczenieToggleVisibility() {
        otoczenieModule.syncToggleVisibility();
    }

    function syncLayerTogglesVisibility() {
        if (layerPanel) {
            layerPanel.syncVisibility();
        }
        syncListingCategorySwitch();
    }

    function syncLayerBadge() {
        if (layerPanel) {
            layerPanel.syncBadge();
        }
    }

    function initLayerToggles() {
        layerPanel = createLayerPanel({
            getMap: function() { return map; },
            mapZoom: mapZoom,
            parcelRenderMode: PARCEL_RENDER_MODE,
            getState: getLayerPanelState,
            toggleLayer: {
                ortho: toggleOrthoLayer,
                mpzp: toggleMpzpLayer,
                mpzpRu: toggleMpzpRuLayer,
                pog: togglePogLayer,
                studium: toggleStudiumLayer,
                powodz: togglePowodzLayer,
                gesut: toggleGesutLayer,
                portPolska: togglePortPolskaLayer,
                sidusis: toggleSidusisLayer,
                dzialki: toggleDzialkiLayer,
                gunb: toggleGunbLayer,
                transakcje: toggleTransakcjeLayer,
                sygnaly: toggleSignalsLayer,
                ogloszenia: toggleListingsLayer,
                ofertyDeweloperow: toggleDeveloperOffersLayer,
                budynki: toggleBudynkiLayer,
                otoczenie: toggleOtoczenieLayer
            },
            syncLayerVisibility: {
                ortho: syncOrthoToggleVisibility,
                mpzp: syncMpzpToggleVisibility,
                mpzpRu: syncMpzpRuToggleVisibility,
                pog: syncPogToggleVisibility,
                studium: syncStudiumToggleVisibility,
                powodz: syncPowodzToggleVisibility,
                gesut: syncGesutToggleVisibility,
                portPolska: syncPortPolskaToggleVisibility,
                sidusis: syncSidusisToggleVisibility,
                dzialki: syncDzialkiToggleVisibility,
                gunb: syncGunbToggleVisibility,
                transakcje: syncTransakcjeToggleVisibility,
                sygnaly: syncSignalsToggleVisibility,
                ogloszenia: syncListingsToggleVisibility,
                ofertyDeweloperow: syncDeveloperOffersToggleVisibility,
                budynki: syncBudynkiToggleVisibility,
                otoczenie: syncOtoczenieToggleVisibility
            },
            getLayerInfoHtml: {
                mpzp: getMpzpLayerInfoHtml,
                mpzpRu: getMpzpRuLayerInfoHtml,
                pog: getPogLayerInfoHtml,
                studium: getStudiumLayerInfoHtml,
                powodz: getPowodzLayerInfoHtml,
                kowr: getKowrLayerInfoHtml,
                ownership: getOwnershipLayerInfoHtml,
                landUse: getLandUseLayerInfoHtml,
            }
        });
    }

    function handleLayerControllerStateChange() {
        if (syncMeshCoverageDetails) syncMeshCoverageDetails();
        if (pointQuerySession && pointQuerySession.get()) {
            pointQuerySession.cancel();
            renderListPanel();
        }
        if (selectedNoiseContext && !noiseLayerRuntime.getDesired(selectedNoiseContext.layerKey)) {
            selectedNoiseContext = null;
            if (interactiveHitDispatcher) interactiveHitDispatcher.clearClickMarker();
            if (activeTab === 'details') renderDetailsPlaceholder();
        }
        if (selectedEducationId && !educationLayerRuntime.getDesired()) {
            selectedEducationId = null;
            if (interactiveHitDispatcher) interactiveHitDispatcher.clearClickMarker();
            if (activeTab === 'details') renderDetailsPlaceholder();
        }
        syncLayerBadge();
        if (layerPanel) layerPanel.syncLegends();
        syncListingCategorySwitch();
        syncUrl();
    }

    var syncMeshCoverageDetails = null;
    var meshDetailSelection = null;
    function meshSelectionKey() {
        return [selectedDid, selectedBid, selectedTid, selectedGunbId, selectedListingId, selectedOtoczenieId].join('|');
    }
    function initLayerControllers() {
        if (!syncMeshCoverageDetails && detailsContentEl) syncMeshCoverageDetails = attachMeshCoverageDetails({
            element: detailsContentEl,
            getPoint: () => selectedLatLng && meshDetailSelection && meshDetailSelection.key === meshSelectionKey()
                ? meshDetailSelection.point : selectedLatLng,
            baseUrl: BASE_URL,
        });
        var controllers = createLayerControllers({
            baseUrl: BASE_URL,
            parcelRenderMode: PARCEL_RENDER_MODE,
            overlayLayersMinZoom: OVERLAY_LAYERS_MIN_ZOOM,
            getMap: function() { return map; },
            getMapZoom: mapZoom,
            getCurrentBbox: currentBbox,
            getLayerToggleEl: getLayerToggleEl,
            onBringDataLayersToFront: bringDataLayersToFront,
            onStateChange: handleLayerControllerStateChange,
            onOverlayAttributionChange: updateOverlayMapAttribution,
            getGeoQuery: getGeoQuery,
            isLimitedMode: function() { return LIMITED_MODE; },
            individualZoomThreshold: INDIVIDUAL_ZOOM_THRESHOLD,
            formatAggCount: formatAggCount,
            onMapClickHandled: consumeHandledMapClick,
            onSelectTransaction: handleTransactionFeatureTap,
            onRenderGeoJson: renderGeoJson,
            onLoadingChange: showMapLoading,
            onLimitedModeCleared: handleLimitedGeoState,
            onFetchGeoJsonError: handleGeoJsonFetchError,
            getClusterViewportPadding: getMapPaddingForPanel,
            onDataLayerRequestStarted: handleDataLayerRequestStarted,
            onDataLayerRequestSettled: handleDataLayerRequestSettled,
            onRenderSignals: renderSignalsData,
            onSignalsCleared: function() {},
            onSelectSignalHit: function(props, latlng) {
                startPointQuery(latlng, null, [{ type: 'signal', id: String(props.id), properties: props }]);
            },
            getListingFilterParams: getListingFilterParams,
            getListingRadiusFilterState: getListingRadiusFilterState,
            onRenderListings: renderListingsData,
            onListingsCleared: function() {},
            onSelectListing: function(props, latlng) {
                if (!latlng) return;
                startPointQuery(latlng, null, [{ type: 'listing', id: String(props.id), properties: props,
                    feature: { type: 'Feature', properties: props, geometry: { type: 'Point', coordinates: [latlng.lng, latlng.lat] } } }]);
            },
            onListingClusterClick: onListingClusterClick,
            getDeveloperOfferFilterParams: getDeveloperOfferFilterParams,
            onRenderDeveloperOffers: renderDeveloperOffersData,
            onDeveloperOffersCleared: clearDeveloperOffersData,
            onSelectDeveloperInvestment: selectDeveloperInvestmentHit,
            onRenderDzialki: renderDzialkiData,
            onRenderMpzpRu: renderMpzpRuData,
            onSelectBuilding: selectBuilding,
            isDesktopLayout: isDesktopLayout,
            onRenderBudynki: renderBudynkiData,
            getBdot10kFilterQueryString: getBdot10kFilterQueryString,
            getGunbFilterQueryString: getGunbFilterQueryString,
            onSelectGunbPermit: selectGunbPermit,
            onBrowseGunbGroup: browseGunbInPanel,
            onGunbGroupsChange: function(groups) { gunbGroupsCache = groups || {}; },
            onRenderGunb: renderGunbData,
            onGunbCleared: function() {
                selectedGunbLayer = null;
                clearGunbBadgeLayer();
                gunbGroupsCache = {};
                buildCombinedBadges();
            },
            onRenderOtoczenie: renderOtoczenieData,
            onRenderNoise: function(layerKey) { tryRestoreNoiseSelection(layerKey); },
            getActiveTab: function() { return activeTab; },
            getSelectedDid: function() { return selectedDid; },
            getSelectedBid: function() { return selectedBid; },
            onRenderSelectionPin: renderSelectionPinData,
            layers: {
                ortho: {
                    getLayer: function() { return orthoLayer; },
                    setLayer: function(layer) { orthoLayer = layer; },
                    getActive: function() { return orthoActive; },
                    setActive: function(value) { orthoActive = !!value; },
                    getDesired: function() { return orthoDesired; },
                    setDesired: function(value) { orthoDesired = !!value; },
                },
                gesut: {
                    getLayer: function() { return gesutLayer; },
                    setLayer: function(layer) { gesutLayer = layer; },
                    getActive: function() { return gesutActive; },
                    setActive: function(value) { gesutActive = !!value; },
                    getDesired: function() { return gesutDesired; },
                    setDesired: function(value) { gesutDesired = !!value; },
                },
                portPolska: {
                    getLayer: function() { return portPolskaLayer; },
                    setLayer: function(layer) { portPolskaLayer = layer; },
                    getActive: function() { return portPolskaActive; },
                    setActive: function(value) { portPolskaActive = !!value; },
                    getDesired: function() { return portPolskaDesired; },
                    setDesired: function(value) { portPolskaDesired = !!value; },
                },
                sidusis: {
                    getLayer: function() { return sidusisLayer; },
                    setLayer: function(layer) { sidusisLayer = layer; },
                    getActive: function() { return sidusisActive; },
                    setActive: function(value) { sidusisActive = !!value; },
                    getDesired: function() { return sidusisDesired; },
                    setDesired: function(value) { sidusisDesired = !!value; },
                },
                mpzp: {
                    getLayer: function() { return mpzpLayer; },
                    setLayer: function(layer) { mpzpLayer = layer; },
                    getActive: function() { return mpzpActive; },
                    setActive: function(value) { mpzpActive = !!value; },
                    getDesired: function() { return mpzpDesired; },
                    setDesired: function(value) { mpzpDesired = !!value; },
                },
                mpzpRu: {
                    getLayer: function() { return mpzpRuLayer; },
                    setLayer: function(layer) { mpzpRuLayer = layer; },
                    getActive: function() { return mpzpRuActive; },
                    setActive: function(value) { mpzpRuActive = !!value; },
                    getDesired: function() { return mpzpRuDesired; },
                    setDesired: function(value) { mpzpRuDesired = !!value; },
                    getAbortController: function() { return abortMpzpRu; },
                    setAbortController: function(controller) { abortMpzpRu = controller; },
                },
                pog: {
                    getLayer: function() { return pogLayer; },
                    setLayer: function(layer) { pogLayer = layer; },
                    getActive: function() { return pogActive; },
                    setActive: function(value) { pogActive = !!value; },
                    getDesired: function() { return pogDesired; },
                    setDesired: function(value) { pogDesired = !!value; },
                },
                studium: {
                    getLayer: function() { return studiumLayer; },
                    setLayer: function(layer) { studiumLayer = layer; },
                    getActive: function() { return studiumActive; },
                    setActive: function(value) { studiumActive = !!value; },
                    getDesired: function() { return studiumDesired; },
                    setDesired: function(value) { studiumDesired = !!value; },
                },
                powodz: {
                    getLayer: function() { return powodzLayer; },
                    setLayer: function(layer) { powodzLayer = layer; },
                    getActive: function() { return powodzActive; },
                    setActive: function(value) { powodzActive = !!value; },
                    getDesired: function() { return powodzDesired; },
                    setDesired: function(value) { powodzDesired = !!value; },
                },
                transakcje: {
                    getLayer: function() { return geoLayer; },
                    setLayer: function(layer) { geoLayer = layer; },
                    getActive: function() { return transakcjeActive; },
                    setActive: function(value) { transakcjeActive = !!value; },
                    getDesired: function() { return transakcjeDesired; },
                    setDesired: function(value) { transakcjeDesired = !!value; },
                    getAbortController: function() { return abortGeo; },
                    setAbortController: function(controller) { abortGeo = controller; },
                },
                sygnaly: {
                    getLayer: function() { return sygnalyLayer; },
                    setLayer: function(layer) { sygnalyLayer = layer; },
                    getActive: function() { return sygnalyActive; },
                    setActive: function(value) { sygnalyActive = !!value; },
                    getDesired: function() { return sygnalyDesired; },
                    setDesired: function(value) { sygnalyDesired = !!value; },
                    getAbortController: function() { return abortSignals; },
                    setAbortController: function(controller) { abortSignals = controller; },
                },
                ogloszenia: {
                    getLayer: function() { return ogloszeniaLayer; },
                    setLayer: function(layer) { ogloszeniaLayer = layer; },
                    getActive: function() { return ogloszeniaActive; },
                    setActive: function(value) { ogloszeniaActive = !!value; },
                    getDesired: function() { return ogloszeniaDesired; },
                    setDesired: function(value) { ogloszeniaDesired = !!value; },
                    getAbortController: function() { return abortListings; },
                    setAbortController: function(controller) { abortListings = controller; },
                },
                ofertyDeweloperow: {
                    getLayer: function() { return ofertyDeweloperowLayer; },
                    setLayer: function(layer) { ofertyDeweloperowLayer = layer; },
                    getActive: function() { return ofertyDeweloperowActive; },
                    setActive: function(value) { ofertyDeweloperowActive = !!value; },
                    getDesired: function() { return ofertyDeweloperowDesired; },
                    setDesired: function(value) { ofertyDeweloperowDesired = !!value; },
                    getAbortController: function() { return abortDeveloperOffers; },
                    setAbortController: function(controller) { abortDeveloperOffers = controller; },
                },
                dzialki: {
                    getLayer: function() { return dzialkiLayer; },
                    setLayer: function(layer) { dzialkiLayer = layer; },
                    getActive: function() { return dzialkiActive; },
                    setActive: function(value) { dzialkiActive = !!value; },
                    getDesired: function() { return dzialkiDesired; },
                    setDesired: function(value) { dzialkiDesired = !!value; },
                    getAbortController: function() { return abortDzialki; },
                    setAbortController: function(controller) { abortDzialki = controller; },
                },
                budynki: {
                    getLayer: function() { return budynkiLayer; },
                    setLayer: function(layer) { budynkiLayer = layer; },
                    getActive: function() { return budynkiActive; },
                    setActive: function(value) { budynkiActive = !!value; },
                    getDesired: function() { return budynkiDesired; },
                    setDesired: function(value) { budynkiDesired = !!value; },
                    getAbortController: function() { return abortBudynki; },
                    setAbortController: function(controller) { abortBudynki = controller; },
                },
                gunb: {
                    getLayer: function() { return gunbLayer; },
                    setLayer: function(layer) { gunbLayer = layer; },
                    getActive: function() { return gunbActive; },
                    setActive: function(value) { gunbActive = !!value; },
                    getDesired: function() { return gunbDesired; },
                    setDesired: function(value) { gunbDesired = !!value; },
                    getAbortController: function() { return abortGunb; },
                    setAbortController: function(controller) { abortGunb = controller; },
                },
                otoczenie: {
                    getLayer: function() { return otoczenieLayer; },
                    setLayer: function(layer) { otoczenieLayer = layer; },
                    getActive: function() { return otoczenieActive; },
                    setActive: function(value) { otoczenieActive = !!value; },
                    getDesired: function() { return otoczenieDesired; },
                    setDesired: function(value) { otoczenieDesired = !!value; },
                    getAbortController: function() { return abortOtoczenie; },
                    setAbortController: function(controller) { abortOtoczenie = controller; },
                },
                selectionPin: {
                    getLayer: function() { return selectionPinLayer; },
                    setLayer: function(layer) { selectionPinLayer = layer; },
                    getAbortController: function() { return abortSelectionPin; },
                    setAbortController: function(controller) { abortSelectionPin = controller; },
                },
            },
        });

        orthoController = controllers.orthoController;
        gesutController = controllers.gesutController;
        portPolskaController = controllers.portPolskaController;
        sidusisController = controllers.sidusisController;
        mpzpController = controllers.mpzpController;
        mpzpRuController = controllers.mpzpRuController;
        pogController = controllers.pogController;
        studiumController = controllers.studiumController;
        powodzController = controllers.powodzController;
        kowrController = controllers.kowrController;
        ownershipController = controllers.ownershipController;
        landUseController = controllers.landUseController;
        transactionsController = controllers.transactionsController;
        signalsController = controllers.signalsController;
        listingsController = controllers.listingsController;
        developerOffersController = controllers.developerOffersController;
        dzialkiController = controllers.dzialkiController;
        budynkiController = controllers.budynkiController;
        gunbController = controllers.gunbController;
        otoczenieController = controllers.otoczenieController;
        selectionPinController = controllers.selectionPinController;
    }

    function isDesktopLayout() {
        return panelLayout.isDesktopLayout();
    }

    function getCurrentSheetSnap() {
        return panelLayout.getCurrentSnap();
    }

    function syncLayoutMode() {
        panelLayout.syncLayoutMode();
    }

    function setSheetSnap(snap) {
        panelLayout.setSheetSnap(snap);
    }

    function initSheetDrag() {
        panelLayout.initSheetDrag();
    }

    function getMapPaddingForPanel() {
        return panelLayout.getMapPaddingForPanel();
    }

    function easeMapToKeepPointVisible(latlng) {
        panelLayout.easeMapToKeepPointVisible(latlng);
    }

    function syncNearbyHalfSnap() {
        if (isDesktopLayout()) return;
        if (activeTab !== 'nearby') {
            panelLayout.setHalfSnapHeight(null);
            return;
        }
        var sheetEl = document.getElementById('nm-sheet');
        var panelEl = document.getElementById('nm-panel-nearby');
        if (!sheetEl || !panelEl) return;
        var handleEl = document.getElementById('nm-sheet-handle');
        var tabsEl = sheetEl.querySelector('.nm-tabs');
        var handleH = handleEl ? handleEl.offsetHeight : 0;
        var tabsH = tabsEl ? tabsEl.offsetHeight : 0;
        var headEl = panelEl.querySelector('.nm-panel-head');
        var contentEl = panelEl.querySelector('.nm-panel-scroll');
        var headH = headEl ? headEl.offsetHeight : 0;
        var contentH = contentEl ? contentEl.scrollHeight : 0;
        var naturalH = handleH + tabsH + headH + contentH + 12;
        // Cap so the map keeps at least ~45% of the viewport.
        var maxH = Math.round(window.innerHeight * 0.55);
        panelLayout.setHalfSnapHeight(Math.min(naturalH, maxH));
    }

    function setTab(tab, options) {
        if (VALID_TABS.indexOf(tab) === -1) return;
        activeTab = tab;
        if (tab !== 'nearby' && personaModule && personaModule.isActive()) {
            personaModule.reset();
        }
        options = options || {};
        tabEls.forEach(function(el) {
            var isActiveTab = el.getAttribute('data-tab') === tab;
            el.classList.toggle('is-active', isActiveTab);
            el.setAttribute('aria-selected', isActiveTab ? 'true' : 'false');
        });
        panelEls.forEach(function(panel) {
            panel.classList.toggle('is-active', panel.id === 'nm-panel-' + tab);
        });
        panelFooterEls.forEach(function(footer) {
            footer.classList.toggle('is-active', footer.classList.contains('nm-panel-footer--for-' + tab));
        });
        if (selectionBannerEl) {
            selectionBannerEl.classList.toggle('is-tab-hidden', tab === 'nearby');
        }
        if (tab !== 'nearby') {
            panelLayout.setHalfSnapHeight(null);
        } else {
            // Defer measurement until panel becomes visible.
            requestAnimationFrame(syncNearbyHalfSnap);
        }
        if (tab === 'nearby' && !selectedLatLng && pointQuerySession && pointQuerySession.get()) {
            renderPointNearbyChoice();
        }
        if (options.snap) setSheetSnap(options.snap);
        applyNearbyLayerVisibility();
        syncPageHeading();
        if (options.sync !== false) syncUrl();
    }

    // The visually hidden h1 follows what the panel shows: the selected object
    // on the details tab, the list title on the list tab.
    function syncPageHeading() {
        if (activeTab === 'details' && detailsMetaEl && !detailsMetaEl.hidden && detailsMetaEl.textContent.trim()) {
            setPageHeading(detailsMetaEl.textContent);
            return;
        }
        if (activeTab === 'list' && listTitleEl && listTitleEl.textContent.trim()) {
            setPageHeading(listTitleEl.textContent);
            return;
        }
        if (activeTab === 'nearby') {
            setPageHeading('Otoczenie wybranego miejsca');
            return;
        }
        setPageHeading('');
    }

    if (typeof MutationObserver === 'function') {
        [listTitleEl, detailsMetaEl].forEach(function(el) {
            if (!el) return;
            new MutationObserver(syncPageHeading).observe(el, {
                childList: true,
                characterData: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['hidden'],
            });
        });
    }

    function maybeExpandSheetFromScroll(scrollEl) {
        if (isDesktopLayout()) return;
        if (!scrollEl || getCurrentSheetSnap() === 'full') return;
        if (activeTab === 'list') return;
        if (scrollEl.scrollHeight <= scrollEl.clientHeight + 16) return;
        if (scrollEl.scrollTop + scrollEl.clientHeight < scrollEl.scrollHeight - 10) return;
        setSheetSnap('full');
    }

    function sortField(sort) {
        return sortFieldState(sort);
    }

    function sortDir(sort) {
        return sortDirState(sort);
    }

    function renderSignalNoticeDetails() {
        if (!signalNotice) {
            return false;
        }

        var title = 'Potwierdzenie zgłoszenia';
        var body = 'Nie udało się potwierdzić zgłoszenia. Poproś o nowy link i spróbuj ponownie.';
        var badgeClass = 'ms-alert--danger nm-signal-submit__status--error';

        if (signalNotice === 'moderation_pending') {
            title = 'Zgłoszenie zostało przekazane do moderacji';
            body = 'Adres e-mail został potwierdzony. Zgłoszenie zostało przekazane do moderacji i zostanie opublikowane, jeśli jest w porządku.';
            badgeClass = 'ms-alert--success nm-signal-submit__status--success';
        } else if (signalNotice === 'moderation_already_pending') {
            title = 'To zgłoszenie już czeka na moderację';
            body = 'Ten link został już wcześniej użyty. Zgłoszenie nadal czeka na moderację i zostanie opublikowane, jeśli jest w porządku.';
            badgeClass = 'ms-alert--success nm-signal-submit__status--success';
        }

        setDetailsMeta('Sygnał społeczności');
        setDetailsKicker('Wybrany sygnał społeczności');
        setDetailsDepartment('signals');
        detailsContentEl.innerHTML = ''
            + '<div class="nm-detail-stack">'
            + '  <section class="ms-card ms-card--grid nm-detail-block">'
            + '    <div class="nm-section-label">Sygnały społeczności</div>'
            + '    <h3 class="nm-detail-title">' + esc(title) + '</h3>'
            + '    <div class="ms-alert nm-signal-submit__status ' + badgeClass + '">' + esc(body) + '</div>'
            + '    <p class="nm-detail-copy">Mapa została ustawiona na miejscu zgłoszenia, więc możesz od razu sprawdzić wskazany punkt.</p>'
            + '  </section>'
            + '</div>';
        openNearbyBtn.disabled = true;

        return true;
    }

    function restoreStateFromUrl() {
        var restored = restoreStateFromUrlState();
        currentAssetType = restored.currentAssetType;
        currentSort = restored.currentSort;
        activeTab = restored.activeTab;
        selectedTid = restored.selectedTid;
        selectedDid = restored.selectedDid;
        selectedBid = restored.selectedBid;
        selectedGunbId = restored.selectedGunbId;
        selectedListingId = restored.selectedListingId;
        selectedDeveloperInvestmentId = restored.selectedDeveloperInvestmentId || null;
        pendingDeveloperInvestmentRestore = !!selectedDeveloperInvestmentId;
        selectedOtoczenieId = restored.selectedOtoczenieId;
        selectedNoiseContext = restored.selectedNoiseContext;
        tapBrowseLatlng = restored.browseLatlng;
        // A saved browse point represents the list tab. Older URLs could keep
        // stale browse_* parameters next to an explicit tab=details; in that
        // case the explicit details state must win.
        pendingTapBrowseRestore = !!restored.browseLatlng && restored.activeTab === 'list';
        selectedSignalContext = restored.selectedSignalContext;
        selectedSearchItem = restored.selectedSearchItem || null;
        activeNearbyId = restored.activeNearbyId;
        pendingNearbyRestore = restored.pendingNearbyRestore;
        nearbyLoaded = restored.nearbyLoaded;
        transakcjeDesired = restored.layerState.transakcjeDesired;
        transakcjeActive = restored.layerState.transakcjeActive;
        if (!transakcjeDesired) {
            selectedTransactionRow = null;
        }
        orthoDesired = restored.layerState.orthoDesired;
        mpzpDesired = restored.layerState.mpzpDesired;
        mpzpRuDesired = restored.layerState.mpzpRuDesired;
        pogDesired = restored.layerState.pogDesired;
        studiumDesired = restored.layerState.studiumDesired;
        powodzDesired = restored.layerState.powodzDesired;
        gesutDesired = restored.layerState.gesutDesired;
        portPolskaDesired = restored.layerState.portPolskaDesired;
        sidusisDesired = restored.layerState.sidusisDesired;
        dzialkiDesired = restored.layerState.dzialkiDesired;
        dzialkiActive = restored.layerState.dzialkiActive;
        budynkiDesired = restored.layerState.budynkiDesired;
        budynkiActive = restored.layerState.budynkiActive;
        gunbDesired = restored.layerState.gunbDesired;
        gunbActive = restored.layerState.gunbActive;
        sygnalyDesired = restored.layerState.sygnalyDesired;
        sygnalyActive = restored.layerState.sygnalyActive;
        ogloszeniaDesired = restored.layerState.ogloszeniaDesired || !!selectedListingId;
        ogloszeniaActive = restored.layerState.ogloszeniaActive || !!selectedListingId;
        ofertyDeweloperowDesired = restored.layerState.ofertyDeweloperowDesired || !!selectedDeveloperInvestmentId;
        ofertyDeweloperowActive = restored.layerState.ofertyDeweloperowActive || !!selectedDeveloperInvestmentId;
        otoczenieDesired = restored.layerState.otoczenieDesired;
        otoczenieActive = restored.layerState.otoczenieActive;
        if (signalNotice && !restored.selectedTid && !restored.selectedDid && !restored.selectedBid && !restored.selectedGunbId && !restored.selectedListingId && !restored.selectedSignalContext) {
            activeTab = 'details';
        }
        filterState = restored.filterState;
        selectedLatLng = restored.selectedLatLng;
        parcelMeasurementManager.setUrlState(restored.parcelMeasurementsState);
        return restored.initState;
    }

    function applyFilterInputs() {
        applyFilterInputsState({
            currentAssetType: currentAssetType,
            currentSort: currentSort,
            filterState: filterState,
            onSyncTerytHint: syncTerytHintFromInput
        });
        syncListingCategorySwitch();
        syncListingFilterTags();
        syncListingFilterVisibility();
        renderListingActiveFilters();
        renderTransactionActiveFilters();
        syncAssetSwitchVisibility();
        updateSearchRadiusCircles();
    }

    function readFilterInputsSnapshot() {
        return readFilterInputsState({
            filterState: filterState,
            parseTerytFilterValue: parseTerytFilterValue,
            onSyncTerytHint: syncTerytHintFromInput
        });
    }

    function readFilterInputs() {
        filterState = readFilterInputsSnapshot();
        syncListingFilterTags();
        syncListingFilterVisibility();
        renderListingActiveFilters();
        renderTransactionActiveFilters();
        updateSearchRadiusCircles();
    }

    function setFilterInputsPending(pending) {
        if (!applyFiltersBtn) {
            return;
        }
        applyFiltersBtn.classList.toggle('is-dirty', !!pending);
        applyFiltersBtn.setAttribute('aria-label', pending ? 'Zastosuj zmienione filtry' : 'Zastosuj');
    }

    var SEARCH_RADIUS_OVERLAYS = {
        transactions: {
            sourceId: 'src-search-radius-transactions',
            fillLayerId: 'lyr-search-radius-transactions-fill',
            lineLayerId: 'lyr-search-radius-transactions-line',
            fillColor: TRANSACTION_COLOR,
            lineColor: TRANSACTION_COLOR,
        },
        listings: {
            sourceId: 'src-search-radius-listings',
            fillLayerId: 'lyr-search-radius-listings-fill',
            lineLayerId: 'lyr-search-radius-listings-line',
            fillColor: '#2563eb',
            lineColor: '#1d4ed8',
        },
    };

    var WOJEWODZTWO_BOUNDS = {
        '02': [[14.8, 50.05], [17.8, 51.82]],
        '04': [[17.2, 52.42], [19.68, 53.85]],
        '06': [[21.55, 50.18], [24.15, 52.32]],
        '08': [[14.55, 51.35], [16.45, 53.18]],
        '10': [[18.05, 50.82], [20.75, 52.42]],
        '12': [[19.05, 49.18], [21.45, 50.55]],
        '14': [[19.25, 51.0], [23.15, 53.5]],
        '16': [[16.85, 49.95], [18.75, 51.25]],
        '18': [[21.08, 49.0], [23.65, 50.85]],
        '20': [[21.45, 52.25], [23.95, 54.45]],
        '22': [[16.7, 53.45], [19.65, 54.85]],
        '24': [[18.05, 49.38], [19.95, 51.15]],
        '26': [[19.7, 50.15], [21.35, 51.35]],
        '28': [[19.1, 53.15], [22.85, 54.45]],
        '30': [[15.75, 51.1], [18.95, 53.65]],
        '32': [[14.1, 53.0], [16.95, 54.85]],
    };

    function emptyFeatureCollection() {
        return { type: 'FeatureCollection', features: [] };
    }

    function radiusCircleFeature(lat, lng, radiusKm) {
        var parsedLat = Number(lat);
        var parsedLng = Number(lng);
        var parsedRadiusKm = Number(radiusKm || 1);
        if (!isFinite(parsedLat) || !isFinite(parsedLng) || !isFinite(parsedRadiusKm) || parsedRadiusKm <= 0) {
            return null;
        }

        var radiusMeters = Math.min(30, parsedRadiusKm) * 1000;
        var earthRadiusMeters = 6371008.8;
        var latRad = parsedLat * Math.PI / 180;
        var lngRad = parsedLng * Math.PI / 180;
        var angularDistance = radiusMeters / earthRadiusMeters;
        var coords = [];
        for (var i = 0; i <= 96; i++) {
            var bearing = 2 * Math.PI * (i / 96);
            var nextLat = Math.asin(
                Math.sin(latRad) * Math.cos(angularDistance)
                + Math.cos(latRad) * Math.sin(angularDistance) * Math.cos(bearing)
            );
            var nextLng = lngRad + Math.atan2(
                Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(latRad),
                Math.cos(angularDistance) - Math.sin(latRad) * Math.sin(nextLat)
            );
            coords.push([nextLng * 180 / Math.PI, nextLat * 180 / Math.PI]);
        }

        return {
            type: 'Feature',
            geometry: { type: 'Polygon', coordinates: [coords] },
            properties: {},
        };
    }

    function radiusBounds(lat, lng, radiusKm) {
        var parsedLat = Number(lat);
        var parsedLng = Number(lng);
        var parsedRadiusKm = Math.min(30, Number(radiusKm || 1));
        if (!isFinite(parsedLat) || !isFinite(parsedLng) || !isFinite(parsedRadiusKm) || parsedRadiusKm <= 0) {
            return null;
        }
        var latDelta = parsedRadiusKm / 110.574;
        var lngDelta = parsedRadiusKm / (111.320 * Math.max(0.2, Math.cos(parsedLat * Math.PI / 180)));
        return [
            [parsedLng - lngDelta, parsedLat - latDelta],
            [parsedLng + lngDelta, parsedLat + latDelta],
        ];
    }

    function fitMapToActiveLocationRadius() {
        if (!map) {
            return false;
        }
        var areaBbox = '';
        if (activeFilterScope === 'listings' && isListingAreaReference(filterState.listing_location_ref_type)) {
            areaBbox = filterState.listing_location_ref_bbox || '';
        } else if (activeFilterScope === 'transactions' && filterState.address_ref_type === 'bdot_area') {
            areaBbox = filterState.address_ref_bbox || '';
        }
        if (areaBbox) {
            var bbox = String(areaBbox).split(',').map(Number);
            if (bbox.length === 4 && bbox.every(isFinite)) {
                map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
                    padding: { top: 120, right: 72, bottom: 140, left: 72 },
                    duration: 800,
                    maxZoom: 16,
                });
                return true;
            }
        }
        var bounds = null;
        if (activeFilterScope === 'listings' && !isListingAreaReference(filterState.listing_location_ref_type)
            && filterState.listing_location_ref_lat && filterState.listing_location_ref_lng) {
            bounds = radiusBounds(filterState.listing_location_ref_lat, filterState.listing_location_ref_lng, filterState.listing_radius_km || 1);
        } else if (activeFilterScope === 'transactions' && filterState.address_ref_lat && filterState.address_ref_lng) {
            bounds = radiusBounds(filterState.address_ref_lat, filterState.address_ref_lng, filterState.address_radius_km || 1);
        }
        if (!bounds) {
            return false;
        }
        map.fitBounds(bounds, {
            padding: { top: 120, right: 72, bottom: 140, left: 72 },
            duration: 800,
            maxZoom: 16,
        });
        return true;
    }

    function hasActiveLocationFilter() {
        if (activeFilterScope === 'listings') {
            return !!(
                filterState.listing_location_query
                || filterState.listing_location_ref_lat
                || filterState.listing_location_ref_lng
            );
        }
        return !!(
            filterState.address_query
            || filterState.address_ref_lat
            || filterState.address_ref_lng
        );
    }

    function fitMapToSelectedWojewodztwo() {
        if (!map || !filterState.woj || hasActiveLocationFilter()) {
            return false;
        }
        var bounds = WOJEWODZTWO_BOUNDS[filterState.woj];
        if (!bounds) {
            return false;
        }
        map.fitBounds(bounds, {
            padding: { top: 120, right: 72, bottom: 140, left: 72 },
            duration: 800,
            maxZoom: 9,
        });
        return true;
    }

    function ensureSearchRadiusOverlay(def) {
        if (!map || !map.isStyleLoaded()) {
            return false;
        }
        if (!map.getSource(def.sourceId)) {
            map.addSource(def.sourceId, {
                type: 'geojson',
                data: emptyFeatureCollection(),
            });
        }
        if (!map.getLayer(def.fillLayerId)) {
            map.addLayer({
                id: def.fillLayerId,
                type: 'fill',
                source: def.sourceId,
                paint: {
                    'fill-color': def.fillColor,
                    'fill-opacity': 0.08,
                },
            });
        }
        if (!map.getLayer(def.lineLayerId)) {
            map.addLayer({
                id: def.lineLayerId,
                type: 'line',
                source: def.sourceId,
                paint: {
                    'line-color': def.lineColor,
                    'line-opacity': 0.38,
                    'line-width': 1.5,
                },
            });
        }
        return true;
    }

    function setSearchRadiusOverlay(scope, feature) {
        var def = SEARCH_RADIUS_OVERLAYS[scope];
        if (!def || !ensureSearchRadiusOverlay(def)) {
            return;
        }
        var source = map.getSource(def.sourceId);
        if (source && source.setData) {
            source.setData(feature ? { type: 'FeatureCollection', features: [feature] } : emptyFeatureCollection());
        }
    }

    function updateSearchRadiusCircles() {
        if (!map) {
            return;
        }
        setSearchRadiusOverlay('transactions', filterState.address_ref_type !== 'bdot_area'
            && filterState.address_ref_lat && filterState.address_ref_lng
            ? radiusCircleFeature(filterState.address_ref_lat, filterState.address_ref_lng, filterState.address_radius_km || 1)
            : null);
        setSearchRadiusOverlay('listings', !isListingAreaReference(filterState.listing_location_ref_type)
            && filterState.listing_location_ref_lat && filterState.listing_location_ref_lng
            ? radiusCircleFeature(filterState.listing_location_ref_lat, filterState.listing_location_ref_lng, filterState.listing_radius_km || 1)
            : null);
    }

    function getSharedFilters() {
        return getSharedFiltersState({
            currentAssetType: currentAssetType,
            currentSort: currentSort,
            filterState: filterState
        });
    }

    function getApiFilters() {
        var filters = getApiFiltersState({
            currentAssetType: currentAssetType,
            filterState: filterState
        });
        if (currentBucket) {
            filters.bucket = currentBucket;
        }
        return filters;
    }

    function hasActiveBdot10kFilters() {
        var params = getBdot10kFilterParams();
        return !!(
            params[BDOT10K_IMPACT_CLASSIFICATION_PARAM]
            || params[BDOT10K_NUISANCE_LEVEL_PARAM]
            || params[BDOT10K_USEFULNESS_LEVEL_PARAM]
        );
    }

    var historyStateReady = false;
    var historyBootstrapComplete = false;
    var lastHistorySignature = null;
    var mapHistoryCheckpointSignature = null;

    function getHistorySignalSignature() {
        if (!selectedSignalContext) return null;

        // Parcel/building renderers enrich this context asynchronously with
        // labels and subtitles. Those are URL metadata for the same selection,
        // not separate user navigation steps.
        if (selectedDid || selectedBid) {
            return selectedSignalContext.selectedSignalId
                ? { selectedSignalId: String(selectedSignalContext.selectedSignalId) }
                : null;
        }

        return {
            entityType: selectedSignalContext.entityType || null,
            entityId: selectedSignalContext.entityId != null ? String(selectedSignalContext.entityId) : null,
            selectedSignalId: selectedSignalContext.selectedSignalId
                ? String(selectedSignalContext.selectedSignalId)
                : null
        };
    }

    function getHistorySignature() {
        return JSON.stringify({
            asset: currentAssetType,
            sort: currentSort,
            tab: activeTab,
            tid: selectedTid,
            did: selectedDid,
            bid: selectedBid,
            gid: selectedGunbId,
            listingId: selectedListingId,
            developerInvestmentId: urlDeveloperInvestmentId(),
            otoczenieId: selectedOtoczenieId,
            noise: selectedNoiseContext,
            browse: getBrowseStateLatlng(),
            signal: getHistorySignalSignature(),
            search: selectedSearchItem,
            nearbyId: activeNearbyId,
            parcelMeasurements: parcelMeasurementManager.getUrlState(),
            filters: filterState,
            layers: {
                transakcje: transakcjeDesired,
                ortho: orthoDesired,
                mpzp: mpzpDesired,
                mpzpRu: mpzpRuDesired,
                pog: pogDesired,
                studium: studiumDesired,
                powodz: powodzDesired,
                gesut: gesutDesired,
                portPolska: portPolskaDesired,
                sidusis: sidusisDesired,
                dzialki: dzialkiDesired,
                budynki: budynkiDesired,
                gunb: gunbDesired,
                sygnaly: sygnalyDesired,
                ogloszenia: ogloszeniaDesired,
                ofertyDeweloperow: ofertyDeweloperowDesired,
                otoczenie: otoczenieDesired,
                ownership: ownershipLayerRuntime.getDesired(),
                landUse: landUseLayerRuntime.getDesired()
            }
        });
    }

    function syncUrl(centerOverride, zoomOverride, options) {
        options = options || {};
        var historySignature = getHistorySignature();
        var historyMode = 'replace';

        if (historyBootstrapComplete && historyStateReady && historySignature !== lastHistorySignature) {
            historyMode = 'push';
            mapHistoryCheckpointSignature = null;
        } else if (historyBootstrapComplete && historyStateReady && options.mapNavigation && mapHistoryCheckpointSignature !== historySignature) {
            historyMode = 'push';
            mapHistoryCheckpointSignature = historySignature;
        }

        syncUrlState({
            map: map,
            mapZoom: mapZoom,
            centerOverride: centerOverride,
            zoomOverride: zoomOverride,
            currentAssetType: currentAssetType,
            currentSort: currentSort,
            activeTab: activeTab,
            selectedTid: selectedTid,
            selectedDid: selectedDid,
            selectedBid: selectedBid,
            selectedGunbId: selectedGunbId,
            selectedListingId: selectedListingId,
            selectedDeveloperInvestmentId: urlDeveloperInvestmentId(),
            selectedOtoczenieId: selectedOtoczenieId,
            selectedNoiseContext: selectedNoiseContext,
            browseLatlng: getBrowseStateLatlng(),
            selectedSignalContext: selectedSignalContext,
            selectedSearchItem: selectedSearchItem,
            activeNearbyId: activeNearbyId,
            nearbyLoaded: nearbyLoaded,
            pendingNearbyRestore: pendingNearbyRestore,
            selectedLatLng: selectedLatLng,
            parcelMeasurementsState: parcelMeasurementManager.getUrlState(),
            filterState: filterState,
            historyMode: historyMode,
            desiredLayers: {
                transakcjeDesired: transakcjeDesired,
                orthoDesired: orthoDesired,
                mpzpDesired: mpzpDesired,
                mpzpRuDesired: mpzpRuDesired,
                pogDesired: pogDesired,
                studiumDesired: studiumDesired,
                powodzDesired: powodzDesired,
                gesutDesired: gesutDesired,
                portPolskaDesired: portPolskaDesired,
                sidusisDesired: sidusisDesired,
                dzialkiDesired: dzialkiDesired,
                budynkiDesired: budynkiDesired,
                gunbDesired: gunbDesired,
                sygnalyDesired: sygnalyDesired,
                ogloszeniaDesired: ogloszeniaDesired,
                ofertyDeweloperowDesired: ofertyDeweloperowDesired,
                otoczenieDesired: otoczenieDesired
            }
        });

        historyStateReady = true;
        lastHistorySignature = historySignature;
    }

    function clearSelection(options) {
        meshDetailSelection = null;
        nearbyPointReference = null;
        if (signalSubmitController && signalSubmitController.isOpen()) {
            signalSubmitController.close({ restore: false });
        }
        selectedNoiseContext = null;
        selectedEducationId = null;
        selectedDeveloperInvestmentId = null;
        pendingDeveloperInvestmentRestore = false;
        selectionManager.clearSelection(options);
    }

    function clearNearbyVisuals() {
        nearbyManager.clearVisuals();
    }

    function clearNearbyState() {
        if (personaModule) {
            personaModule.reset({ renderNearby: false });
        }
        nearbyManager.clearState();
    }

    function renderDetailsPlaceholder() {
        detailRenderers.renderDetailsPlaceholder();
    }

    function renderDetailsLoading(label) {
        detailRenderers.renderDetailsLoading(label);
    }

    function renderDetailsError(message) {
        detailRenderers.renderDetailsError(message);
    }

    function renderKowrDetails(data) {
        detailRenderers.renderKowrDetails(data);
    }

    function selectKowrFeature(data, latlng) {
        clearSelection({ keepDetails: true, sync: false });
        selectedLatLng = latlng;

        // A KOWR object is useful on its own, even when there is no imported
        // eRolnik listing. Mark the clicked place immediately and, when the
        // parcel exists in the local EGiB data, reuse the standard parcel
        // selection/highlight path without replacing the KOWR detail panel.
        if (interactiveHitDispatcher && typeof interactiveHitDispatcher.showClickMarker === 'function') {
            interactiveHitDispatcher.showClickMarker(latlng);
        }
        var identifier = data && data.parcel ? data.parcel.identifier : null;
        if (identifier && data.local_parcel) {
            selectedDid = String(identifier);
            ensureSelectedFeatureData('parcel', selectedDid, {
                renderLayer: true,
                renderDetails: false,
            });
        }

        renderKowrDetails(data);
        updateSelectionControl();
        setTab('details', { snap: 'half', sync: false });
        easeMapToKeepPointVisible(selectedLatLng);
        syncUrl();
    }

    function buildSignalsContext(entityType, entityId, data) {
        if (!entityType || entityId == null || entityId === '') {
            return null;
        }

        var resolvedData = data || {};
        var context = {
            entityType: String(entityType),
            entityId: String(entityId),
            targetIdentifier: resolvedData.targetIdentifier != null ? String(resolvedData.targetIdentifier) : null,
            targetLabel: resolvedData.targetLabel || null,
            targetSubtitle: resolvedData.targetSubtitle || null,
            selectedSignalId: resolvedData.selectedSignalId != null ? String(resolvedData.selectedSignalId) : null,
            signalFirst: resolvedData.signalFirst === true,
        };

        if (
            selectedSignalContext
            && selectedSignalContext.entityType === context.entityType
            && String(selectedSignalContext.entityId) === context.entityId
        ) {
            if (!context.targetIdentifier && selectedSignalContext.targetIdentifier) {
                context.targetIdentifier = selectedSignalContext.targetIdentifier;
            }
            if (!context.targetLabel && selectedSignalContext.targetLabel) {
                context.targetLabel = selectedSignalContext.targetLabel;
            }
            if (!context.targetSubtitle && selectedSignalContext.targetSubtitle) {
                context.targetSubtitle = selectedSignalContext.targetSubtitle;
            }
            if (!context.selectedSignalId && selectedSignalContext.selectedSignalId) {
                context.selectedSignalId = selectedSignalContext.selectedSignalId;
            }
            if (!context.signalFirst && selectedSignalContext.signalFirst) {
                context.signalFirst = true;
            }
        }

        return context;
    }

    function getParcelSignalsContext(props, preferredContext) {
        var fallbackLabel = props && (props.numer || props.id_dzialki)
            ? 'Działka ' + String(props.numer || props.id_dzialki)
            : 'Działka';
        var fallbackSubtitle = [props && props.obreb, props && props.gmina].filter(Boolean).join(', ') || (props && props.teryt) || null;

        return buildSignalsContext(
            'dzialka',
            preferredContext && preferredContext.entityId != null ? preferredContext.entityId : (props && props.id != null ? props.id : null),
            {
                targetIdentifier: preferredContext && preferredContext.targetIdentifier != null ? preferredContext.targetIdentifier : (props ? props.id_dzialki : null),
                targetLabel: preferredContext && preferredContext.targetLabel ? preferredContext.targetLabel : fallbackLabel,
                targetSubtitle: preferredContext && preferredContext.targetSubtitle ? preferredContext.targetSubtitle : fallbackSubtitle,
                selectedSignalId: preferredContext && preferredContext.selectedSignalId != null ? preferredContext.selectedSignalId : null,
                signalFirst: preferredContext ? preferredContext.signalFirst === true : false,
            }
        );
    }

    function getBuildingSignalsContext(props, preferredContext) {
        return buildSignalsContext(
            'budynek',
            preferredContext && preferredContext.entityId != null ? preferredContext.entityId : (props && props.id != null ? props.id : null),
            {
                targetIdentifier: preferredContext && preferredContext.targetIdentifier != null ? preferredContext.targetIdentifier : (props ? props.id_budynku : null),
                targetLabel: preferredContext && preferredContext.targetLabel
                    ? preferredContext.targetLabel
                    : ('Budynek ' + String((props && props.id_budynku) || '')),
                targetSubtitle: preferredContext && preferredContext.targetSubtitle
                    ? preferredContext.targetSubtitle
                    : ((props && props.rodzaj_label) || (props && props.teryt) || null),
                selectedSignalId: preferredContext && preferredContext.selectedSignalId != null ? preferredContext.selectedSignalId : null,
                signalFirst: preferredContext ? preferredContext.signalFirst === true : false,
            }
        );
    }

    function loadSignalsForContext(signalsContext) {
        if (!signalsPanel) {
            return;
        }

        if (!signalsContext) {
            signalsPanel.clearFocus();
            return;
        }

        signalsPanel.fetchEntitySignals(signalsContext);
    }

    function handleSignalFocus(signal) {
        if (selectedSignalContext) {
            selectedSignalContext = Object.assign({}, selectedSignalContext, {
                selectedSignalId: signal && signal.id != null ? String(signal.id) : null,
            });
        }

        // Kategoria sygnału jest znana dopiero po odpowiedzi API, więc nagłówek
        // panelu dostaje ją tutaj — setDetailsMeta z dom/elements, bo wrapper
        // z detail-renderers czyściłby link do symulacji nasłonecznienia.
        if (selectedSignalContext && selectedSignalContext.signalFirst && signal) {
            var categoryName = signal.category && signal.category.name ? signal.category.name : null;
            var targetLabel = signal.target_label || selectedSignalContext.targetLabel || '';
            if (categoryName) {
                setDetailsMeta(targetLabel ? categoryName + ' · ' + targetLabel : categoryName);
            }
            setDetailsKicker('Wybrany sygnał społeczności');
            setDetailsDepartment('signals');
        }

        if (signalsController && typeof signalsController.showSignalHighlight === 'function') {
            signalsController.showSignalHighlight(signal || null);
        }

        bringDataLayersToFront();
    }

    function clearSignalFocus() {
        handleSignalFocus(null);
    }

    function prependSignalTargetType(targetTypes, type) {
        if (targetTypes.indexOf(type) === -1) {
            targetTypes.unshift(type);
        }
    }

    function getCurrentMapCenterLatLng() {
        if (map) {
            var center = map.getCenter();
            return {
                lat: center.lat,
                lng: center.lng,
            };
        }

        return {
            lat: DEFAULT_LAT,
            lng: DEFAULT_LNG,
        };
    }

    function createSignalSubmitOpenContext(requestedContext) {
        var activeContext = null;

        if (requestedContext && requestedContext.entityType && requestedContext.entityId != null && requestedContext.entityId !== '') {
            activeContext = buildSignalsContext(
                String(requestedContext.entityType),
                requestedContext.entityId,
                requestedContext
            );
        }

        if (!activeContext && selectedSignalContext) {
            activeContext = Object.assign({}, selectedSignalContext);
        }

        var pointLatLng = selectedLatLng || getCurrentMapCenterLatLng();
        var openContext = {
            availableTargetTypes: ['punkt', 'miejscowosc'],
            preferredTargetType: 'punkt',
            targets: {
                punkt: {
                    lat: pointLatLng.lat,
                    lng: pointLatLng.lng,
                    label: activeContext && activeContext.entityType === 'punkt' && activeContext.targetLabel
                        ? activeContext.targetLabel
                        : 'Punkt na mapie',
                    subtitle: activeContext && activeContext.entityType === 'punkt' && activeContext.targetSubtitle
                        ? activeContext.targetSubtitle
                        : (selectedLatLng
                            ? 'Aktualnie wybrane miejsce na mapie.'
                            : 'Środek aktualnego widoku mapy.'),
                },
                miejscowosc: null,
            },
        };

        if (!activeContext) {
            return openContext;
        }

        if (activeContext.entityType === 'dzialka' && activeContext.entityId) {
            prependSignalTargetType(openContext.availableTargetTypes, 'dzialka');
            openContext.preferredTargetType = 'dzialka';
            openContext.targets.dzialka = {
                id: String(activeContext.entityId),
                identifier: activeContext.targetIdentifier ? String(activeContext.targetIdentifier) : null,
                label: activeContext.targetLabel || 'Wybrana działka',
                subtitle: activeContext.targetSubtitle || null,
            };
        }

        if (activeContext.entityType === 'budynek' && activeContext.entityId) {
            prependSignalTargetType(openContext.availableTargetTypes, 'budynek');
            openContext.preferredTargetType = 'budynek';
            openContext.targets.budynek = {
                id: String(activeContext.entityId),
                identifier: activeContext.targetIdentifier ? String(activeContext.targetIdentifier) : null,
                label: activeContext.targetLabel || 'Wybrany budynek',
                subtitle: activeContext.targetSubtitle || null,
            };
        }

        if (activeContext.entityType === 'miejscowosc' && activeContext.entityId) {
            openContext.preferredTargetType = 'miejscowosc';
            openContext.targets.miejscowosc = {
                id: String(activeContext.entityId),
                label: activeContext.targetLabel || 'Miejscowość',
                subtitle: activeContext.targetSubtitle || null,
            };
        }

        if (activeContext.entityType === 'punkt') {
            openContext.preferredTargetType = 'punkt';
            openContext.targets.punkt = {
                lat: pointLatLng.lat,
                lng: pointLatLng.lng,
                label: activeContext.targetLabel || 'Punkt na mapie',
                subtitle: activeContext.targetSubtitle || 'Wskaż dokładne miejsce na mapie.',
            };
        }

        return openContext;
    }

    function restoreCurrentDetailsAfterSignalSubmit() {
        if (pendingTapBrowseRestore) {
            setTab('list', { sync: false, snap: 'half' });
            return;
        } else if (selectedTid) {
            renderDetailsLoading('Transakcja ' + selectedTid.substring(0, 8));
            fetchTransactionDetail(selectedTid);
            return;
        }

        if (selectedGunbId) {
            renderDetailsLoading('Pozwolenie na budowę');
            fetchGunbDetail(selectedGunbId);
            return;
        }

        if (selectedListingId) {
            fetchListingDetail(selectedListingId);
            return;
        }

        if (selectedDid) {
            renderDetailsLoading('Działka ' + selectedDid);
            ensureSelectedFeatureData('parcel', selectedDid, {
                renderLayer: false,
                renderDetails: true,
            });
            return;
        }

        if (selectedBid) {
            renderDetailsLoading('Budynek ' + selectedBid);
            ensureSelectedFeatureData('building', selectedBid, {
                renderLayer: false,
                renderDetails: true,
            });
            return;
        }

        if (selectedOtoczenieFeature) {
            renderOtoczenieDetails(selectedOtoczenieFeature);
            return;
        }


        if (selectedSignalContext) {
            renderSignalTargetDetails({
                target_identifier: selectedSignalContext.targetIdentifier || null,
                target_label: selectedSignalContext.targetLabel || null,
                target_subtitle: selectedSignalContext.targetSubtitle || null,
            }, selectedSignalContext);
            return;
        }

        renderDetailsPlaceholder();
    }

    function openSignalSubmitForm(requestedContext) {
        if (!signalSubmitController) {
            return;
        }

        if (!window.RCN_USER && typeof window.openAuthModal === 'function') {
            var capturedContext = requestedContext || {};
            window.openAuthModal('login', {
                pendingAction: function() {
                    openSignalSubmitForm(capturedContext);
                }
            });
            return;
        }

        signalSubmitController.open(requestedContext || {});
        setTab('details', { snap: 'half', sync: false });
    }

    function renderParcelDetails(props, options) {
        var signalsContext = getParcelSignalsContext(props, options && options.signalsContext ? options.signalsContext : null);
        selectedSignalContext = signalsContext;
        detailRenderers.renderParcelDetails(props, { signalsContext: signalsContext });
        loadSignalsForContext(signalsContext);
    }

    function renderBuildingDetails(props, options) {
        var signalsContext = getBuildingSignalsContext(props, options && options.signalsContext ? options.signalsContext : null);
        selectedSignalContext = signalsContext;
        detailRenderers.renderBuildingDetails(props, { signalsContext: signalsContext });
        loadSignalsForContext(signalsContext);
    }

    function renderSignalTargetDetails(props, signalsContext) {
        selectedSignalContext = signalsContext;
        detailRenderers.renderSignalTargetDetails(props, signalsContext);
        loadSignalsForContext(signalsContext);
    }

    function fetchPointUrbanPlanningForSignal(props, latlng) {
        if (!props || !latlng || props.target_type === 'dzialka' || props.target_type === 'budynek') {
            return;
        }

        var context = selectedSignalContext;
        if (!context || !context.entityType || context.entityId == null) {
            return;
        }

        var cacheKey = Number(latlng.lat).toFixed(6) + ',' + Number(latlng.lng).toFixed(6);
        if (pointUrbanPlanningCache[cacheKey]) {
            renderSignalTargetDetails(Object.assign({}, props, {
                urbanPlanning: pointUrbanPlanningCache[cacheKey]
            }), context);
            return;
        }

        fetch(BASE_URL + 'api/urban-planning-point?lat=' + encodeURIComponent(latlng.lat) + '&lng=' + encodeURIComponent(latlng.lng), { cache: 'no-store' })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (!data || !data.urbanPlanning) {
                    return;
                }
                if (!selectedSignalContext
                    || selectedSignalContext.entityType !== context.entityType
                    || String(selectedSignalContext.entityId) !== String(context.entityId)) {
                    return;
                }
                pointUrbanPlanningCache[cacheKey] = data.urbanPlanning;
                renderSignalTargetDetails(Object.assign({}, props, {
                    urbanPlanning: data.urbanPlanning
                }), context);
            })
            .catch(function() {});
    }

    function selectSignalHit(props, latlng, signalId) {
        selectionManager.selectSignalHit(props, latlng, signalId);
        fetchPointUrbanPlanningForSignal(props, latlng);
    }

    function renderOtoczenieDetails(feature) {
        detailRenderers.renderOtoczenieDetails(feature);
    }

    function getOtoczenieFeatureId(feature) {
        var props = feature && feature.properties ? feature.properties : {};
        return props.id || props.bdot10k_id || props.id_bdot10k || null;
    }

    function fetchOtoczenieUrbanPlanning(feature) {
        var id = getOtoczenieFeatureId(feature);
        if (id == null || id === '') {
            return;
        }

        var cacheKey = String(id);
        if (otoczenieUrbanPlanningCache[cacheKey]) {
            if (selectedOtoczenieFeature && String(getOtoczenieFeatureId(selectedOtoczenieFeature)) === cacheKey) {
                selectedOtoczenieFeature.properties = Object.assign(
                    {},
                    selectedOtoczenieFeature.properties || {},
                    { urbanPlanning: otoczenieUrbanPlanningCache[cacheKey] }
                );
                renderOtoczenieDetails(selectedOtoczenieFeature);
            }
            return;
        }

        fetch(BASE_URL + 'api/bdot10k-szczegoly-map/' + encodeURIComponent(cacheKey), { cache: 'no-store' })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (!data || !data.urbanPlanning) {
                    return;
                }
                otoczenieUrbanPlanningCache[cacheKey] = data.urbanPlanning;
                if (!selectedOtoczenieFeature || String(getOtoczenieFeatureId(selectedOtoczenieFeature)) !== cacheKey) {
                    return;
                }
                selectedOtoczenieFeature.properties = Object.assign(
                    {},
                    selectedOtoczenieFeature.properties || {},
                    { urbanPlanning: data.urbanPlanning }
                );
                renderOtoczenieDetails(selectedOtoczenieFeature);
            })
            .catch(function() {});
    }


    function hasParcelDetails(props) {
        return detailRenderers.hasParcelDetails(props);
    }

    function hasBuildingDetails(props) {
        return detailRenderers.hasBuildingDetails(props);
    }

    function findGunbFeatureById(gunbId) {
        return gunbManager.findGunbFeatureById(gunbId);
    }

    function clearSelectedGunbVisual() {
        gunbManager.clearSelectedGunbVisual();
    }

    function renderSelectedGunbVisual(feature) {
        return gunbManager.renderSelectedGunbVisual(feature);
    }

    function syncSelectedGunbVisual() {
        return gunbManager.syncSelectedGunbVisual();
    }

    function getSelectedFeatureIdByType(layerType) {
        if (layerType === 'parcel') return selectedDid;
        if (layerType === 'building') return selectedBid;
        return null;
    }

    function getSelectedFeatureKey(layerType, featureId) {
        if (!layerType || !featureId) return null;
        return layerType + ':' + String(featureId);
    }

    function getSelectedFeatureRequestUrl(layerType, featureId) {
        if (layerType === 'parcel') {
            return BASE_URL + 'api/dzialki?pin_only=1&id_dzialki=' + encodeURIComponent(featureId);
        }

        return BASE_URL + 'api/budynki?pin_only=1&id_budynku=' + encodeURIComponent(featureId);
    }

    function clearSelectedFeatureLayersOnly() {
        if (dzialkiController && typeof dzialkiController.clearSelectedFeature === 'function') {
            dzialkiController.clearSelectedFeature();
        } else if (map) {
            removeSourceAndLayers(map, DzialkiLayer.SELECTED_SOURCE_ID, DzialkiLayer.SELECTED_LAYER_IDS);
        }

        if (budynkiController && typeof budynkiController.clearSelectedFeature === 'function') {
            budynkiController.clearSelectedFeature();
        } else if (map) {
            removeSourceAndLayers(map, BudynkiLayer.SELECTED_SOURCE_ID, BudynkiLayer.SELECTED_LAYER_IDS);
        }
    }

    function clearSelectedFeatureVisual() {
        selectedFeatureManager.abortCurrentRequest();
        parcelMeasurementManager.clear();
        clearSelectedFeatureLayersOnly();
        selectedFeatureLayer = null;
        selectedFeatureLayerKey = null;
    }

    function renderSelectedFeatureDetailsFromData(layerType, data) {
        var feature = data && data.features && data.features.length ? data.features[0] : null;
        var props = feature && feature.properties ? feature.properties : null;
        if (!props) {
            renderDetailsError('Nie znaleziono obiektu');
            return;
        }

        if (layerType === 'parcel') {
            renderParcelDetails(props);
            return;
        }

        renderBuildingDetails(props);
    }

    function renderSelectedFeatureLayerData(data, layerType, featureKey) {
        if (!data || !data.features || !data.features.length) {
            clearSelectedFeatureVisual();
            return null;
        }

        clearSelectedFeatureLayersOnly();
        selectedFeatureLayerKey = featureKey;

        var controller = layerType === 'parcel' ? dzialkiController : budynkiController;
        var result = controller && typeof controller.renderSelectedFeature === 'function'
            ? controller.renderSelectedFeature(data)
            : null;

        selectedFeatureLayer = result ? result.layer : null;
        if (layerType === 'parcel') {
            parcelMeasurementManager.setFeature(data.features[0]);
        } else {
            parcelMeasurementManager.clear();
        }

        if (result && result.center) {
            selectedLatLng = result.center;
            if ((pendingNearbyRestore || nearbyLoaded)
                && nearbyManager
                && !nearbyManager.isLoadedForSelection(selectedLatLng)) {
                loadNearbyForSelection(false);
            }
        }

        bringDataLayersToFront();
        return selectedFeatureLayer;
    }

    function ensureSelectedFeatureData(layerType, featureId, options) {
        selectedFeatureManager.ensureData(layerType, featureId, options);
    }

    function renderTransactionDetails(data) {
        detailRenderers.renderTransactionDetails(data);
    }

    function applySelectedStylesInList() {
        listPanelRenderers.applySelectedStylesInList();
    }


    function selectionActive() {
        return selectionManager.selectionActive();
    }

    function updateSelectionControl() {
        selectionManager.updateSelectionControl();
    }

    function runClearSelectionFromBanner() {
        if (interactiveHitDispatcher && typeof interactiveHitDispatcher.clearClickMarker === 'function') {
            interactiveHitDispatcher.clearClickMarker();
        }
        selectionManager.runClearSelectionFromBanner();
    }

    // Parcel labels are handled as a MapLibre symbol layer (lyr-dzialki-label)
    // added during renderDzialkiData. Visibility is zoom-driven.
    function updateParcelLabels() {
        // Labels are managed by MapLibre's zoom-based visibility — no per-feature iteration needed
    }


    function resetHighlight() {
        selectionManager.resetHighlight();
    }

    function applySelectionFocusState() {
        return selectionManager.applySelectionFocusState();
    }

    function clearTransactionHighlight() {
        selectionManager.clearTransactionHighlight();
    }

    function highlightTransactionById(transactionId) {
        return selectionManager.highlightTransactionById(transactionId);
    }

    // Rebuild nearby distance visuals with current selectedLatLng (visual only, no map movement).
    function rebuildNearbyLinkIfNeeded() {
        if (nearbyManager
            && nearbyLoaded
            && selectedLatLng
            && !nearbyManager.isLoadedForSelection(selectedLatLng)) {
            loadNearbyForSelection(false);
            return;
        }
        if (nearbyManager && nearbyLoaded) {
            nearbyManager.refreshFocusLink();
        }
    }

    function getRowLatLng(row) {
        return selectionManager.getRowLatLng(row);
    }

    function selectTransactionByRow(row, shouldFly) {
        selectionManager.selectTransactionByRow(row, shouldFly);
    }

    function selectTransactionByFeature(props, latlng) {
        selectionManager.selectTransactionByFeature(props, latlng);
    }

    function handleTransactionFeatureTap(props, latlng, feature, _layer, point) {
        if (!props || !props.tran_lokalny_id_iip) {
            return;
        }

        if (!feature) {
            selectTransactionByFeature(props, latlng);
            return;
        }

        tapResolutionManager.requestTransactionTapResolution(feature, latlng, point);
    }

    function selectParcel(props, latlng) {
        selectionManager.selectParcel(props, latlng);
    }

    function selectBuilding(props, latlng) {
        selectionManager.selectBuilding(props, latlng);
    }

    function selectNoiseHit(hit, latlng, options) {
        if (!hit || !hit.layerKey) return;
        options = options || {};

        clearSelection({ keepDetails: true, sync: false });
        selectedLatLng = latlng || selectedLatLng;
        selectedNoiseContext = {
            id: String(hit.id || (hit.layerKey + ':noise')),
            layerKey: hit.layerKey,
            level: isFinite(Number(hit.properties && hit.properties.dbMin))
                ? Number(hit.properties.dbMin)
                : null,
        };
        if (interactiveHitDispatcher && selectedLatLng) {
            interactiveHitDispatcher.showClickMarker(selectedLatLng);
        }

        var isMonitoring = hit.layerKey === 'noiseMonitoring';
        var properties = hit.properties || {};
        // The time of day is the „Pora” row of the card (contourHtml).
        var title = isMonitoring
            ? (properties.aggregate ? 'Pomiary hałasu w tym obszarze' : 'Punkt monitoringu hałasu')
            : 'Strategiczna mapa hałasu';
        var content = isMonitoring
            ? measurementHtml(properties, noiseLayerRuntime.getMetadata(hit.layerKey))
            : contourHtml(properties, noiseLayerRuntime.getMetadata(hit.layerKey));

        setDetailsKicker('Wybrana warstwa mapy');
        setDetailsDepartment(null);
        setDetailsMeta(title);
        detailsContentEl.innerHTML = '<div class="nm-detail-stack"><section class="ms-card ms-card--grid nm-detail-block">'
            + content + '</section></div>';
        openNearbyBtn.disabled = !selectedLatLng;
        if (detailCtaEl) {
            detailCtaEl.removeAttribute('href');
            detailCtaEl.hidden = true;
        }
        setTab('details', { snap: 'half', sync: false });
        if (!options.skipEase) easeMapToKeepPointVisible(selectedLatLng);
        if (!options.skipSync) syncUrl();
    }

    function selectEducationHit(hit, latlng) {
        if (!hit || !hit.properties) return;

        clearSelection({ keepDetails: true, sync: false });
        selectedEducationId = String(hit.id);
        selectedLatLng = latlng || selectedLatLng;
        if (interactiveHitDispatcher && selectedLatLng) {
            interactiveHitDispatcher.showClickMarker(selectedLatLng);
        }

        setDetailsKicker('Wybrana warstwa mapy');
        setDetailsDepartment(null);
        setDetailsMeta(EducationFacilitiesLayer.DESCRIPTION);
        detailsContentEl.innerHTML = '<div class="nm-detail-stack"><section class="ms-card ms-card--grid nm-detail-block">'
            + educationFacilityHtml(hit.properties, educationLayerRuntime.getMetadata()) + '</section></div>';
        openNearbyBtn.disabled = !selectedLatLng;
        if (detailCtaEl) {
            detailCtaEl.removeAttribute('href');
            detailCtaEl.hidden = true;
        }
        setTab('details', { snap: 'half', sync: false });
        easeMapToKeepPointVisible(selectedLatLng);
        syncUrl();
    }

    function restoredNoiseHit() {
        if (!selectedNoiseContext || !selectedNoiseContext.layerKey || !selectedLatLng) return null;

        var context = selectedNoiseContext;
        var hits = context.layerKey === 'noiseMonitoring'
            ? noiseLayerRuntime.getRenderedFeatures(context.layerKey).map(function(feature) {
                return normalizeNoiseHit(Object.assign({}, feature, {
                    layer: { id: 'lyr-noiseMonitoring-points' }
                }));
            }).filter(Boolean)
            : noiseGeometryHitsAtLngLat(function(layerKey) {
                return layerKey === context.layerKey
                    ? noiseLayerRuntime.getRenderedFeatures(layerKey)
                    : [];
            }, selectedLatLng);

        var exact = hits.filter(function(hit) {
            if (hit.layerKey !== context.layerKey || hit.id !== context.id) return false;
            return context.level == null
                || Number(hit.properties && hit.properties.dbMin) === Number(context.level);
        })[0];
        if (exact) return exact;

        return hits.filter(function(hit) {
            if (hit.layerKey !== context.layerKey) return false;
            return context.level == null
                || Number(hit.properties && hit.properties.dbMin) === Number(context.level);
        })[0] || null;
    }

    function tryRestoreNoiseSelection(layerKey) {
        if (!selectedNoiseContext || selectedNoiseContext.layerKey !== layerKey) return false;
        var hit = restoredNoiseHit();
        if (!hit) return false;
        selectNoiseHit(hit, selectedLatLng, { skipEase: true, skipSync: true });
        return true;
    }


    function selectOtoczenieFeature(feature, latlng) {
        selectionManager.selectOtoczenieFeature(feature, latlng);
        fetchOtoczenieUrbanPlanning(feature);
    }

    function fetchTransactionDetail(transactionId) {
        transactionDetailManager.fetchTransactionDetail(transactionId);
    }

    function tryHighlightTransactionParcel(transactionId) {
        transactionDetailManager.tryHighlightTransactionParcel(transactionId);
    }

    function getListSummaryMessage() {
        return listPanelRenderers.getListSummaryMessage();
    }

    function renderListCardHtml(row) {
        return listPanelRenderers.renderListCardHtml(row);
    }

    function renderOverlapBrowsePanel() {
        overlapManager.renderOverlapBrowsePanel();
    }

    var LIST_SUBTAB_DEFS = [
        { key: 'ogloszenia', label: 'Ogłoszenia' },
        { key: 'ofertyDeweloperow', label: 'Oferty deweloperów' },
        { key: 'transakcje', label: 'Transakcje' },
        { key: 'sygnaly', label: 'Sygnały' },
        { key: 'gunb', label: 'Pozwolenia' }
    ];

    var LIST_SUBTAB_DEPARTMENTS = {
        ogloszenia: 'offers',
        ofertyDeweloperow: 'offers',
        transakcje: 'transactions',
        sygnaly: 'signals',
        gunb: 'permits'
    };
    var listPanelEl = document.getElementById('nm-panel-list');

    function getListSubTabs() {
        return LIST_SUBTAB_DEFS.filter(function(def) {
            if (def.key === 'ogloszenia') return ogloszeniaActive;
            if (def.key === 'ofertyDeweloperow') return ofertyDeweloperowActive;
            if (def.key === 'transakcje') return transakcjeActive;
            if (def.key === 'sygnaly') return sygnalyActive;
            if (def.key === 'gunb') return gunbActive;
            return false;
        });
    }

    function renderListSubTabBar(tabs) {
        if (!listSubTabsEl) return;
        if (tabs.length < 2) {
            listSubTabsEl.style.display = 'none';
            listSubTabsEl.innerHTML = '';
            return;
        }
        listSubTabsEl.style.display = '';
        listSubTabsEl.innerHTML = tabs.map(function(def) {
            return '<button type="button" class="ms-segmented__option nm-list-subtab ms-dept--' + (LIST_SUBTAB_DEPARTMENTS[def.key] || 'portal')
                + (def.key === listSubTab ? ' is-active' : '')
                + '" data-list-subtab="' + def.key + '" aria-pressed="' + (def.key === listSubTab ? 'true' : 'false') + '">' + esc(def.label) + '</button>';
        }).join('');
    }

    function flattenGunbViewFeatures() {
        var out = [];
        var groups = gunbGroupsCache || {};
        Object.keys(groups).forEach(function(key) {
            if (Array.isArray(groups[key])) {
                groups[key].forEach(function(feature) { out.push(feature); });
            }
        });
        return out;
    }

    function renderListPanel(options) {
        if (!map) return;
        // Frozen while the pointer is on the list — keep the hovered card still.
        // The pending render is flushed when the pointer leaves the list.
        if (listHoverLock && !(options && options.immediate) && !(pointQuerySession && pointQuerySession.get())) {
            listRenderDeferredWhileLocked = true;
            return;
        }
        listRenderDeferredWhileLocked = false;
        renderListPanelBody();
        updateListTabCount();
        scheduleListLoadingHide();
    }

    function formatListTabCount(count) {
        count = Math.max(0, Number(count) || 0);
        if (count >= 1000) {
            return Math.floor(count / 1000) + 'k+';
        }
        return String(count);
    }

    function getListTabCount() {
        if (pointQuerySession && pointQuerySession.get()) return pointQueryObjectCount(pointQuerySession.get());
        if (combinedBrowseTransactions) return combinedBrowseTransactions.length;
        if (tapBrowseHits) return tapBrowseHits.length;
        if (overlapBrowseFeatures) return overlapBrowseFeatures.length;
        if (gunbBrowseFeatures) return gunbBrowseFeatures.length;
        if (listSubTab === 'ogloszenia') {
            return listingViewAggregated || mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD ? null : listingViewFeatures.length;
        }
        if (listSubTab === 'sygnaly') {
            if (signalsViewAggregated || mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) return null;
            var signalCount = 0;
            signalsViewFeatures.forEach(function(feature) {
                var props = (feature && feature.properties) || {};
                signalCount += Array.isArray(props.signals) ? props.signals.length : 0;
            });
            return signalCount;
        }
        if (listSubTab === 'gunb') {
            return mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD ? null : flattenGunbViewFeatures().length;
        }
        if (listSubTab === 'ofertyDeweloperow') {
            return developerOfferViewAggregated ? null : developerOfferViewFeatures.length;
        }
        return (mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) || !transakcjeActive ? null : listTotal;
    }

    function updateListTabCount() {
        if (!listTabCountEl) {
            return;
        }
        var count = getListTabCount();
        listTabCountEl.hidden = count === null || count === undefined;
        listTabCountEl.textContent = count === null || count === undefined ? '' : formatListTabCount(count);
    }

    function renderListPanelBody() {
        var pointSession = pointQuerySession && pointQuerySession.get();
        // Only the transaction list shows the footer button and its error.
        renderListMoreControls(listMoreBtn, listMoreErrorEl, { visible: false, failed: false, label: listMoreLabel });
        var resultsKicker = document.querySelector('[data-map-results-kicker]');
        if (resultsKicker) resultsKicker.textContent = pointSession ? 'Wybrane miejsce' : 'Widok mapy';
        // Mixed results (a picked point, a tap on overlapping objects) keep the
        // map's brand accent; a single result type takes its department colour.
        setDepartment(listPanelEl, null);
        if (pointSession) {
            if (listSubTabsEl) listSubTabsEl.style.display = 'none';
            if (listingSortRowEl) listingSortRowEl.style.display = 'none';
            sortRowEl.style.display = 'none';
            listMoreBtn.style.display = 'none';
            renderPointQueryPanel(pointSession, {
                title: listTitleEl, meta: listMetaEl, content: listContentEl,
                zoom: pointSession.zoom,
                zoomGates: getPointQueryZoomGates(pointSession.zoom),
                renderHit: function(hit) {
                    if (hit.type === 'meshCoverage') return renderMeshCoverageCard(hit.data);
                    if (LAYER_POINT_TYPES.indexOf(hit.type) !== -1) return renderLayerPointCard(hit.data);
                    if (hit.type === 'transaction') return renderListCardHtml(hit.properties);
                    if (hit.type === 'listing') return renderListingListCardHtml(hit.feature);
                    if (hit.type === 'kowr') return '<button class="ms-card ms-card--grid nm-list-card" type="button"><strong>Działka ' + esc(hit.id) + '</strong><p>Sprawdź informacje i dostępność działki</p></button>';
                    return tapBrowseManager.renderTapHitCardHtml(hit);
                },
            });
            return;
        }
        releasePointQueryPanel(listContentEl);

        if (mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) {
            overlapBrowseFeatures = null;
            gunbBrowseFeatures = null;
            combinedBrowseTransactions = null;
            combinedBrowseGunb = null;
            combinedBrowseOtherHits = null;
            clearTapBrowseState();
        }

        var tabs = getListSubTabs();
        var hasTab = tabs.some(function(def) { return def.key === listSubTab; });
        if (!hasTab) {
            listSubTab = tabs.length ? tabs[0].key : 'transakcje';
        }

        // Point-click browse modes (set by tapping overlapping map objects) take over.
        if (combinedBrowseTransactions || tapBrowseHits || overlapBrowseFeatures || gunbBrowseFeatures) {
            if (listSubTabsEl) listSubTabsEl.style.display = 'none';
            if (listingSortRowEl) listingSortRowEl.style.display = 'none';
            if (combinedBrowseTransactions) { renderCombinedBrowsePanel(); return; }
            if (tapBrowseHits) { renderTapHitBrowsePanel(); return; }
            if (overlapBrowseFeatures) { renderOverlapBrowsePanel(); return; }
            if (gunbBrowseFeatures) { renderGunbBrowsePanel(); return; }
        }

        renderListSubTabBar(tabs);
        setDepartment(listPanelEl, LIST_SUBTAB_DEPARTMENTS[listSubTab] || 'transactions');

        if (listSubTab === 'ogloszenia') {
            renderListingsListPanel();
            return;
        }
        if (listingSortRowEl) listingSortRowEl.style.display = 'none';
        if (listSubTab === 'ofertyDeweloperow') {
            renderDeveloperOffersListPanel();
            return;
        }
        if (listSubTab === 'sygnaly') {
            renderSignalsListPanel();
            return;
        }
        if (listSubTab === 'gunb') {
            renderGunbListPanel();
            return;
        }
        renderTransactionsListPanel();
    }

    // Polish plural form for the word "sygnał".
    function signalsCountWord(count) {
        var abs = Math.abs(Number(count) || 0);
        if (abs === 1) {
            return 'sygnał';
        }
        var lastTwo = abs % 100;
        var last = abs % 10;
        if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) {
            return 'sygnały';
        }
        return 'sygnałów';
    }

    function renderSignalsListPanel() {
        sortRowEl.style.display = 'none';
        listMoreBtn.style.display = 'none';
        listTitleEl.textContent = 'Sygnały w aktualnym widoku';

        if (signalsViewAggregated || mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) {
            listMetaEl.textContent = 'Przybliż mapę, aby wczytać listę';
            setListContent(listContentEl, renderZoomInState(
                'Przybliż mapę, aby zobaczyć pojedyncze sygnały',
                'Na tym poziomie sygnały społeczności są grupowane w skupiska. Lista pojawi się po przybliżeniu.'
            ));
            return;
        }
        if (!signalsViewFeatures.length) {
            listMetaEl.textContent = '0 sygnałów';
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Brak sygnałów w tym widoku</strong><span>W tym miejscu nikt nie dodał jeszcze uwagi. Możesz dodać ją przyciskiem „Dodaj”.</span></div>');
            return;
        }

        // One map point can carry several signals with mixed sentiment, so the
        // list flattens them into individual entries and groups by sentiment —
        // a positive signal must never hide behind a negative one.
        var entries = [];
        renderedSignalFeatures = signalsViewFeatures.slice();
        renderedSignalFeatures.forEach(function(feature, featureIndex) {
            var props = (feature && feature.properties) || {};
            var signals = Array.isArray(props.signals) ? props.signals : [];
            signals.forEach(function(signal) {
                entries.push({ featureIndex: featureIndex, props: props, signal: signal });
            });
        });

        if (!entries.length) {
            listMetaEl.textContent = '0 sygnałów';
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Brak sygnałów w tym widoku</strong><span>W tym miejscu nikt nie dodał jeszcze uwagi. Możesz dodać ją przyciskiem „Dodaj”.</span></div>');
            return;
        }

        listMetaEl.textContent = fmt(entries.length) + ' ' + signalsCountWord(entries.length);

        var sections = [
            { key: 'con', label: 'Uciążliwości', entries: [] },
            { key: 'pro', label: 'Udogodnienia', entries: [] },
            { key: 'general', label: 'Obserwacje', entries: [] },
        ];
        entries.forEach(function(entry) {
            var sentiment = entry.signal && entry.signal.category ? entry.signal.category.sentiment : null;
            var bucket = sentiment === 'pro' ? sections[1] : sentiment === 'con' ? sections[0] : sections[2];
            bucket.entries.push(entry);
        });

        var html = sections.filter(function(section) {
            return section.entries.length;
        }).map(function(section) {
            return '<div class="nm-signal-list-group nm-signal-list-group--' + section.key + '">'
                + '<div class="nm-signal-list-group__head">'
                    + '<span class="nm-signal-list-group__title">' + esc(section.label) + '</span>'
                    + '<span class="nm-signal-list-group__count">' + section.entries.length + '</span>'
                + '</div>'
                + section.entries.map(renderSignalListCardHtml).join('')
            + '</div>';
        }).join('');

        setListContent(listContentEl, '<div class="nm-list-stack">' + html + '</div>');
    }

    function renderSignalListCardHtml(entry) {
        var props = entry.props || {};
        var signal = entry.signal || {};
        var category = signal.category || {};
        var sentiment = category.sentiment;
        var sentimentMeta = sentiment === 'pro'
            ? { label: 'Udogodnienie', cls: 'ms-badge--success', card: 'pro' }
            : sentiment === 'con'
                ? { label: 'Uciążliwość', cls: 'ms-badge--danger', card: 'con' }
                : { label: 'Obserwacja', cls: 'ms-badge--neutral', card: 'general' };
        var body = String(signal.body || '').replace(/\s+/g, ' ').trim();
        if (body.length > 140) {
            body = body.slice(0, 137) + '…';
        }
        var targetLabel = signal.target_label || signal.coverage_label || props.target_label || '';
        return '<button class="ms-card ms-card--grid nm-list-card nm-signal-card nm-signal-card--' + sentimentMeta.card + '" type="button"'
            + ' data-signal-feature-index="' + entry.featureIndex + '"'
            + (signal.id != null ? ' data-signal-id="' + esc(String(signal.id)) + '"' : '')
            + '>'
            + '<span class="nm-transaction-card__top">'
                + '<span class="ms-badge ' + sentimentMeta.cls + '">' + esc(sentimentMeta.label) + '</span>'
                + '<span class="nm-transaction-card__date">' + esc(category.name || 'Sygnał społeczności') + '</span>'
            + '</span>'
            + (body ? '<span class="nm-list-address">' + esc(body) + '</span>' : '')
            + (targetLabel ? '<span class="nm-transaction-card__source">' + esc(targetLabel) + '</span>' : '')
        + '</button>';
    }

    function renderGunbListPanel() {
        sortRowEl.style.display = 'none';
        listMoreBtn.style.display = 'none';
        listTitleEl.textContent = 'Pozwolenia w aktualnym widoku';

        if (mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) {
            listMetaEl.textContent = 'Przybliż mapę, aby wczytać listę';
            setListContent(listContentEl, renderZoomInState(
                'Przybliż mapę, aby zobaczyć pojedyncze pozwolenia',
                'Na tym poziomie pozwolenia na budowę są grupowane w skupiska. Lista pojawi się po przybliżeniu.'
            ));
            return;
        }
        var features = flattenGunbViewFeatures();
        if (!features.length) {
            listMetaEl.textContent = '0 pozwoleń';
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Brak pozwoleń na budowę w tym widoku</strong><span>Zmień rok wpływu wniosku w filtrach albo oddal mapę.</span></div>');
            return;
        }
        listMetaEl.textContent = countLabel(features.length, 'pozwolenie', 'pozwolenia', 'pozwoleń');
        renderedGunbFeatures = features.slice();
        renderKeyedStack(listContentEl, features.map(function(feature) {
            var props = (feature && feature.properties) || {};
            return { key: 'g:' + (props.id != null ? props.id : ''), html: renderGunbListCardHtml(props) };
        }));
        applySelectedStylesInGunbList();
    }

    function renderTransactionsListPanel() {
        if (mapZoom() < INDIVIDUAL_ZOOM_THRESHOLD) {
            var summary = getListSummaryMessage();
            listTitleEl.textContent = summary.title;
            listMetaEl.textContent = summary.meta;
            sortRowEl.style.display = 'none';
            listMoreBtn.style.display = 'none';
            setListContent(listContentEl, summary.html);
            return;
        }

        if (!transakcjeActive) {
            listTitleEl.textContent = 'Transakcje w aktualnym widoku';
            listMetaEl.textContent = 'Warstwa transakcji jest wyłączona';
            sortRowEl.style.display = 'none';
            listMoreBtn.style.display = 'none';
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Warstwa transakcji jest wyłączona</strong><span>Włącz warstwę „Transakcje” w panelu warstw mapy, aby zobaczyć listę.</span></div>');
            return;
        }

        listTitleEl.textContent = 'Transakcje w aktualnym widoku';
        listMetaEl.textContent = listLoading
            ? 'Ładowanie listy…'
            : ((listTotalEstimated ? 'około ' : '') + countLabel(listTotal, 'transakcja', 'transakcje', 'transakcji'));
        sortRowEl.style.display = '';

        if (listError) {
            listMetaEl.textContent = 'Nie udało się wczytać listy';
            setListContent(listContentEl, renderListError('Nie udało się wczytać listy transakcji.', 'data-list-retry', listError));
            listMoreBtn.style.display = 'none';
            return;
        }

        if (listLoading && listRows.length === 0) {
            setListContent(listContentEl, renderListSkeleton('Ładowanie listy transakcji…'));
            listMoreBtn.style.display = 'none';
            return;
        }

        if (!listRows.length) {
            setListContent(listContentEl, '<div class="ms-empty-state nm-empty-state"><strong>Brak transakcji w tym widoku</strong><span>Zmień filtry transakcji albo oddal mapę.</span></div>');
            listMoreBtn.style.display = 'none';
            return;
        }

        renderedTransactionRows = listRows.slice();
        renderKeyedStack(listContentEl, renderedTransactionRows.map(function(row) {
            return { key: row.feature_id || ('t:' + row.tran_lokalny_id_iip), html: renderListCardHtml(row) };
        }));
        renderListMoreControls(listMoreBtn, listMoreErrorEl, { visible: listHasMore, failed: listMoreFailed, label: listMoreLabel });
        applySelectedStylesInList();
    }

    function loadListPage(page, append) {
        listDataManager.loadListPage(page, append);
    }

    function renderNearbyList() {
        nearbyManager.renderList();
    }

    function refreshNearbyMeta() {
        if (!nearbyMetaEl) {
            return;
        }

        if (!selectedLatLng) {
            nearbyMetaEl.textContent = 'Wybierz obiekt i otwórz otoczenie';
            return;
        }

        if (!nearbyItems.length) {
            nearbyMetaEl.textContent = nearbyLoaded ? 'Brak obiektów w pobliżu' : 'Wybierz obiekt i otwórz otoczenie';
            return;
        }

        nearbyMetaEl.textContent = countLabel(nearbyItems.length, 'obiekt', 'obiekty', 'obiektów') + ' w pobliżu'
            + (hasActiveBdot10kFilters() ? ' po filtrach' : '');
    }

    function applyNearbyLayerVisibility() {
        nearbyManager.applyLayerVisibility();
    }

    function focusNearbyItem(item, options) {
        nearbyManager.focusItem(item, options);
    }

    function renderNearbyLayer(data) {
        nearbyManager.renderLayer(data);
    }

    function renderPointNearbyChoice() {
        var session = pointQuerySession.get();
        if (!session) return;
        nearbyMetaEl.textContent = 'Wybierz punkt odniesienia';
        // Answers of overlay layers describe the place; only objects can be chosen.
        var objects = objectHits(session);
        nearbyContentEl.innerHTML = '<div class="ms-alert"><p>' + (objects.length
            ? 'Możesz wybrać znaleziony obiekt albo sprawdzić otoczenie dokładnie w miejscu kliknięcia na mapie.'
            : 'Możesz sprawdzić otoczenie dokładnie w miejscu kliknięcia na mapie.') + '</p>'
            + (objects.length ? '<button type="button" class="ms-button ms-button--primary" data-point-choose-object>'
                + (objects.length === 1 && objects[0].type === 'parcel' ? 'Wybierz znalezioną działkę' : 'Wybierz znaleziony obiekt') + '</button>' : '')
            + '<button type="button" class="ms-button ms-button--secondary" data-point-analyze>Pokaż otoczenie wskazanego punktu</button></div>';
    }

    nearbyContentEl.addEventListener('click', function(e) {
        if (e.target.closest('[data-point-choose-object]')) {
            setTab('list', { snap: 'full' });
            listContentEl.scrollTop = 0;
        }
        if (e.target.closest('[data-point-analyze]')) {
            var session = pointQuerySession.get();
            if (!session) return;
            var point = { lat: session.latlng.lat, lng: session.latlng.lng };
            pointQuerySession.cancel();
            clearSelection({ keepDetails: false, sync: false });
            selectedLatLng = point;
            nearbyPointReference = point;
            interactiveHitDispatcher.showClickMarker(point);
            loadNearbyForSelection(true);
            syncUrl();
        }
    });

    function loadNearbyForSelection(openTab) {
        if (personaModule) {
            personaModule.reset({ renderNearby: false });
        }
        nearbyManager.loadForSelection(openTab);
    }

    function getFeatureCentroid(feature) {
        if (!feature || !feature.geometry) return null;
        var c = centroidOfGeometry(feature.geometry);
        if (!c) return null;
        return { lat: c[1], lng: c[0] };
    }

    function browseOverlapInPanel(latlng, features) {
        overlapManager.browseOverlapInPanel(latlng, features);
    }

    function exitOverlapBrowse() {
        overlapManager.exitOverlapBrowse();
        syncUrl();
    }

    // ── GUNB RWDZ browse / select / detail ─────────────────────────────

    function browseGunbInPanel(latlng, features) {
        gunbManager.browseGunbInPanel(latlng, features);
    }

    function exitGunbBrowse() {
        gunbManager.exitGunbBrowse();
        syncUrl();
    }

    function browseCombinedInPanel(latlng, transFeatures, gunbFeatures) {
        clearTapBrowseState();
        overlapBrowseFeatures = null;
        overlapBrowseLatlng = null;
        gunbBrowseFeatures = null;
        gunbBrowseLatlng = null;

        var otherHits = arguments.length > 3 ? arguments[3] : null;
        transFeatures = Array.isArray(transFeatures) ? transFeatures.filter(Boolean) : [];
        gunbFeatures = Array.isArray(gunbFeatures) ? gunbFeatures.filter(Boolean) : [];

        if ((!otherHits || !otherHits.length)
            && transFeatures.length
            && tapResolutionManager
            && typeof tapResolutionManager.collectCombinedSupportingHits === 'function') {
            var supportingHits = tapResolutionManager.collectCombinedSupportingHits(transFeatures);
            if (!gunbFeatures.length && supportingHits.gunbFeatures.length) {
                gunbFeatures = supportingHits.gunbFeatures;
            }
            otherHits = supportingHits.otherHits;
        }

        combinedBrowseTransactions = transFeatures;
        combinedBrowseGunb = gunbFeatures;
        combinedBrowseOtherHits = Array.isArray(otherHits) ? otherHits.filter(Boolean) : [];
        combinedBrowseLatlng = latlng;
        renderListPanel();
        setTab('list', { snap: 'half' });
    }

    function exitCombinedBrowse() {
        tapBrowseManager.exitCombinedBrowse();
        syncUrl();
    }

    function clearTapBrowseState() {
        tapBrowseManager.clearTapBrowseState();
        overlapBrowseFeatures = null;
        overlapBrowseLatlng = null;
        gunbBrowseFeatures = null;
        gunbBrowseLatlng = null;
        combinedBrowseTransactions = null;
        combinedBrowseGunb = null;
        combinedBrowseOtherHits = null;
        combinedBrowseLatlng = null;
    }

    function browseTapHitsInPanel(latlng, hits) {
        tapBrowseManager.browseTapHitsInPanel(latlng, hits);
    }

    function getBrowseStateLatlng() {
        if (pointQuerySession && pointQuerySession.get()) return pointQuerySession.get().latlng;
        if (pendingTapBrowseRestore && tapBrowseLatlng) return tapBrowseLatlng;
        if (tapBrowseHits && tapBrowseLatlng) return tapBrowseLatlng;
        if ((combinedBrowseTransactions || combinedBrowseGunb || combinedBrowseOtherHits) && combinedBrowseLatlng) {
            return combinedBrowseLatlng;
        }
        if (gunbBrowseFeatures && gunbBrowseLatlng) return gunbBrowseLatlng;
        if (overlapBrowseFeatures && overlapBrowseLatlng) return overlapBrowseLatlng;
        return null;
    }

    function tryRestoreTapBrowse() {
        if (!pendingTapBrowseRestore || tapBrowseRestoreScheduled || !tapBrowseLatlng || !map || !tapResolutionManager) {
            return;
        }

        function restoreAtSavedPoint() {
            tapBrowseRestoreScheduled = false;
            if (!pendingTapBrowseRestore || !tapBrowseLatlng) return;
            pendingTapBrowseRestore = false;
            var restoredLatlng = { lat: tapBrowseLatlng.lat, lng: tapBrowseLatlng.lng };
            var point = map.project([restoredLatlng.lng, restoredLatlng.lat]);
            startPointQuery(restoredLatlng, point);
        }

        if (typeof map.once === 'function') {
            // queryRenderedFeatures starts returning the newly added source only
            // after MapLibre has painted a frame with it.
            tapBrowseRestoreScheduled = true;
            map.once('render', restoreAtSavedPoint);
            map.triggerRepaint();
            return;
        }

        restoreAtSavedPoint();
    }

    function exitTapBrowse() {
        tapBrowseManager.exitTapBrowse();
        syncUrl();
    }

    function renderTapHitBrowsePanel() {
        tapBrowseManager.renderTapHitBrowsePanel();
    }

    function resolveTapHitSelection(kind, id, latlng) {
        tapBrowseManager.resolveTapHitSelection(kind, id, latlng);
    }

    function renderCombinedBrowsePanel() {
        listPanelRenderers.renderCombinedBrowsePanel();
    }

    function renderGunbListCardHtml(props) {
        return listPanelRenderers.renderGunbListCardHtml(props);
    }

    function renderGunbBrowsePanel() {
        listPanelRenderers.renderGunbBrowsePanel();
    }

    function selectGunbPermit(feature, fallbackLatlng) {
        selectedNoiseContext = null;
        gunbManager.selectGunbPermit(feature, fallbackLatlng);
    }

    function fetchGunbDetail(id) {
        gunbManager.fetchGunbDetail(id);
    }

    function renderGunbDetails(data) {
        detailRenderers.renderGunbDetails(data);
    }

    function applySelectedStylesInGunbList() {
        listPanelRenderers.applySelectedStylesInGunbList();
    }

    function clearOverlapLayer() {
        overlapManager.clearOverlapLayer();
    }

    function renderGeoJson(data) {
        var perfToken = perfStart('render-transactions', {
            aggregated: data && data.aggregated === true,
            featureCount: data && data.features ? data.features.length : 0,
            zoom: map ? mapZoom() : null
        });
        latestGeoData = data;
        resetHighlight();
        overlapManager.refreshGroupsFromGeoJson(data);

        bringDataLayersToFront();
        overlapManager.buildCombinedBadges();
        applySelectionFocusState();
        if (selectedTid) tryHighlightTransactionParcel(selectedTid);
        applyNearbyLayerVisibility();
        renderListPanel();
        perfEnd(perfToken, {
            overlapGroups: overlapGroupsCache ? overlapGroupsCache.length : 0
        });

        return geoLayer;
    }

    function getGeoQuery() {
        return qstr(Object.assign({ bbox: currentBbox(0), zoom: mapZoom(), detail: 'map' }, getApiFilters()));
    }

    function clearGeoLayer() {
        if (!geoLayer) return;
        if (geoLayer instanceof MarkerGroup) { geoLayer.remove(); }
        else { removeSourceAndLayers(map, TransactionsLayer.SOURCE_ID, TransactionsLayer.BASE_LAYER_IDS); }
        clearTransactionHighlight();
        geoLayer = null;
    }

    function handleLimitedGeoState() {
        latestGeoData = { features: [], aggregated: false, stats: { count: 0, avg_cena: null } };
        clearGeoLayer();
        clearOverlapLayer();
        renderListPanel();
    }

    function handleGeoJsonFetchError(err) {
        if (err && (err.name === 'AbortError' || err.status === 503)) {
            return;
        }

        latestGeoData = { features: [], aggregated: false, stats: { count: 0, avg_cena: null } };
        clearGeoLayer();
        clearOverlapLayer();
        renderListPanel();
    }

    function loadGeoJson() {
        updateLimitedBanner();
        if (!transactionsController) {
            return;
        }

        transactionsController.load();
    }

    function tryRestoreParcelSelection() {
        if (!selectedDid || selectedFeatureLayerKey === getSelectedFeatureKey('parcel', selectedDid)) return;
        renderDetailsLoading('Działka ' + selectedDid);
        ensureSelectedFeatureData('parcel', selectedDid, {
            renderLayer: true,
            renderDetails: true
        });
    }

    function tryRestoreBuildingSelection() {
        if (!selectedBid || selectedFeatureLayerKey === getSelectedFeatureKey('building', selectedBid)) return;
        renderDetailsLoading('Budynek ' + selectedBid);
        ensureSelectedFeatureData('building', selectedBid, {
            renderLayer: true,
            renderDetails: true
        });
    }

    function renderDzialkiData(data) {
        var perfToken = perfStart('render-dzialki', {
            mode: PARCEL_RENDER_MODE,
            featureCount: data && data.features ? data.features.length : 0,
            zoom: map ? mapZoom() : null
        });
        bringDataLayersToFront();
        tryRestoreParcelSelection();
        applySelectionFocusState();
        perfEnd(perfToken, {
            hasSelection: !!selectedDid
        });

        return dzialkiLayer;
    }

    function loadDzialki() {
        if (!dzialkiController) {
            return;
        }

        dzialkiController.load();
    }

    function requestMobileTapResolution(latlng, point) {
        tapResolutionManager.requestMobileTapResolution(latlng, point);
    }

    function requestParcelHit(latlng) {
        if (!map || !latlng || !dzialkiActive || mapZoom() < DzialkiLayer.MIN_ZOOM) {
            return;
        }

        if (abortParcelHit) {
            abortParcelHit.abort();
        }

        var controller = new AbortController();
        var requestVersion = ++parcelHitRequestVersion;
        var perfToken = perfStart('parcel-hit', {
            zoom: mapZoom(),
            lat: Math.round(latlng.lat * 100000) / 100000,
            lng: Math.round(latlng.lng * 100000) / 100000
        });
        abortParcelHit = controller;

        fetch(BASE_URL + 'api/dzialki-hit?lat=' + encodeURIComponent(latlng.lat) + '&lng=' + encodeURIComponent(latlng.lng), {
            signal: controller.signal
        })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (controller.signal.aborted || requestVersion !== parcelHitRequestVersion) {
                    return;
                }
                if (!data || !data.found || !data.properties) {
                    return;
                }
                selectParcel(data.properties, latlng);
            })
            .catch(function(error) {
                if (error && error.name === 'AbortError') {
                    return;
                }
            })
            .finally(function() {
                perfEnd(perfToken, {
                    requestVersion: requestVersion
                });
                if (abortParcelHit === controller) {
                    abortParcelHit = null;
                }
            });
    }

    function renderBudynkiData(data) {
        var perfToken = perfStart('render-budynki', {
            featureCount: data && data.features ? data.features.length : 0,
            zoom: map ? mapZoom() : null
        });
        bringDataLayersToFront();
        tryRestoreBuildingSelection();
        applySelectionFocusState();
        perfEnd(perfToken, {
            hasSelection: !!selectedBid
        });

        return budynkiLayer;
    }

    function loadBudynki() {
        if (!budynkiController) {
            return;
        }

        budynkiController.load();
    }

    function renderSelectionPinData(_data, result) {
        if (result && result.center && !selectedLatLng) {
            selectedLatLng = result.center;
            if (pendingNearbyRestore && !nearbyLoaded) {
                loadNearbyForSelection(false);
            }
        }

        return selectionPinLayer;
    }

    function loadSelectionPin() {
        var layerType = selectedDid ? 'parcel' : (selectedBid ? 'building' : null);
        var featureId = selectedDid || selectedBid;
        if (layerType && featureId && selectedFeatureLayerKey === getSelectedFeatureKey(layerType, featureId)) {
            if (selectionPinController) {
                selectionPinController.clear();
            } else if (selectionPinLayer && map) {
                removeSourceAndLayers(map, SelectionPinLayer.SOURCE_ID, SelectionPinLayer.LAYER_IDS);
            }
            selectionPinLayer = null;
            return;
        }

        if (!selectionPinController) {
            return;
        }

        selectionPinController.load();
    }

    // Pending timers for staggered data-layer loads (see runStaggeredLoaders).
    var apiStaggerTimers = [];
    var filterApplyLoadingTimer = null;
    var filterApplyPendingLayerId = null;
    var filterApplyLayerStarted = false;
    var filterApplyLayerSettled = false;
    var filterApplyAuxPending = false;

    var FILTER_SCOPE_LAYER_IDS = {
        transactions: 'transakcje',
        listings: 'ogloszenia',
        parcels: 'dzialki',
        buildings: 'budynki',
        signals: 'sygnaly',
        surroundings: 'otoczenie',
        permits: 'gunb',
    };

    function finishFilterApplyLoading() {
        if (filterApplyLoadingTimer) {
            clearTimeout(filterApplyLoadingTimer);
            filterApplyLoadingTimer = null;
        }
        filterApplyPendingLayerId = null;
        filterApplyLayerStarted = false;
        filterApplyLayerSettled = false;
        filterApplyAuxPending = false;
        if (applyFiltersBtn) {
            applyFiltersBtn.classList.remove('is-loading');
            applyFiltersBtn.disabled = false;
            applyFiltersBtn.removeAttribute('aria-busy');
        }
    }

    function maybeFinishFilterApplyLoading() {
        if (!filterApplyPendingLayerId || !filterApplyLayerStarted || !filterApplyLayerSettled || filterApplyAuxPending) {
            return;
        }
        if (mapRefreshTimer || (map && typeof map.isMoving === 'function' && map.isMoving())) {
            return;
        }
        finishFilterApplyLoading();
    }

    function beginFilterApplyLoading(scope) {
        if (!applyFiltersBtn) {
            return;
        }
        if (filterApplyLoadingTimer) {
            clearTimeout(filterApplyLoadingTimer);
        }
        filterApplyPendingLayerId = FILTER_SCOPE_LAYER_IDS[scope] || 'transakcje';
        filterApplyLayerStarted = false;
        filterApplyLayerSettled = false;
        filterApplyAuxPending = scope === 'parcels' || scope === 'buildings';
        applyFiltersBtn.classList.add('is-loading');
        applyFiltersBtn.disabled = true;
        applyFiltersBtn.setAttribute('aria-busy', 'true');

        // Awaryjnie odblokuj interfejs, jeżeli zewnętrzne żądanie utknie bez
        // odpowiedzi. Zwykła ścieżka kończy spinner po wyrenderowaniu warstwy.
        filterApplyLoadingTimer = setTimeout(finishFilterApplyLoading, 30000);
    }

    function handleDataLayerRequestStarted(layer) {
        if (layer && layer.id === 'ogloszenia') renderListPanel();
        if (layerPanel && layer) layerPanel.setLoading(layer.id, true);
        if (!layer || layer.id !== filterApplyPendingLayerId) {
            return;
        }
        filterApplyLayerStarted = true;
        filterApplyLayerSettled = false;
    }

    function handleDataLayerRequestSettled(layer) {
        schedulePointQueryRefresh();
        if (layer && layer.id === 'ogloszenia') renderListPanel();
        if (layerPanel && layer) layerPanel.setLoading(layer.id, false);
        if (!layer || layer.id !== filterApplyPendingLayerId || !filterApplyLayerStarted) {
            return;
        }
        filterApplyLayerSettled = true;
        maybeFinishFilterApplyLoading();
    }

    function handleFilterApplyAuxSettled(scope) {
        filterApplyAuxPending = false;
        var controller = scope === 'parcels' ? dzialkiController : budynkiController;
        if (!filterApplyLayerStarted && controller && !controller.canActivate()) {
            // Przy zbyt małym zbliżeniu wyniki EGiB są prezentowane jako lista
            // i znaczniki, mimo że właściwa warstwa nie może jeszcze się włączyć.
            filterApplyLayerStarted = true;
            filterApplyLayerSettled = true;
        }
        maybeFinishFilterApplyLoading();
    }

    function clearApiStaggerTimers() {
        for (var i = 0; i < apiStaggerTimers.length; i++) {
            clearTimeout(apiStaggerTimers[i]);
        }
        apiStaggerTimers.length = 0;
    }

    // Fire data-layer loaders one at a time, spaced by API_REFRESH_STAGGER_MS,
    // instead of launching every active layer's request in a single tick. The
    // first runs immediately so the refresh still feels instant; the rest are
    // spread out so one pan can't hit the backend with ~10 parallel requests at
    // once. Still-pending loaders are cleared when a new pan or refresh starts.
    function runStaggeredLoaders(loaders) {
        clearApiStaggerTimers();
        var delay = 0;
        for (var i = 0; i < loaders.length; i++) {
            var fn = loaders[i];
            if (typeof fn !== 'function') continue;
            if (delay === 0) {
                fn();
            } else {
                apiStaggerTimers.push(setTimeout(fn, delay));
            }
            delay += API_REFRESH_STAGGER_MS;
        }
    }

    function refreshAll(options) {
        options = options || {};
        var session = pointQuerySession && pointQuerySession.get();
        if (session && session.filterKey !== JSON.stringify(filterState)) {
            pointQuerySession.cancel();
        }
        showListLoadingIndicator();
        overlapBrowseFeatures = null;
        overlapBrowseLatlng = null;
        combinedBrowseTransactions = null;
        combinedBrowseGunb = null;
        combinedBrowseOtherHits = null;
        combinedBrowseLatlng = null;
        if (options.resetList) {
            listRows = [];
            listTotal = 0;
            listTotalEstimated = false;
            listHasMore = false;
            listPage = 1;
        }
        var loaders = [];
        if (transakcjeActive) {
            loaders.push(loadGeoJson);
            loaders.push(function() { loadListPage(1, false); });
        } else {
            if (geoLayer) { clearGeoLayer(); }
            clearOverlapLayer();
            renderListPanel();
        }
        if (dzialkiActive) loaders.push(loadDzialki);
        if (mpzpRuActive) loaders.push(loadMpzpRu);
        if (budynkiActive) loaders.push(loadBudynki);
        if (gunbActive) loaders.push(loadGunb);
        if (sygnalyActive) loaders.push(loadSignals);
        if (ogloszeniaActive) loaders.push(loadListings);
        if (ofertyDeweloperowActive) loaders.push(loadDeveloperOffers);
        if (otoczenieActive) loaders.push(loadOtoczenie);
        if (educationLayerRuntime.getActive()) loaders.push(function() {
            var educationController = educationLayerRuntime.getController();
            if (educationController) educationController.load();
        });
        loaders.push(loadSelectionPin);
        runStaggeredLoaders(loaders);
        syncUrl();
    }

    function scheduleMapRefresh() {
        if (listingsController && ogloszeniaActive) {
            listingsController.loadState = 'loading';
            renderListPanel();
        }
        // Show the list loading hint as soon as the map settles, before the
        // debounced refresh actually fires, so the feedback feels immediate.
        showListLoadingIndicator();
        if (mapRefreshTimer) clearTimeout(mapRefreshTimer);
        mapRefreshTimer = setTimeout(function() {
            mapRefreshTimer = null;
            refreshAll({ resetList: true });
        }, MAP_REFRESH_DEBOUNCE_MS);
    }

    var initState = restoreStateFromUrl();

    window.addEventListener('popstate', function() {
        // Re-run the regular URL restoration path. This keeps Back/Forward
        // reliable across every selection and layer type without duplicating
        // the map bootstrap logic in a second in-place state machine.
        window.location.reload();
    });

    // „Przejdź do treści” moves focus to the map without a fragment
    // navigation: a new #tresc history entry would fire popstate above and
    // reload the map.
    var skipLink = document.querySelector('.ms-skip-link[href="#tresc"]');
    var skipTarget = document.getElementById('tresc');
    if (skipLink && skipTarget) {
        skipLink.addEventListener('click', function(event) {
            event.preventDefault();
            if (!skipTarget.hasAttribute('tabindex')) {
                skipTarget.setAttribute('tabindex', '-1');
            }
            skipTarget.focus();
        });
    }

    applyTheme();
    syncLayoutMode();
    applyFilterInputs();
    setFilterScope(ogloszeniaActive ? 'listings' : 'transactions');
    setupTerytAutocomplete();
    setupTransactionAddressAutocomplete();
    setupListingLocationAutocomplete();
    setupEgibLocationAutocomplete(
        parcelLocationQueryInput,
        parcelLocationSuggestEl,
        'parcels',
        'data-parcel-location-pick'
    );
    setupEgibLocationAutocomplete(
        buildingLocationQueryInput,
        buildingLocationSuggestEl,
        'buildings',
        'data-building-location-pick'
    );
    setupEgibMapBoundsButtons();
    setupTokenField(
        parcelNeighbourNumbersInput,
        parcelNeighbourNumbersEditor,
        parcelNeighbourNumbersValuesEl,
        function(value) {
            return String(value || '').trim().slice(0, 96);
        },
        ''
    );
    setupTokenField(
        parcelNeighbourAreasInput,
        parcelNeighbourAreasEditor,
        parcelNeighbourAreasValuesEl,
        function(value) {
            var normalized = String(value || '').trim().replace(',', '.');
            var number = Number(normalized);
            return isFinite(number) && number > 0 ? String(number) : '';
        },
        'm²'
    );
    fetchTerytPowiaty();

    // Draws the fallback card in place of the map canvas. Both failure modes
    // below share the markup and the reload button; only the copy differs.
    function renderMapFallback(title, message) {
        var mapEl = document.getElementById('nm-map');
        if (!mapEl) return;
        mapEl.innerHTML = '<div class="nm-map-fallback">'
            + '<strong>' + title + '</strong>'
            + '<span>' + message + '</span>'
            + '<button type="button" class="ms-button ms-button--secondary ms-button--block nm-secondary-btn nm-map-fallback__reload">Odśwież stronę</button>'
            + '</div>';
        var reloadBtn = mapEl.querySelector('.nm-map-fallback__reload');
        if (reloadBtn) {
            reloadBtn.addEventListener('click', function() { window.location.reload(); });
        }
    }

    // The maplibregl global is missing, so the library script never ran at all
    // (failed request, blocked resource, upstream removing the build we ask for).
    // That has nothing to do with the visitor's hardware — never blame WebGL here.
    function showMapLoadFailedNotice() {
        if (window.console && console.error) {
            console.error('Map initialization failed: maplibregl is undefined, the library script did not load.');
        }
        renderMapFallback(
            'Nie udało się wczytać mapy',
            'Nie udało się pobrać biblioteki mapy. Sprawdź połączenie z internetem i odśwież stronę.'
        );
    }

    // MapLibre GL requires WebGL; the constructor throws when the browser
    // cannot create a context (missing support, hardware acceleration off,
    // crashed GPU process). Show a notice instead of dying with an uncaught
    // error that would leave the whole app blank.
    function showMapUnavailableNotice(err) {
        if (window.console && console.error) {
            console.error('Map initialization failed (WebGL unavailable):', err);
        }
        renderMapFallback(
            'Nie udało się uruchomić mapy',
            'Twoja przeglądarka nie obsługuje WebGL albo ma wyłączoną akcelerację sprzętową, dlatego mapa nie może zostać wyświetlona. Włącz akcelerację sprzętową w ustawieniach przeglądarki albo spróbuj otworzyć stronę w innej przeglądarce.'
        );
    }

    if (typeof maplibregl === 'undefined') {
        showMapLoadFailedNotice();
        return;
    }

    try {
        map = createBasemapMap(maplibregl, {
            container: 'nm-map',
            style: window.RCN_MAP_STYLE_OVERRIDE || OPENFREEMAP_STYLE,
            center: [initState.lng, initState.lat],
            zoom: initState.zoom,
            minZoom: 5,
            maxZoom: MAP_MAX_ZOOM
        });
    } catch (mapInitError) {
        showMapUnavailableNotice(mapInitError);
        return;
    }
    map.addControl(new maplibregl.NavigationControl({
        showCompass: true,
        showZoom: true,
        visualizePitch: false,
    }), 'top-right');

    // The parcel and building layers draw EGiB material and are served from our
    // own database, so they carry no per-source attribution of their own. The
    // PZGiK licence still requires the notice wherever that material is shown,
    // so it is pinned to the map itself rather than to individual layers.
    mapAttributionControl = new maplibregl.AttributionControl({
        compact: true,
        customAttribution: PZGIK_NOTICE + '.',
    });
    map.addControl(mapAttributionControl, 'bottom-right');

    // OpenFreeMap's "bright" style references POI sprite icons that aren't in
    // its sprite sheet (atm, gate, running, brownfield, etc.). Provide a 1x1
    // transparent placeholder for any missing image to silence the warnings.
    map.on('styleimagemissing', function(e) {
        var id = e.id;
        if (!id || map.hasImage(id)) return;
        map.addImage(id, { width: 1, height: 1, data: new Uint8Array(4) });
    });

    // Wait for style to load before adding layers
    map.on('load', function() {
        initLayerToggles();
        initLayerControllers();
        updateSearchRadiusCircles();
        initSheetDrag();
        setSheetSnap('half');
        setTab(activeTab, { sync: false, snap: activeTab === 'filters' ? 'full' : 'half' });

        // Map event handlers (need style loaded)
        map.on('movestart', function(event) {
            userMapNavigationPending = !!(event && event.originalEvent);
            if (userMapNavigationPending && pointQuerySession) {
                pointQuerySession.cancel();
                renderListPanel();
            }
            try {
                if (abortGeo) abortGeo.abort();
                if (abortList) abortList.abort();
                if (abortListings) abortListings.abort();
                if (abortDeveloperOffers) abortDeveloperOffers.abort();
                if (abortListingDetail) abortListingDetail.abort();
                if (abortDzialki) abortDzialki.abort();
                if (abortMpzpRu) abortMpzpRu.abort();
                if (abortBudynki) abortBudynki.abort();
                if (abortGunb) abortGunb.abort();
                if (abortOtoczenie) abortOtoczenie.abort();
                if (educationLayerRuntime.getAbortController()) educationLayerRuntime.getAbortController().abort();
                if (abortSelectionPin) abortSelectionPin.abort();
                if (abortParcelHit) abortParcelHit.abort();
                interactiveHitDispatcher.clearClickMarker();
                tapResolutionManager.abortCurrentRequest();
                if (userMapNavigationPending && kowrController && typeof kowrController.abortFeatureInfo === 'function') {
                    kowrController.abortFeatureInfo();
                }
            } catch (_) {}
            clearTapBrowseState();
            if (mapRefreshTimer) {
                clearTimeout(mapRefreshTimer);
                mapRefreshTimer = null;
            }
            clearApiStaggerTimers();
        });

        map.on('moveend', function() {
            syncUrl(null, null, { mapNavigation: userMapNavigationPending });
            userMapNavigationPending = false;
            scheduleMapRefresh();
            syncLayerTogglesVisibility();
            if (kowrController && typeof kowrController.syncPointerCursor === 'function') {
                kowrController.syncPointerCursor();
            }
        });

        map.on('sourcedata', function(event) {
            // GeoJSON may finish processing in a worker after the HTTP request.
            // Raster tile completion is deliberately unrelated to point queries.
            if (event.source && event.source.type !== 'raster' && event.isSourceLoaded) schedulePointQueryRefresh();
        });

        map.on('mousedown', function(e) {
            parcelMeasurementManager.handleMapPointerDown(e);
        });
        map.on('mouseup', function() {
            parcelMeasurementManager.handleMapPointerUp();
        });
        map.on('touchstart', function(e) {
            parcelMeasurementManager.handleMapPointerDown(e);
        });
        map.on('touchmove', function(e) {
            parcelMeasurementManager.handleMapMove(e);
        });
        map.on('touchend', function() {
            parcelMeasurementManager.handleMapPointerUp();
        });
        map.on('mousemove', function(e) {
            var measurementOwnsCursor = parcelMeasurementManager.handleMapMove(e);
            if (!measurementOwnsCursor && kowrController && typeof kowrController.syncPointerCursor === 'function') {
                kowrController.syncPointerCursor();
            }
        });

        map.on('click', function(e) {
            if (parcelMeasurementManager.handleMapClick(e)) {
                return;
            }
            var handledLayerClick = shouldIgnoreMapClick(e);
            if (handledLayerClick || isNearbyFeatureMapClick(e)) {
                return;
            }

            var latlng = { lat: e.lngLat.lat, lng: e.lngLat.lng };

            if (signalSubmitController && signalSubmitController.isOpen()) {
                signalSubmitController.handleMapClick(latlng);
                if (!isDesktopLayout() && getCurrentSheetSnap() === 'full') {
                    setSheetSnap('half');
                }
                return;
            }

            startPointQuery(latlng, e.point);
            if (!isDesktopLayout() && getCurrentSheetSnap() === 'full') {
                setSheetSnap('half');
            }
        });

        updateLimitedBanner();
        renderListPanel();
        if (!renderSignalNoticeDetails()) {
            renderDetailsPlaceholder();
        }
        updateSelectionControl();
        syncLayerTogglesVisibility();
        refreshAll({ resetList: true });

        if (pendingTapBrowseRestore) {
            setTab('list', { sync: false, snap: 'half' });
        } else if (selectedNoiseContext) {
            renderDetailsLoading('Strategiczna mapa hałasu');
            setDetailsKicker('Wybrana warstwa mapy');
            setTab(activeTab === 'filters' ? 'filters' : 'details', {
                sync: false,
                snap: activeTab === 'filters' ? 'full' : 'half'
            });
            tryRestoreNoiseSelection(selectedNoiseContext.layerKey);
        } else if (selectedTid) {
            renderDetailsLoading('Transakcja ' + selectedTid.substring(0, 8));
            fetchTransactionDetail(selectedTid);
            updateSelectionControl();
            var restoredTab = activeTab === 'filters' ? 'filters' : (activeTab === 'list' ? 'details' : activeTab);
            setTab(restoredTab, {
                sync: false,
                snap: activeTab === 'filters' ? 'full' : 'half'
            });
            // Load nearby immediately if pending (don't wait for GeoJSON)
            if (pendingNearbyRestore && selectedLatLng && !nearbyLoaded) {
                loadNearbyForSelection(restoredTab === 'nearby');
            }
        } else if (selectedGunbId) {
            renderDetailsLoading('Pozwolenie na budow\u0119');
            fetchGunbDetail(selectedGunbId);
            updateSelectionControl();
            var restoredTabG = activeTab === 'filters' ? 'filters' : (activeTab === 'list' ? 'details' : activeTab);
            setTab(restoredTabG, { sync: false, snap: activeTab === 'filters' ? 'full' : 'half' });
            if (pendingNearbyRestore && selectedLatLng && !nearbyLoaded) {
                loadNearbyForSelection(restoredTabG === 'nearby');
            }
        } else if (selectedListingId) {
            fetchListingDetail(selectedListingId);
            updateSelectionControl();
            var restoredTabL = activeTab === 'filters' ? 'filters' : (activeTab === 'list' ? 'details' : activeTab);
            setTab(restoredTabL, { sync: false, snap: activeTab === 'filters' ? 'full' : 'half' });
            if (pendingNearbyRestore && selectedLatLng && !nearbyLoaded) {
                loadNearbyForSelection(restoredTabL === 'nearby');
            }
        } else if (selectedDid || selectedBid) {
            if (selectedDid) {
                renderDetailsLoading('Działka ' + selectedDid);
                ensureSelectedFeatureData('parcel', selectedDid, {
                    renderLayer: true,
                    renderDetails: true
                });
            } else if (selectedBid) {
                renderDetailsLoading('Budynek ' + selectedBid);
                ensureSelectedFeatureData('building', selectedBid, {
                    renderLayer: true,
                    renderDetails: true
                });
            }
            updateSelectionControl();
            var restoredTabF = activeTab === 'filters' ? 'filters' : (activeTab === 'list' ? 'details' : activeTab);
            setTab(restoredTabF, { sync: false, snap: activeTab === 'filters' ? 'full' : 'half' });
            if (pendingNearbyRestore && selectedLatLng && !nearbyLoaded) {
                loadNearbyForSelection(restoredTabF === 'nearby');
            }
        } else if (selectedSignalContext) {
            renderSignalTargetDetails({
                target_identifier: selectedSignalContext.targetIdentifier || null,
                target_label: selectedSignalContext.targetLabel || null,
                target_subtitle: selectedSignalContext.targetSubtitle || null,
            }, selectedSignalContext);
            updateSelectionControl();
            var restoredTabS = activeTab === 'filters' ? 'filters' : (activeTab === 'list' ? 'details' : activeTab);
            setTab(restoredTabS, { sync: false, snap: activeTab === 'filters' ? 'full' : 'half' });
            if (pendingNearbyRestore && selectedLatLng && !nearbyLoaded) {
                loadNearbyForSelection(restoredTabS === 'nearby');
            }
        } else if (selectedOtoczenieId) {
            renderDetailsLoading('Obiekt otoczenia');
            updateSelectionControl();
            var restoredTabO = activeTab === 'filters' ? 'filters' : (activeTab === 'list' ? 'details' : activeTab);
            setTab(restoredTabO, { sync: false, snap: activeTab === 'filters' ? 'full' : 'half' });
        } else if (selectedLatLng && pendingNearbyRestore && !nearbyLoaded) {
            nearbyPointReference = selectedLatLng;
            updateSelectionControl();
            setTab(activeTab === 'filters' ? 'filters' : 'nearby', {
                sync: false,
                snap: activeTab === 'filters' ? 'full' : 'half'
            });
            loadNearbyForSelection(activeTab !== 'filters');
        }

        if (selectedSearchItem) {
            pickSearchItem(map, selectedSearchItem, { skipFly: true, silent: true });
        }

        tryRestoreTapBrowse();

        // Listing-page links contain the area identity, but may omit its bounds.
        // Restore them once without interrupting a later selection or map move.
        if (activeFilterScope === 'listings' && !selectedLatLng && !selectedSearchItem && !pendingTapBrowseRestore) {
            var initialListingFilterState = filterState;
            var initialListingCenter = map.getCenter();
            var initialListingZoom = map.getZoom();
            restoreListingAreaBbox(initialListingFilterState).then(function(restored) {
                if (!restored || filterState !== initialListingFilterState) return;
                syncUrl();
                var currentCenter = map.getCenter();
                if (activeFilterScope === 'listings' && !selectedLatLng && !selectedSearchItem
                    && currentCenter.lng === initialListingCenter.lng && currentCenter.lat === initialListingCenter.lat
                    && map.getZoom() === initialListingZoom) {
                    fitMapToActiveLocationRadius();
                }
            });
        }

        syncUrl();
        historyBootstrapComplete = true;
    }); // end map.on('load')

    initSearchModule({
        getMap: function() { return map; },
        onMapClickHandled: consumeHandledMapClick,
        onItemPicked: function(item) {
            selectedSearchItem = {
                type: item.type,
                id: item.id != null ? String(item.id) : null,
                lat: item.lat,
                lng: item.lng,
                nazwa: item.nazwa || '',
                bbox: Array.isArray(item.bbox) ? item.bbox.slice() : item.bbox || null,
            };
            syncUrl();
        },
        onItemCleared: function() {
            if (!selectedSearchItem) return;
            selectedSearchItem = null;
            syncUrl();
        }
    });

    initAuthModal();
    // „Co nowego” waits for the start dialog and for „Dokończ sprawdzanie”; unseen
    // news of a returning visitor still come first.
    initWhatsNew({ suppressAutoOpen: startDialog.autoOpened || (guidedResume.shown && !newsPending) });

    var topNavMobile = document.getElementById('nm-top-nav-mobile');
    var topNavBtn = document.getElementById('nm-top-nav-btn');
    var topNavMenu = document.getElementById('nm-top-nav-menu');
    if (topNavMobile && topNavBtn && topNavMenu) {
        var setTopNavOpen = function(open) {
            topNavBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
            topNavMenu.hidden = !open;
        };

        topNavBtn.addEventListener('click', function(event) {
            event.stopPropagation();
            var nextOpen = topNavBtn.getAttribute('aria-expanded') !== 'true';
            setTopNavOpen(nextOpen);
        });

        topNavMenu.addEventListener('click', function(event) {
            if (event.target.closest('a, button')) {
                setTopNavOpen(false);
            }
        });

        document.addEventListener('click', function(event) {
            if (topNavBtn.getAttribute('aria-expanded') !== 'true') return;
            if (topNavMobile.contains(event.target)) return;
            setTopNavOpen(false);
        });

        document.addEventListener('keydown', function(event) {
            if (event.key !== 'Escape') return;
            if (topNavBtn.getAttribute('aria-expanded') === 'true') {
                setTopNavOpen(false);
            }
        });
    }

    var fabRoot = document.getElementById('nm-fab');
    var fabMainBtn = document.getElementById('nm-fab-main');
    var fabMenu = document.getElementById('nm-fab-menu');
    if (fabRoot && fabMainBtn && fabMenu) {
        var setFabExpanded = function(expanded) {
            fabRoot.setAttribute('data-expanded', expanded ? 'true' : 'false');
            fabMainBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            fabMenu.hidden = !expanded;
        };

        fabMainBtn.addEventListener('click', function(event) {
            event.stopPropagation();
            var nextOpen = fabRoot.getAttribute('data-expanded') !== 'true';
            setFabExpanded(nextOpen);
        });

        fabMenu.addEventListener('click', function(event) {
            var actionBtn = event.target.closest('[data-fab-action]');
            if (!actionBtn) return;
            event.stopPropagation();
            setFabExpanded(false);
            var action = actionBtn.getAttribute('data-fab-action');
            if (action === 'add-signal') {
                openSignalSubmitForm();
                return;
            }
            if (action === 'add-favorite-point') {
                if (!window.RCN_USER && typeof window.openAuthModal === 'function') {
                    window.openAuthModal('login', {
                        pendingAction: function() {
                            openAddFavoritePoint();
                        }
                    });
                    return;
                }
                openAddFavoritePoint();
            }
        });

        document.addEventListener('click', function(event) {
            if (fabRoot.getAttribute('data-expanded') !== 'true') return;
            if (fabRoot.contains(event.target)) return;
            setFabExpanded(false);
        });

        document.addEventListener('keydown', function(event) {
            if (event.key !== 'Escape') return;
            if (fabRoot.getAttribute('data-expanded') === 'true') {
                setFabExpanded(false);
            }
        });
    }

    function openAddFavoritePoint() {
        var api = window.metroskopFavorites;
        if (!api || typeof api.openCommentModal !== 'function') return;
        api.openCommentModal({ entityType: 'punkt', entityId: null }, null);
    }

    if (panelToggleBtn) {
        panelToggleBtn.addEventListener('click', function() {
            panelLayout.togglePanelCollapse();
        });
    }

    if (shareBtn) {
        initMapShare({
            triggerEl: shareBtn,
            syncUrl: syncUrl,
            apiUrl: BASE_URL + 'rcn/api/map-share',
        });

        var shareMenuItem = document.getElementById('nm-share-menu-item');
        if (shareMenuItem) {
            shareMenuItem.addEventListener('click', function() {
                shareBtn.click();
            });
        }
    }

    if (geolocateBtn && navigator.geolocation) {
        geolocateBtn.addEventListener('click', function() {
            geolocateBtn.disabled = true;
            navigator.geolocation.getCurrentPosition(function(position) {
                geolocateBtn.disabled = false;
                map.flyTo({ center: [position.coords.longitude, position.coords.latitude], zoom: 17, duration: 800 });
            }, function() {
                geolocateBtn.disabled = false;
            }, { enableHighAccuracy: true, timeout: 8000 });
        });
    } else if (geolocateBtn) {
        geolocateBtn.style.display = 'none';
    }

    if (openFavoritesBtn && favListEl && favListBodyEl) {
        mountFavoritesList({
            triggerEl: openFavoritesBtn,
            listEl: favListEl,
            bodyEl: favListBodyEl,
            backdropEl: favListBackdropEl,
            controller: favoritesController,
        });
    }

    assetEls.forEach(function(el) {
        el.addEventListener('click', function() {
            var next = el.getAttribute('data-asset');
            if (next === currentAssetType) return;
            currentAssetType = next;
            applyFilterInputs();
            syncBucketUi();
            if (geoLayer) { clearGeoLayer(); }
            clearOverlapLayer();
            showMapLoading(true);
            clearSelection({ keepDetails: false, sync: false });
            refreshAll({ resetList: true });
        });
    });

    var bucketSelectEl = document.getElementById('nm-bucket-select');

    function setBucketUrlParam() {
        try {
            var url = new URL(location.href);
            if (currentBucket) { url.searchParams.set('bucket', currentBucket); }
            else { url.searchParams.delete('bucket'); }
            history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
    }

    // The property-type stats filter only applies to lokale (lokal sub-types); hide
    // it and drop any active bucket for działki/budynki.
    function syncBucketUi() {
        if (!bucketSelectEl) { return; }
        var show = currentAssetType === 'lokale';
        bucketSelectEl.hidden = !show;
        if (!show && currentBucket) {
            currentBucket = '';
            bucketSelectEl.value = '';
            setBucketUrlParam();
        }
    }

    if (bucketSelectEl) {
        if (currentBucket && currentAssetType !== 'lokale') {
            currentBucket = '';
            setBucketUrlParam();
        }
        bucketSelectEl.value = currentBucket;
        syncBucketUi();
        bucketSelectEl.addEventListener('change', function() {
            currentBucket = bucketSelectEl.value || '';
            setBucketUrlParam();
            if (geoLayer) { clearGeoLayer(); }
            clearOverlapLayer();
            showMapLoading(true);
            refreshAll({ resetList: true });
        });
    }

    document.addEventListener('click', function(event) {
        var scopeBtn = event.target.closest('[data-filter-scope]');
        if (!scopeBtn) {
            return;
        }
        setFilterScope(scopeBtn.getAttribute('data-filter-scope') || 'transactions');
    });

    document.addEventListener('click', function(event) {
        var tagBtn = event.target.closest('[data-listing-select-target]');
        if (!tagBtn) {
            return;
        }
        var input = document.getElementById(tagBtn.getAttribute('data-listing-select-target') || '');
        if (!input) {
            return;
        }
        input.value = tagBtn.getAttribute('data-listing-select-value') || '';
        readFilterInputs();
        if (input.id === 'nm-f-listing-category' || input.id === 'nm-f-listing-offer-type') {
            applyListingQuickFilterChange({ clearPending: true });
            return;
        }
        setFilterInputsPending(true);
        syncListingCategorySwitch();
        syncListingFilterTags();
        syncListingFilterVisibility();
        syncListingBrowseLink();
    });

    document.addEventListener('click', function(event) {
        if (event.target.closest('[data-transaction-active-clear]')) {
            clearTransactionAreaFilter();
            return;
        }
        var clearBtn = event.target.closest('[data-listing-active-clear]');
        if (!clearBtn) {
            return;
        }
        clearListingActiveFilter(clearBtn.getAttribute('data-listing-active-clear') || '');
    });

    var filtersPanelEl = document.getElementById('nm-panel-filters');
    if (filtersPanelEl) {
        filtersPanelEl.addEventListener('input', function(event) {
            if (event.target && event.target.closest('#nm-f-apply, #nm-f-reset')) {
                return;
            }
            setFilterInputsPending(true);
            if (event.target && event.target.closest('[data-filter-scope-section="listings"]')) {
                syncListingBrowseLink(readFilterInputsSnapshot());
            }
        });
        filtersPanelEl.addEventListener('change', function(event) {
            if (event.target && event.target.closest('#nm-f-apply, #nm-f-reset')) {
                return;
            }
            setFilterInputsPending(true);
            if (event.target && event.target.closest('[data-filter-scope-section="listings"]')) {
                syncListingBrowseLink(readFilterInputsSnapshot());
            }
        });
    }

    if (listingBrowseLinkEl) {
        listingBrowseLinkEl.addEventListener('click', function() {
            syncListingBrowseLink(readFilterInputsSnapshot());
        });
    }

    listingCategoryEls.forEach(function(el) {
        el.addEventListener('click', function() {
            setListingCategoryFilter(el.getAttribute('data-listing-category-filter') || '');
        });
    });

    if (listingCategoryMoreSelect) {
        listingCategoryMoreSelect.addEventListener('change', function() {
            if (listingCategoryMoreSelect.value) {
                setListingCategoryFilter(listingCategoryMoreSelect.value);
            }
        });
    }

    sortEls.forEach(function(el) {
        el.addEventListener('click', function() {
            var nextField = el.getAttribute('data-sort');
            if (nextField === sortField(currentSort)) {
                currentSort = currentSort.charAt(0) === '-' ? nextField : '-' + nextField;
            } else {
                currentSort = nextField;
            }
            applyFilterInputs();
            if (overlapBrowseFeatures) {
                renderOverlapBrowsePanel();
            } else {
                loadListPage(1, false);
            }
            syncUrl();
        });
    });

    listingSortEls.forEach(function(el) {
        el.addEventListener('click', function() {
            listingListSort = el.getAttribute('data-listing-sort') || 'newest';
            listingSortEls.forEach(function(chip) {
                chip.classList.toggle('is-active', chip === el);
            });
            if (ogloszeniaActive) {
                renderListPanel({ immediate: true });
            }
        });
    });

    if (listContentEl) {
        listContentEl.addEventListener('click', function(ev) {
            // Point cards have their own handler below; opening twice restarts
            // detail requests and can use a different location for the same hit.
            if (ev.target.closest('[data-point-hit-type]')) return;
            if (ev.target.closest('[data-info-popup], a[href]')) return;
            var card = ev.target.closest('[data-listing-card]');
            if (!card) {
                return;
            }
            var cardId = card.getAttribute('data-listing-card');
            var match = renderedListingFeatures.filter(function(feature) {
                return String((feature.properties || {}).id || '') === String(cardId);
            })[0];
            if (!match) {
                return;
            }
            var coords = match.geometry ? match.geometry.coordinates : null;
            selectListingHit(match.properties || {}, coords ? { lat: coords[1], lng: coords[0] } : null);
        });
        listContentEl.addEventListener('mouseenter', function() {
            // Desktop only — hover-to-pan does not apply to touch input.
            if (isDesktopLayout()) {
                listHoverLock = true;
                // Suppress the loading bar while hovering — it returns on exit.
                hideListLoadingIndicator();
            }
        });
        // Hover-to-map synchronisation was intentionally removed: easing the map
        // to whatever card the pointer happened to cross caused confusing jumps on
        // accidental hover. The list freeze below stays so a background map move
        // can't reshuffle the card the user is about to click.
        listContentEl.addEventListener('mouseleave', function() {
            resetListHoverHighlight();
            if (listHoverLock) {
                listHoverLock = false;
                if (listRenderDeferredWhileLocked) {
                    listRenderDeferredWhileLocked = false;
                    // Hover is over — now surface the loading bar and flush the
                    // refresh that was deferred while the list was frozen.
                    showListLoadingIndicator();
                    renderListPanel();
                }
            }
        });
    }

    if (listSubTabsEl) {
        listSubTabsEl.addEventListener('click', function(ev) {
            var btn = ev.target.closest('[data-list-subtab]');
            if (!btn) {
                return;
            }
            listSubTab = btn.getAttribute('data-list-subtab');
            renderListPanel({ immediate: true });
        });
    }

    if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', function() {
            beginFilterApplyLoading(activeFilterScope);
            readFilterInputs();
            setFilterInputsPending(false);
            syncListingCategorySwitch();
            enableLayerForActiveFilterScope();
            if (activeFilterScope === 'parcels' || activeFilterScope === 'buildings') {
                var egibScope = activeFilterScope;
                runEgibSearch(egibScope).finally(function() {
                    handleFilterApplyAuxSettled(egibScope);
                });
            }
            if (!fitMapToActiveLocationRadius()) {
                fitMapToSelectedWojewodztwo();
            }
            var dzialkiQuery = filterState.dzialka_id;
            if (dzialkiQuery && dzialkiQuery.length >= 2) {
                if (dzialkaIdHintEl) dzialkaIdHintEl.textContent = 'Szukam…';
                fetch(DZIALKI_SEARCH_URL + '?id_dzialki=' + encodeURIComponent(dzialkiQuery))
                    .then(function(r) { return r.json(); })
                    .then(function(data) {
                        var items = data.items || [];
                        if (items.length > 0) {
                            var hit = items[0];
                            if (dzialkaIdHintEl) dzialkaIdHintEl.textContent = items.length === 1
                                ? 'Znaleziono: ' + hit.id_dzialki
                                : 'Znaleziono ' + items.length + ' działek – pokazuję pierwszą: ' + hit.id_dzialki;
                            map.flyTo({ center: [hit.lng, hit.lat], zoom: Math.max(map.getZoom(), 17), duration: 800 });
                        } else {
                            if (dzialkaIdHintEl) dzialkaIdHintEl.textContent = 'Nie znaleziono działki o podanym identyfikatorze.';
                        }
                    })
                    .catch(function() {
                        if (dzialkaIdHintEl) dzialkaIdHintEl.textContent = 'Błąd wyszukiwania – spróbuj ponownie.';
                    });
            }
            if (geoLayer) { clearGeoLayer(); }
            clearOverlapLayer();
            showMapLoading(true);
            clearSelection({ keepDetails: false, sync: false });
            refreshAll({ resetList: true });
            setTab('filters', { snap: 'full' });
        });
    }

    if (resetFiltersBtn) {
        resetFiltersBtn.addEventListener('click', function() {
            filterState = createDefaultFilterState();
            applyFilterInputs();
            setFilterInputsPending(false);
            if (dzialkaIdInput) dzialkaIdInput.value = '';
            if (dzialkaIdHintEl) dzialkaIdHintEl.textContent = '';
            if (bdot10kImpactClassificationInput) bdot10kImpactClassificationInput.value = '';
            if (bdot10kNuisanceLevelInput) bdot10kNuisanceLevelInput.value = '';
            if (bdot10kUsefulnessLevelInput) bdot10kUsefulnessLevelInput.value = '';
            [
                parcelLocationQueryInput,
                parcelIdInput,
                parcelNumberInput,
                parcelAreaInput,
                parcelNeighbourNumbersInput,
                parcelNeighbourAreasInput,
                buildingLocationQueryInput,
                buildingIdInput,
                buildingFloorsAboveInput,
                buildingFloorsBelowInput,
            ].forEach(function(input) {
                if (input) input.value = '';
            });
            if (parcelNeighbourRadiusInput) parcelNeighbourRadiusInput.value = '20';
            if (parcelAreaToleranceInput) parcelAreaToleranceInput.value = '2';
            egibLocationReferences.parcels = null;
            egibLocationReferences.buildings = null;
            clearEgibMapBounds('parcels');
            clearEgibMapBounds('buildings');
            [parcelNeighbourNumbersInput, parcelNeighbourAreasInput].forEach(function(input) {
                if (input && input._tokenField) {
                    input._tokenField.clear();
                }
            });
            [parcelResultsEl, buildingResultsEl].forEach(function(resultsEl) {
                if (!resultsEl) return;
                resultsEl.hidden = true;
                resultsEl.innerHTML = '';
                resultsEl._items = [];
            });
            clearEgibSearchMarkers();
            clearSelection({ keepDetails: false, sync: false });
            refreshAll({ resetList: true });
            setTab('filters', { snap: 'full' });
        });
    }

    if (openNearbyBtn) {
        openNearbyBtn.addEventListener('click', function() {
            if (!selectedLatLng) return;
            loadNearbyForSelection(true);
        });
    }

    if (backToDetailsBtn) {
        backToDetailsBtn.addEventListener('click', function() {
            setTab('details', { snap: 'half' });
        });
    }

    if (personaBtn) {
        personaBtn.addEventListener('click', function() {
            if (!selectedLatLng || !personaModule) return;
            personaModule.toggle(selectedLatLng);
        });
        personaModule.syncButtonState();
    }

    if (listMoreBtn) {
        listMoreBtn.addEventListener('click', function() {
            if (!listHasMore || listLoading) return;
            loadListPage(listPage + 1, true);
        });
    }

    tabEls.forEach(function(el) {
        el.addEventListener('click', function() {
            var tab = el.getAttribute('data-tab');
            // Preserve current snap, but ensure at least 'half' and force 'full' for filters
            var snap = undefined;
            if (tab === 'filters') {
                snap = 'full';
            } else if (tab === 'nearby' || getCurrentSheetSnap() === 'peek') {
                snap = 'half';
            }
            setTab(tab, { snap: snap });
            if (tab === 'nearby' && selectedLatLng && !nearbyLoaded) loadNearbyForSelection(false);
        });
    });

    listContentEl.addEventListener('click', function(e) {
        if (e.target.closest('[data-listings-retry]')) {
            loadListings();
            return;
        }
        if (e.target.closest('[data-list-retry]')) {
            loadListPage(1, false);
            return;
        }
        if (e.target.closest('[data-developer-offers-retry]')) {
            loadDeveloperOffers();
            return;
        }
        if (e.target.closest('[data-point-back]')) {
            pointQuerySession.cancel();
            syncUrl();
            return;
        }
        var pointZoomTo = e.target.closest('[data-point-zoom-to]');
        if (pointZoomTo) {
            var zoomSession = pointQuerySession.get();
            if (!zoomSession) return;
            var zoomLatLng = zoomSession.latlng;
            // Crossing layer thresholds cancels the session, so query again once the map settles.
            map.once('moveend', function() { startPointQuery(zoomLatLng); });
            map.easeTo({
                center: [zoomLatLng.lng, zoomLatLng.lat],
                zoom: Number(pointZoomTo.getAttribute('data-point-zoom-to')),
                duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 700,
            });
            return;
        }
        var pointRetry = e.target.closest('[data-point-retry]');
        if (pointRetry) {
            // The alert holding the focused button is replaced: focus moves to its section's heading first.
            var slot = pointRetry.getAttribute('data-point-slot');
            var focusTarget = (slot && listContentEl.querySelector('h3[data-card-key="heading:' + slot + '"]')) || listTitleEl;
            if (focusTarget) {
                if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
                focusTarget.focus({ preventScroll: true });
            }
            pointQuerySession.retry(pointRetry.getAttribute('data-point-retry'));
            return;
        }
        var pointCard = e.target.closest('[data-point-hit-type]');
        if (pointCard) {
            if (e.target.closest('[data-info-popup], [data-favorite-toggle], a')) return;
            var session = pointQuerySession.get();
            var hit = session && session.hits.find(function(item) {
                return item.type === pointCard.getAttribute('data-point-hit-type') && String(item.id) === pointCard.getAttribute('data-point-hit-id');
            });
            if (hit) {
                if (hit.type === 'meshCoverage' || LAYER_POINT_TYPES.indexOf(hit.type) !== -1) return;
                pointQuerySession.cancel();
                if (hit.type === 'kowr') selectKowrFeature(hit.data, session.latlng);
                else if (hit.type === 'listing') selectListingHit(hit.properties, session.latlng);
                else interactiveHitDispatcher.openSingleHit(session.latlng, hit);
                meshDetailSelection = { key: meshSelectionKey(), point: { lat: session.latlng.lat, lng: session.latlng.lng } };
                if (syncMeshCoverageDetails) syncMeshCoverageDetails();
            }
            return;
        }
        if (e.target.closest('#nm-overlap-back')) {
            exitOverlapBrowse();
            return;
        }
        if (e.target.closest('#nm-tap-browse-back')) {
            exitTapBrowse();
            return;
        }
        if (e.target.closest('#nm-gunb-browse-back')) {
            exitGunbBrowse();
            return;
        }
        if (e.target.closest('#nm-combined-browse-back')) {
            exitCombinedBrowse();
            return;
        }
        var tapHitCard = e.target.closest('.nm-list-card[data-tap-hit-kind]');
        if (tapHitCard) {
            if (e.target.closest('[data-info-popup]')) return;
            resolveTapHitSelection(
                tapHitCard.getAttribute('data-tap-hit-kind'),
                tapHitCard.getAttribute('data-tap-hit-id'),
                tapBrowseManager.getTapBrowseLatlng() || combinedBrowseLatlng
            );
            return;
        }
        var signalCard = e.target.closest('.nm-list-card[data-signal-feature-index]');
        if (signalCard) {
            var signalIndex = parseInt(signalCard.getAttribute('data-signal-feature-index'), 10);
            var signalFeature = renderedSignalFeatures[signalIndex];
            if (signalFeature) {
                var signalCoords = signalFeature.geometry ? signalFeature.geometry.coordinates : null;
                selectSignalHit(
                    signalFeature.properties || {},
                    signalCoords ? { lat: signalCoords[1], lng: signalCoords[0] } : null,
                    signalCard.getAttribute('data-signal-id')
                );
            }
            return;
        }
        var gunbCard = e.target.closest('.nm-list-card[data-gunb-id]');
        if (gunbCard) {
            var gunbId = parseInt(gunbCard.getAttribute('data-gunb-id'), 10);
            var gunbSource = gunbBrowseFeatures || combinedBrowseGunb || renderedGunbFeatures;
            if (gunbSource) {
                var gFeature = gunbSource.find(function(f) {
                    return f.properties && String(f.properties.id) === String(gunbId);
                });
                if (gFeature) selectGunbPermit(gFeature);
            }
            return;
        }
        // Help triggers and the "Szczegóły" links inside a card keep their own action.
        if (e.target.closest('[data-info-popup], a[href]')) return;
        var investmentCard = e.target.closest('.nm-list-card[data-developer-investment-index]');
        if (investmentCard) {
            var investment = renderedDeveloperOfferFeatures[parseInt(investmentCard.getAttribute('data-developer-investment-index'), 10)];
            if (investment) {
                var investmentCoords = investment.geometry ? investment.geometry.coordinates : null;
                selectDeveloperInvestmentHit(investment.properties || {}, investmentCoords ? { lat: investmentCoords[1], lng: investmentCoords[0] } : null);
            }
            return;
        }
        var card = e.target.closest('.nm-list-card[data-tid]');
        if (!card) return;
        var tid = card.getAttribute('data-tid');
        if (combinedBrowseTransactions) {
            var cFeature = combinedBrowseTransactions.find(function(f) {
                return f.properties && f.properties.tran_lokalny_id_iip === tid;
            });
            if (cFeature) {
                selectTransactionByFeature(cFeature.properties, combinedBrowseLatlng);
            }
            return;
        }
        if (overlapBrowseFeatures) {
            var feature = overlapBrowseFeatures.find(function(f) {
                return f.properties && f.properties.tran_lokalny_id_iip === tid;
            });
            if (feature) {
                selectTransactionByFeature(feature.properties, overlapBrowseLatlng);
            }
            return;
        }
        // Pending responses may replace listRows while hover keeps the old DOM.
        var row = renderedTransactionRows.find(function(entry) { return entry.tran_lokalny_id_iip === tid; });
        if (row) selectTransactionByRow(row, true);
    });

    nearbyContentEl.addEventListener('click', function(e) {
        var card = e.target.closest('[data-nearby-index]');
        if (!card) return;
        var index = parseInt(card.getAttribute('data-nearby-index'), 10);
        if (!isNaN(index) && nearbyItems[index]) focusNearbyItem(nearbyItems[index]);
    });

    if (detailsContentEl) {
        detailsContentEl.addEventListener('click', function(e) {
            if (parcelMeasurementManager.handleDetailClick(e)) {
                return;
            }
            var openSignalSubmitTrigger = e.target.closest('[data-open-signal-submit-global]');
            if (openSignalSubmitTrigger) {
                e.preventDefault();
                openSignalSubmitForm();
                return;
            }

        });
        detailsContentEl.addEventListener('change', function(e) {
            parcelMeasurementManager.handleDetailChange(e);
        });
        detailsContentEl.addEventListener('input', function(e) {
            parcelMeasurementManager.handleDetailInput(e);
        });
    }

    panelScrollEls.forEach(function(el) {
        el.addEventListener('scroll', function() {
            maybeExpandSheetFromScroll(el);
        }, { passive: true });
    });

    if (selectionClearBtn) {
        selectionClearBtn.addEventListener('click', function() {
            runClearSelectionFromBanner();
        });
    }

    if (floatingClearBtn) {
        floatingClearBtn.addEventListener('click', function() {
            runClearSelectionFromBanner();
        });
    }

    if (selectionShowBtn) {
        selectionShowBtn.addEventListener('click', function() {
            if (selectedLatLng && map) {
                map.flyTo({ center: [selectedLatLng.lng, selectedLatLng.lat], zoom: Math.max(map.getZoom(), INDIVIDUAL_ZOOM_THRESHOLD), duration: 450, padding: getMapPaddingForPanel() });
                if (!isDesktopLayout() && getCurrentSheetSnap() === 'full') {
                    setSheetSnap('half');
                }
            }
        });
    }

    window.addEventListener('resize', function() {
        syncLayoutMode();
        setSheetSnap(getCurrentSheetSnap());
        updateParcelLabels();
        scheduleMapRefresh();
    });
})();
